export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string }
    String: { input: string; output: string }
    Boolean: { input: boolean; output: boolean }
    Int: { input: number; output: number }
    Float: { input: number; output: number }
    DateTime: { input: string; output: string }
    NonEmptyString: { input: unknown; output: unknown }
    SecureRichText: { input: string; output: string }
    /**
     * The `Upload` special type represents a file to be uploaded in the same HTTP request as specified by
     * [graphql-multipart-request-spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
     */
    Upload: { input: unknown; output: unknown }
}

export type AcceptGroupInvitationPayload = {
    __typename: 'AcceptGroupInvitationPayload'
    group: Maybe<Group>
}

export type AcceptMembershipRequestPayload = {
    __typename: 'AcceptMembershipRequestPayload'
    group: Maybe<Group>
}

export type AccessId = {
    __typename: 'AccessId'
    description: Scalars['String']['output']
    id: Scalars['Int']['output']
}

export type AccessItem = {
    grant: AccessItemGrant
    guid: Maybe<Scalars['String']['output']>
    type: AccessItemType
}

export enum AccessItemGrant {
    Read = 'read',
    ReadWrite = 'readWrite',
}

export type AccessItemGroup = AccessItem & {
    __typename: 'AccessItemGroup'
    grant: AccessItemGrant
    group: Maybe<Group>
    guid: Maybe<Scalars['String']['output']>
    type: AccessItemType
}

export type AccessItemInput = {
    grant: AccessItemGrant
    guid?: InputMaybe<Scalars['String']['input']>
    type: AccessItemType
}

export type AccessItemSubGroup = AccessItem & {
    __typename: 'AccessItemSubGroup'
    grant: AccessItemGrant
    guid: Maybe<Scalars['String']['output']>
    subGroup: Maybe<Subgroup>
    type: AccessItemType
}

export enum AccessItemType {
    Group = 'group',
    LoggedIn = 'loggedIn',
    Public = 'public',
    SubGroup = 'subGroup',
    User = 'user',
}

export type AccessItemUser = AccessItem & {
    __typename: 'AccessItemUser'
    grant: AccessItemGrant
    guid: Maybe<Scalars['String']['output']>
    type: AccessItemType
    user: Maybe<User>
}

export type AccessRequestEmail = {
    __typename: 'AccessRequestEmail'
    enabled: Maybe<Scalars['Boolean']['output']>
    frequency: Maybe<AccessRequestFrequency>
}

export enum AccessRequestFrequency {
    Direct = 'direct',
    OncePerDay = 'oncePerDay',
}

export type Activity = {
    __typename: 'Activity'
    entity: Entity
    guid: Scalars['String']['output']
    type: ActivityType
}

export type ActivityFilter = {
    __typename: 'ActivityFilter'
    contentTypes: Array<Maybe<KeyValueItem>>
}

export type ActivityList = {
    __typename: 'ActivityList'
    edges: Maybe<Array<Maybe<Activity>>>
    total: Scalars['Int']['output']
}

export enum ActivityType {
    Create = 'create',
    Update = 'update',
}

export type AddAttachmentPayload = {
    __typename: 'AddAttachmentPayload'
    attachment: Maybe<Attachment>
}

export type AddChatMessagePayload = {
    __typename: 'AddChatMessagePayload'
    chatMessage: Maybe<ChatMessage>
}

export type AddChatPayload = {
    __typename: 'AddChatPayload'
    chat: Maybe<Chat>
}

export type AddColophonFieldInput = {
    label?: InputMaybe<Scalars['String']['input']>
}

export type AddCommentWithoutAccountPayload = {
    __typename: 'AddCommentWithoutAccountPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type AddDatahubContentSourceInput = {
    apiUrl: Scalars['String']['input']
    batchSize?: InputMaybe<Scalars['Int']['input']>
    frontendUrl: Scalars['String']['input']
    name: Scalars['String']['input']
    pluralName: Scalars['String']['input']
}

export type AddEntityPayload = {
    __typename: 'AddEntityPayload'
    entity: Maybe<Entity>
    fields: Maybe<Array<Maybe<EntityFormResponseFeedback>>>
    success: Maybe<Scalars['Boolean']['output']>
}

export type AddGroupPayload = {
    __typename: 'AddGroupPayload'
    group: Maybe<Group>
}

export type AddIntelligentSearchInput = {
    numberOfAnswers?: InputMaybe<Scalars['Int']['input']>
    query: Scalars['String']['input']
}

export type AddPadPayload = {
    __typename: 'AddPadPayload'
    entity: Maybe<Pad>
    success: Maybe<Scalars['Boolean']['output']>
}

export type AddSiteSettingProfileFieldPayload = {
    __typename: 'AddSiteSettingProfileFieldPayload'
    profileItem: Maybe<ProfileItem>
}

export type AddSiteSettingProfileFieldValidatorPayload = {
    __typename: 'AddSiteSettingProfileFieldValidatorPayload'
    profileFieldValidator: Maybe<ProfileFieldValidator>
}

export type AddSubgroupPayload = {
    __typename: 'AddSubgroupPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type AddUserContactInput = {
    userGuid: Scalars['String']['input']
}

export type AddUserContactPayload = {
    __typename: 'AddUserContactPayload'
    success: Maybe<Scalars['Boolean']['output']>
    user: Maybe<User>
}

export type AddWebPushSubscriptionPayload = {
    __typename: 'AddWebPushSubscriptionPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export enum AdminAccessPermission {
    AccessAdmin = 'accessAdmin',
    AccessRequestManagement = 'accessRequestManagement',
    ContentManagement = 'contentManagement',
    FullControl = 'fullControl',
    PublicationRequestManagement = 'publicationRequestManagement',
    UserManagement = 'userManagement',
}

export type AppVersion = {
    __typename: 'AppVersion'
    buildDate: Maybe<Scalars['String']['output']>
    commit: Maybe<Scalars['String']['output']>
    /** Release version, or the commit SHA when the build was not a release, or 'dev' locally. */
    version: Scalars['String']['output']
}

export type AppointmentAgenda = {
    __typename: 'AppointmentAgenda'
    id: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
}

export type AppointmentAttendeeInput = {
    email: Scalars['String']['input']
    firstName: Scalars['String']['input']
    lastName: Scalars['String']['input']
    phone?: InputMaybe<Scalars['String']['input']>
}

export type AppointmentDataPayload = {
    __typename: 'AppointmentDataPayload'
    agendas: Maybe<Array<Maybe<AppointmentAgenda>>>
    appointmentTypes: Maybe<Array<Maybe<AppointmentType>>>
}

export type AppointmentTime = {
    __typename: 'AppointmentTime'
    endDateTime: Maybe<Scalars['DateTime']['output']>
    startDateTime: Maybe<Scalars['DateTime']['output']>
}

export type AppointmentTimes = {
    __typename: 'AppointmentTimes'
    day: Maybe<Scalars['DateTime']['output']>
    times: Maybe<Array<Maybe<AppointmentTime>>>
}

export type AppointmentType = {
    __typename: 'AppointmentType'
    hasVideocall: Maybe<Scalars['Boolean']['output']>
    id: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
}

export type AppointmentTypeInput = {
    hasVideocall?: InputMaybe<Scalars['Boolean']['input']>
    id?: InputMaybe<Scalars['String']['input']>
}

export type ArchiveEntitiesPayload = {
    __typename: 'ArchiveEntitiesPayload'
    edges: Maybe<Array<Maybe<Entity>>>
}

export type ArchiveEntityPayload = {
    __typename: 'ArchiveEntityPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type Attachment = {
    __typename: 'Attachment'
    dimension: Maybe<ImageDimension>
    downloadUrl: Maybe<Scalars['String']['output']>
    id: Maybe<Scalars['String']['output']>
    mimeType: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
}

export type AttendEventPayload = {
    __typename: 'AttendEventPayload'
    entity: Maybe<Event>
    fields: Maybe<Array<Maybe<EntityFormResponseFeedback>>>
    success: Maybe<Scalars['Boolean']['output']>
}

export type AttendEventWithoutAccountPayload = {
    __typename: 'AttendEventWithoutAccountPayload'
    entity: Maybe<Event>
}

export type Attendee = {
    __typename: 'Attendee'
    email: Scalars['String']['output']
    formResponse: Maybe<Array<Maybe<EntityFormResponse>>>
    guid: Scalars['String']['output']
    icon: Maybe<Scalars['String']['output']>
    isAttendingSubEvents: Maybe<Scalars['Boolean']['output']>
    isInvited: Maybe<Scalars['Boolean']['output']>
    name: Maybe<Scalars['String']['output']>
    state: Scalars['String']['output']
    timeCheckedIn: Maybe<Scalars['DateTime']['output']>
    url: Maybe<Scalars['String']['output']>
}

export enum AttendeeOrderBy {
    Email = 'email',
    Name = 'name',
    TimeCheckedIn = 'timeCheckedIn',
    TimeUpdated = 'timeUpdated',
}

export enum AttendeeRequestOrderBy {
    Email = 'email',
    Name = 'name',
    TimeCreated = 'timeCreated',
}

export type AttendeesList = {
    __typename: 'AttendeesList'
    edges: Maybe<Array<Maybe<Attendee>>>
    total: Maybe<Scalars['Int']['output']>
    totalAccept: Maybe<Scalars['Int']['output']>
    totalAcceptNotCheckedIn: Maybe<Scalars['Int']['output']>
    totalCheckedIn: Maybe<Scalars['Int']['output']>
    totalMaybe: Maybe<Scalars['Int']['output']>
    totalOnline: Maybe<Scalars['Int']['output']>
    totalReject: Maybe<Scalars['Int']['output']>
    totalUnconfirmed: Maybe<Scalars['Int']['output']>
    totalWaitinglist: Maybe<Scalars['Int']['output']>
    totalWaitinglistNotCheckedIn: Maybe<Scalars['Int']['output']>
}

export type AutoMembershipField = {
    __typename: 'AutoMembershipField'
    field: Maybe<ProfileItem>
    value: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type AutoMembershipFieldInput = {
    guid?: InputMaybe<Scalars['String']['input']>
    value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type Blog = Entity & {
    __typename: 'Blog'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    backgroundColor: Maybe<Scalars['String']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    canVote: Maybe<Scalars['Boolean']['output']>
    commentCount: Maybe<Scalars['Int']['output']>
    comments: Maybe<Array<Maybe<Comment>>>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    featured: Maybe<Featured>
    flowAttachments: Maybe<Array<Maybe<File>>>
    followers: Maybe<FollowersList>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasVoted: Maybe<Scalars['Int']['output']>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isFollowing: Maybe<Scalars['Boolean']['output']>
    isHighlighted: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommended: Maybe<Scalars['Boolean']['output']>
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localAbstract: Maybe<Scalars['String']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    publishRequest: Maybe<PublishRequest>
    revision: Maybe<Revision>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    suggestedItems: Maybe<Array<Maybe<Entity>>>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    votes: Maybe<Scalars['Int']['output']>
    votingUsers: Maybe<UserList>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type BlogCommentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type BlogFollowersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
}

export type BlogVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type BrokenLink = {
    __typename: 'BrokenLink'
    id: Scalars['Int']['output']
    reason: BrokenLinkReason
    source: Scalars['String']['output']
    target: Scalars['String']['output']
}

export type BrokenLinkList = {
    __typename: 'BrokenLinkList'
    edges: Maybe<Array<Maybe<BrokenLink>>>
    total: Scalars['Int']['output']
}

export enum BrokenLinkReason {
    Archived = 'archived',
    DoesNotExist = 'doesNotExist',
    Draft = 'draft',
    SourceMorePrivileges = 'sourceMorePrivileges',
}

export type ChangeGroupOwnerPayload = {
    __typename: 'ChangeGroupOwnerPayload'
    group: Maybe<Group>
}

export type Chat = {
    __typename: 'Chat'
    container: ChatContainer
    guid: Scalars['String']['output']
    isNotificationPushEnabled: Maybe<Scalars['Boolean']['output']>
    messages: Maybe<ChatMessageList>
    type: ChatType
    unread: Scalars['Int']['output']
    videoCallToken: Maybe<Scalars['String']['output']>
}

export type ChatMessagesArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type ChatContainer = {
    __typename: 'ChatContainer'
    group: Maybe<Group>
    message: Maybe<ChatMessage>
    users: Maybe<Array<Maybe<User>>>
}

export type ChatList = {
    __typename: 'ChatList'
    edges: Maybe<Array<Maybe<Chat>>>
    total: Scalars['Int']['output']
    totalUnread: Scalars['Int']['output']
}

export type ChatMessage = Entity & {
    __typename: 'ChatMessage'
    canEdit: Scalars['Boolean']['output']
    chat: Maybe<Chat>
    guid: Scalars['String']['output']
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    reactions: Maybe<Array<Maybe<ChatReaction>>>
    replyCount: Scalars['Int']['output']
    richDescription: Scalars['SecureRichText']['output']
    sender: User
    status: Maybe<Scalars['Int']['output']>
    timeCreated: Scalars['DateTime']['output']
}

export type ChatMessageList = {
    __typename: 'ChatMessageList'
    edges: Maybe<Array<Maybe<ChatMessage>>>
    total: Scalars['Int']['output']
}

export type ChatReaction = {
    __typename: 'ChatReaction'
    count: Scalars['Int']['output']
    unicode: Scalars['String']['output']
    users: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export enum ChatType {
    Group = 'group',
    Message = 'message',
    User = 'user',
}

export enum ChatTypeFilter {
    Group = 'group',
    User = 'user',
}

export type ChatUpdate = {
    __typename: 'ChatUpdate'
    action: ChatUpdateAction
    guid: Scalars['String']['output']
    message: Maybe<ChatMessage>
}

export enum ChatUpdateAction {
    Add = 'add',
    Delete = 'delete',
    Edit = 'edit',
}

export type ChatsUpdate = {
    __typename: 'ChatsUpdate'
    action: ChatsUpdateAction
    guid: Scalars['String']['output']
}

export enum ChatsUpdateAction {
    Refetch = 'refetch',
}

export type ColophonField = {
    __typename: 'ColophonField'
    key: Maybe<Scalars['String']['output']>
    label: Maybe<Scalars['String']['output']>
}

export type ColophonFieldInput = {
    key?: InputMaybe<Scalars['String']['input']>
    label?: InputMaybe<Scalars['String']['input']>
}

export type ColophonValue = {
    __typename: 'ColophonValue'
    key: Maybe<Scalars['String']['output']>
    label: Maybe<Scalars['String']['output']>
    value: Maybe<Scalars['String']['output']>
}

export type ColophonValueInput = {
    key?: InputMaybe<Scalars['String']['input']>
    value?: InputMaybe<Scalars['String']['input']>
}

export type Column = {
    __typename: 'Column'
    widgets: Maybe<Array<Maybe<Widget>>>
    width: Maybe<Array<Maybe<Scalars['Int']['output']>>>
}

export type Comment = Entity & {
    __typename: 'Comment'
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canVote: Maybe<Scalars['Boolean']['output']>
    commentCount: Maybe<Scalars['Int']['output']>
    comments: Maybe<Array<Maybe<Comment>>>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    guid: Scalars['String']['output']
    hasVoted: Maybe<Scalars['Int']['output']>
    isBestAnswer: Maybe<Scalars['Boolean']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    ownerName: Maybe<Scalars['String']['output']>
    pendingModeration: Maybe<Scalars['Boolean']['output']>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    status: Maybe<Scalars['Int']['output']>
    subtype: Maybe<Scalars['String']['output']>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    votes: Maybe<Scalars['Int']['output']>
    votingUsers: Maybe<UserList>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type CommentVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type CommentModerationMutationPayload = {
    __typename: 'CommentModerationMutationPayload'
    node: Maybe<CommentModerationRequest>
    success: Maybe<Scalars['Boolean']['output']>
}

export type CommentModerationRequest = {
    __typename: 'CommentModerationRequest'
    assignedTo: Maybe<User>
    comments: Maybe<Array<Maybe<Comment>>>
    entity: Maybe<Entity>
    guid: Maybe<Scalars['String']['output']>
    status: Maybe<CommentModerationStatusEnum>
}

export type CommentModerationRequestsPayload = {
    __typename: 'CommentModerationRequestsPayload'
    edges: Maybe<Array<Maybe<CommentModerationRequest>>>
    total: Maybe<Scalars['Int']['output']>
}

export enum CommentModerationStatusEnum {
    Assigned = 'assigned',
    Closed = 'closed',
    Open = 'open',
}

export type CommentProcessMutationPayload = {
    __typename: 'CommentProcessMutationPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type ContentAllowedTagCategory = {
    __typename: 'ContentAllowedTagCategory'
    contentType: Scalars['String']['output']
    showAllTagCategories: Maybe<Scalars['Boolean']['output']>
    showTagCategories: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type ContentAllowedTagCategoryInput = {
    contentType: Scalars['String']['input']
    showAllTagCategories?: InputMaybe<Scalars['Boolean']['input']>
    showTagCategories?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
}

export type ContentSnapshotPayload = {
    __typename: 'ContentSnapshotPayload'
    edges: Maybe<Array<Maybe<File>>>
    success: Maybe<Scalars['Boolean']['output']>
}

export type ContentVersion = {
    __typename: 'ContentVersion'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    featured: Maybe<Featured>
    formFields: Maybe<Array<Maybe<EntityFormField>>>
    formResponse: Maybe<Array<Maybe<EntityFormResponse>>>
    group: Maybe<Group>
    inputLanguage: Maybe<Scalars['String']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isRecommended: Maybe<Scalars['Boolean']['output']>
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    owner: Maybe<User>
    parent: Maybe<Entity>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    rows: Maybe<Array<Maybe<Row>>>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    source: Maybe<Scalars['String']['output']>
    suggestedItems: Maybe<Array<Maybe<Entity>>>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type CooldownContentItem = {
    __typename: 'CooldownContentItem'
    group: Maybe<Scalars['String']['output']>
    guid: Maybe<Scalars['String']['output']>
    isDeletable: Maybe<Scalars['Boolean']['output']>
    scheduleDeleteAfter: Maybe<Scalars['DateTime']['output']>
    subtype: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type CooldownContentList = {
    __typename: 'CooldownContentList'
    edges: Maybe<Array<Maybe<CooldownContentItem>>>
    total: Scalars['Int']['output']
}

export type CopyEntityPayload = {
    __typename: 'CopyEntityPayload'
    entity: Maybe<Entity>
}

export type CustomContentAllowedTagCategory = {
    __typename: 'CustomContentAllowedTagCategory'
    showAllTagCategories: Maybe<Scalars['Boolean']['output']>
    showTagCategories: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type CustomContentAllowedTagCategoryInput = {
    showAllTagCategories?: InputMaybe<Scalars['Boolean']['input']>
    showTagCategories?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
}

export type CustomContentType = {
    __typename: 'CustomContentType'
    allowedTagCategories: Maybe<CustomContentAllowedTagCategory>
    contentHelpText: Maybe<Scalars['String']['output']>
    detailViewTemplateIds: Maybe<Array<Maybe<Scalars['String']['output']>>>
    formFields: Maybe<Array<Maybe<EntityFormField>>>
    hasFeaturedImage: Maybe<Scalars['Boolean']['output']>
    hasRevisions: Maybe<Scalars['Boolean']['output']>
    hasSchedulePublishArchiveDelete: Maybe<Scalars['Boolean']['output']>
    key: Maybe<Scalars['String']['output']>
    listViewTemplateIds: Maybe<Array<Maybe<Scalars['String']['output']>>>
    localContentHelpText: Maybe<Scalars['String']['output']>
    localName: Maybe<Scalars['String']['output']>
    localNamePlural: Maybe<Scalars['String']['output']>
    localTitleHelpText: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    namePlural: Maybe<Scalars['String']['output']>
    slug: Maybe<Scalars['String']['output']>
    titleHelpText: Maybe<Scalars['String']['output']>
    translations: Maybe<Array<Maybe<TranslationSet>>>
}

export type CustomContentTypeInput = {
    allowedTagCategories?: InputMaybe<CustomContentAllowedTagCategoryInput>
    contentHelpText?: InputMaybe<Scalars['String']['input']>
    detailViewTemplateIds?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    formFields?: InputMaybe<Array<InputMaybe<EntityFormFieldInput>>>
    hasFeaturedImage?: InputMaybe<Scalars['Boolean']['input']>
    hasRevisions?: InputMaybe<Scalars['Boolean']['input']>
    hasSchedulePublishArchiveDelete?: InputMaybe<Scalars['Boolean']['input']>
    key?: InputMaybe<Scalars['String']['input']>
    listViewTemplateIds?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    name?: InputMaybe<Scalars['String']['input']>
    namePlural?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    titleHelpText?: InputMaybe<Scalars['String']['input']>
    translations?: InputMaybe<Array<InputMaybe<TranslationSetInput>>>
}

export type CustomContentTypePayload = {
    __typename: 'CustomContentTypePayload'
    node: Maybe<CustomContentType>
    success: Maybe<Scalars['Boolean']['output']>
}

export type DatahubContentSource = ExternalContentSource & {
    __typename: 'DatahubContentSource'
    apiUrl: Maybe<Scalars['String']['output']>
    batchSize: Maybe<Scalars['Int']['output']>
    frontendUrl: Maybe<Scalars['String']['output']>
    handlerId: Maybe<ExternalContentSourceHandlerEnum>
    key: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    pluralName: Maybe<Scalars['String']['output']>
}

export type DefaultAccessItem = AccessItem & {
    __typename: 'DefaultAccessItem'
    grant: AccessItemGrant
    guid: Maybe<Scalars['String']['output']>
    type: AccessItemType
}

export type DefaultExternalContentSource = ExternalContentSource & {
    __typename: 'DefaultExternalContentSource'
    handlerId: Maybe<ExternalContentSourceHandlerEnum>
    key: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    pluralName: Maybe<Scalars['String']['output']>
}

export type DeleteAccountRequestList = {
    __typename: 'DeleteAccountRequestList'
    edges: Maybe<Array<Maybe<User>>>
    fieldsInAdminOverview: Maybe<Array<Maybe<ProfileItem>>>
    total: Scalars['Int']['output']
}

export type DeleteChatMessagePayload = {
    __typename: 'DeleteChatMessagePayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type DeleteCustomContentTypePayload = {
    __typename: 'DeleteCustomContentTypePayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type DeleteEntitiesPayload = {
    __typename: 'DeleteEntitiesPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type DeleteEntityPayload = {
    __typename: 'DeleteEntityPayload'
    errors: Maybe<Array<Maybe<FileDeleteError>>>
    success: Maybe<Scalars['Boolean']['output']>
}

export type DeleteEventAttendeesPayload = {
    __typename: 'DeleteEventAttendeesPayload'
    entity: Maybe<Event>
}

export type DeleteGroupInvitationPayload = {
    __typename: 'DeleteGroupInvitationPayload'
    group: Maybe<Group>
}

export type DeleteSiteSettingProfileFieldPayload = {
    __typename: 'DeleteSiteSettingProfileFieldPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type DeleteSiteSettingProfileFieldValidatorPayload = {
    __typename: 'DeleteSiteSettingProfileFieldValidatorPayload'
    success: Scalars['Boolean']['output']
}

export type DeleteSubgroupPayload = {
    __typename: 'DeleteSubgroupPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type DeleteTagCollectionpPayload = {
    __typename: 'DeleteTagCollectionpPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type DeleteUsersPayload = {
    __typename: 'DeleteUsersPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type DirectLink = {
    __typename: 'DirectLink'
    link: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type DirectLinkInput = {
    link: Scalars['String']['input']
    title: Scalars['String']['input']
}

export type Discussion = Entity & {
    __typename: 'Discussion'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    canVote: Maybe<Scalars['Boolean']['output']>
    commentCount: Maybe<Scalars['Int']['output']>
    comments: Maybe<Array<Maybe<Comment>>>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    featured: Maybe<Featured>
    flowAttachments: Maybe<Array<Maybe<File>>>
    followers: Maybe<FollowersList>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasVoted: Maybe<Scalars['Int']['output']>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isFollowing: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localAbstract: Maybe<Scalars['String']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    publishRequest: Maybe<PublishRequest>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    suggestedItems: Maybe<Array<Maybe<Entity>>>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    votes: Maybe<Scalars['Int']['output']>
    votingUsers: Maybe<UserList>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type DiscussionCommentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type DiscussionFollowersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
}

export type DiscussionVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type DocumentChatMessage = {
    __typename: 'DocumentChatMessage'
    answer: Maybe<Scalars['String']['output']>
    conversationId: Maybe<Scalars['String']['output']>
    feedback: Maybe<Scalars['String']['output']>
    sources: Maybe<Array<Maybe<SourceDocument>>>
    uuid: Maybe<Scalars['String']['output']>
}

export type DocumentChatPayload = {
    __typename: 'DocumentChatPayload'
    node: Maybe<DocumentChatMessage>
    success: Maybe<Scalars['Boolean']['output']>
}

export type DownloadAsOption = {
    __typename: 'DownloadAsOption'
    type: Scalars['String']['output']
    url: Scalars['String']['output']
}

export type EditAvatarPayload = {
    __typename: 'EditAvatarPayload'
    user: Maybe<User>
}

export type EditChatMessagePayload = {
    __typename: 'EditChatMessagePayload'
    chatMessage: Maybe<ChatMessage>
}

export type EditChatPayload = {
    __typename: 'EditChatPayload'
    chat: Maybe<Chat>
}

export type EditEmailAccessRequestInput = {
    enabled?: InputMaybe<Scalars['Boolean']['input']>
    frequency?: InputMaybe<AccessRequestFrequency>
    guid: Scalars['String']['input']
}

export type EditEmailAccessRequestPayload = {
    __typename: 'EditEmailAccessRequestPayload'
    user: Maybe<User>
}

export type EditEmailOverviewPayload = {
    __typename: 'EditEmailOverviewPayload'
    user: Maybe<User>
}

export type EditEntityBulkPayload = {
    __typename: 'EditEntityBulkPayload'
    edges: Maybe<Array<Maybe<Entity>>>
    success: Maybe<Scalars['Boolean']['output']>
}

export type EditEntityPayload = {
    __typename: 'EditEntityPayload'
    entity: Maybe<Entity>
    fields: Maybe<Array<Maybe<EntityFormResponseFeedback>>>
    success: Maybe<Scalars['Boolean']['output']>
}

export type EditEventAttendeePayload = {
    __typename: 'EditEventAttendeePayload'
    entity: Maybe<Event>
}

export type EditFileFolderPayload = {
    __typename: 'EditFileFolderPayload'
    entity: Maybe<FileFolder>
}

export type EditFileVersionCommentInput = {
    guid: Scalars['String']['input']
    versionComment: Scalars['String']['input']
}

export type EditFileVersionCommentPayload = {
    __typename: 'EditFileVersionCommentPayload'
    success: Scalars['Boolean']['output']
    version: FileVersion
}

export type EditGroupNotificationsPayload = {
    __typename: 'EditGroupNotificationsPayload'
    group: Maybe<Group>
}

export type EditGroupPayload = {
    __typename: 'EditGroupPayload'
    group: Maybe<Group>
}

export type EditNotificationsPayload = {
    __typename: 'EditNotificationsPayload'
    user: Maybe<User>
}

export type EditPadPayload = {
    __typename: 'EditPadPayload'
    entity: Maybe<Pad>
    success: Maybe<Scalars['Boolean']['output']>
}

export type EditProfileFieldPayload = {
    __typename: 'EditProfileFieldPayload'
    fields: Maybe<Array<Maybe<ProfileFieldResponse>>>
    success: Maybe<Scalars['Boolean']['output']>
    user: Maybe<User>
}

export type EditSiteSettingPayload = {
    __typename: 'EditSiteSettingPayload'
    siteSettings: Maybe<SiteSettings>
}

export type EditSiteSettingProfileFieldPayload = {
    __typename: 'EditSiteSettingProfileFieldPayload'
    profileItem: Maybe<ProfileItem>
}

export type EditSiteSettingProfileFieldValidatorPayload = {
    __typename: 'EditSiteSettingProfileFieldValidatorPayload'
    profileFieldValidator: Maybe<ProfileFieldValidator>
}

export type EditSubgroupPayload = {
    __typename: 'EditSubgroupPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type EditTagCollectionPayload = {
    __typename: 'EditTagCollectionPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type EditTaskPayload = {
    __typename: 'EditTaskPayload'
    entity: Maybe<Task>
}

export type EditUserNamePayload = {
    __typename: 'EditUserNamePayload'
    user: Maybe<User>
}

export type EditUsersPayload = {
    __typename: 'EditUsersPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type EmailOverview = {
    __typename: 'EmailOverview'
    enabled: Maybe<Scalars['Boolean']['output']>
    frequency: Maybe<Frequency>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type Entity = {
    guid: Scalars['String']['output']
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    status: Maybe<Scalars['Int']['output']>
}

export type EntityFilter = {
    __typename: 'EntityFilter'
    contentTypes: Maybe<Array<Maybe<KeyValueItem>>>
}

export type EntityForm = {
    __typename: 'EntityForm'
    description: Maybe<Scalars['String']['output']>
    formFields: Maybe<Array<Maybe<EntityFormField>>>
    title: Maybe<Scalars['String']['output']>
}

export type EntityFormField = {
    __typename: 'EntityFormField'
    description: Maybe<Scalars['String']['output']>
    fieldOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>
    fieldType: Maybe<EntityFormFieldTypeEnum>
    guid: Scalars['String']['output']
    isMandatory: Maybe<Scalars['Boolean']['output']>
    title: Scalars['String']['output']
}

export type EntityFormFieldInput = {
    description?: InputMaybe<Scalars['String']['input']>
    fieldOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldType?: InputMaybe<EntityFormFieldTypeEnum>
    guid?: InputMaybe<Scalars['String']['input']>
    isMandatory?: InputMaybe<Scalars['Boolean']['input']>
    title?: InputMaybe<Scalars['String']['input']>
}

export enum EntityFormFieldTypeEnum {
    CheckboxField = 'checkboxField',
    DateField = 'dateField',
    DateTimeField = 'dateTimeField',
    HtmlField = 'htmlField',
    MultiLineTextField = 'multiLineTextField',
    MultiSelectField = 'multiSelectField',
    RadioField = 'radioField',
    RichDescriptionPlaceholderField = 'richDescriptionPlaceholderField',
    SelectField = 'selectField',
    TextField = 'textField',
    TitlePlaceholderField = 'titlePlaceholderField',
}

export type EntityFormInput = {
    description?: InputMaybe<Scalars['String']['input']>
    formFields?: InputMaybe<Array<InputMaybe<EntityFormFieldInput>>>
    title: Scalars['String']['input']
}

export type EntityFormResponse = {
    __typename: 'EntityFormResponse'
    field: Maybe<EntityFormField>
    guid: Maybe<Scalars['String']['output']>
    value: Maybe<Scalars['String']['output']>
}

export type EntityFormResponseFeedback = {
    __typename: 'EntityFormResponseFeedback'
    guid: Maybe<Scalars['String']['output']>
    message: Maybe<Scalars['String']['output']>
}

export type EntityFormResponseInput = {
    guid?: InputMaybe<Scalars['String']['input']>
    value?: InputMaybe<Scalars['String']['input']>
}

export type EntityList = {
    __typename: 'EntityList'
    edges: Maybe<Array<Maybe<Entity>>>
    total: Scalars['Int']['output']
}

export type EntitySlugSuggestionPayload = {
    __typename: 'EntitySlugSuggestionPayload'
    available: Scalars['Boolean']['output']
    suggestion: Maybe<Scalars['String']['output']>
}

export type Episode = Entity & {
    __typename: 'Episode'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    description: Maybe<Scalars['String']['output']>
    edges: Maybe<Array<Maybe<Entity>>>
    excerpt: Maybe<Scalars['String']['output']>
    file: Maybe<FileFolder>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localAbstract: Maybe<Scalars['String']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    podcast: Maybe<Podcast>
    publishRequest: Maybe<PublishRequest>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    suggestedItems: Maybe<Array<Maybe<Entity>>>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    total: Maybe<Scalars['Int']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type EpisodeList = {
    __typename: 'EpisodeList'
    edges: Maybe<Array<Maybe<Episode>>>
    total: Scalars['Int']['output']
}

export type EpisodePayload = {
    __typename: 'EpisodePayload'
    episode: Maybe<Episode>
    success: Maybe<Scalars['Boolean']['output']>
}

export type Event = Entity & {
    __typename: 'Event'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    alreadySignedUpInSlot: Maybe<Scalars['Boolean']['output']>
    attendEventOnline: Maybe<Scalars['Boolean']['output']>
    attendEventWithoutAccount: Maybe<Scalars['Boolean']['output']>
    attendeeWelcomeMailContent: Maybe<Scalars['SecureRichText']['output']>
    attendeeWelcomeMailSubject: Maybe<Scalars['String']['output']>
    attendees: Maybe<AttendeesList>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canAttendWithEmail: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    canVote: Maybe<Scalars['Boolean']['output']>
    children: Maybe<Array<Maybe<Event>>>
    commentCount: Maybe<Scalars['Int']['output']>
    comments: Maybe<Array<Maybe<Comment>>>
    description: Maybe<Scalars['String']['output']>
    enableMaybeAttendEvent: Maybe<Scalars['Boolean']['output']>
    endDate: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    featured: Maybe<Featured>
    form: Maybe<EntityForm>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasChildren: Maybe<Scalars['Boolean']['output']>
    hasPassed: Maybe<Scalars['Boolean']['output']>
    hasVoted: Maybe<Scalars['Int']['output']>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isAttending: Maybe<Scalars['String']['output']>
    isAttendingSubEvents: Maybe<Scalars['Boolean']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isFollowing: Maybe<Scalars['Boolean']['output']>
    isFormEnabled: Maybe<Scalars['Boolean']['output']>
    isHighlighted: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localAbstract: Maybe<Scalars['String']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    location: Maybe<Scalars['String']['output']>
    locationAddress: Maybe<Scalars['String']['output']>
    locationLink: Maybe<Scalars['String']['output']>
    maxAttendees: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    parent: Maybe<Event>
    publishRequest: Maybe<PublishRequest>
    qrAccess: Maybe<Scalars['Boolean']['output']>
    rangeSettings: Maybe<EventRangeSettings>
    requireAttendParent: Maybe<Scalars['Boolean']['output']>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    rsvp: Maybe<Scalars['Boolean']['output']>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    slots: Maybe<Array<Maybe<Scalars['String']['output']>>>
    slotsAvailable: Maybe<Array<Maybe<EventSlot>>>
    source: Maybe<Scalars['String']['output']>
    startDate: Maybe<Scalars['String']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    suggestedItems: Maybe<Array<Maybe<Entity>>>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    ticketLink: Maybe<Scalars['String']['output']>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    videoCallEnabled: Maybe<Scalars['Boolean']['output']>
    videoCallModerators: Maybe<Array<Maybe<User>>>
    videoCallUrl: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    votes: Maybe<Scalars['Int']['output']>
    votingUsers: Maybe<UserList>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type EventAttendeesArgs = {
    isCheckedIn?: InputMaybe<Scalars['Boolean']['input']>
    isInvited?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<AttendeeOrderBy>
    orderDirection?: InputMaybe<OrderDirection>
    query?: InputMaybe<Scalars['String']['input']>
    state?: InputMaybe<Scalars['String']['input']>
}

export type EventCommentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type EventVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export enum EventFilter {
    Previous = 'previous',
    Upcoming = 'upcoming',
}

export type EventList = {
    __typename: 'EventList'
    edges: Maybe<Array<Maybe<Event>>>
    total: Scalars['Int']['output']
}

export type EventRangeSettings = {
    __typename: 'EventRangeSettings'
    instanceLimit: Maybe<Scalars['Int']['output']>
    interval: Maybe<Scalars['Int']['output']>
    isIgnored: Maybe<Scalars['Boolean']['output']>
    repeatUntil: Maybe<Scalars['DateTime']['output']>
    type: Maybe<EventRangeType>
}

export type EventRangeSettingsInput = {
    instanceLimit?: InputMaybe<Scalars['Int']['input']>
    interval: Scalars['Int']['input']
    repeatUntil?: InputMaybe<Scalars['DateTime']['input']>
    type: EventRangeType
    /**
     * True = alle volgende events in de reeks nemen de wijziging over
     * False = dit event komt buiten de reeks te staan
     */
    updateRange: Scalars['Boolean']['input']
}

export enum EventRangeType {
    Daily = 'daily',
    DayOfTheMonth = 'dayOfTheMonth',
    DayOfTheWeek = 'dayOfTheWeek',
    WeekdayOfTheMonth = 'weekdayOfTheMonth',
}

export type EventSlot = {
    __typename: 'EventSlot'
    alreadySignedUpInSlot: Maybe<Scalars['Boolean']['output']>
    name: Maybe<Scalars['String']['output']>
    subEventGuids: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type EventSlotInput = {
    name?: InputMaybe<Scalars['String']['input']>
    subEventGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ExportAvatarsPayload = {
    __typename: 'ExportAvatarsPayload'
    guid: Maybe<Scalars['String']['output']>
    status: Maybe<Scalars['String']['output']>
}

export type ExportContentType = {
    __typename: 'ExportContentType'
    fields: Maybe<Array<Maybe<Scalars['String']['output']>>>
    type: Maybe<Scalars['String']['output']>
}

export type ExportContentTypeInput = {
    contentGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    groupGuid?: InputMaybe<Scalars['String']['input']>
    type: Scalars['String']['input']
}

export type ExportRequest = {
    __typename: 'ExportRequest'
    completedAt: Maybe<Scalars['DateTime']['output']>
    contentTypes: Maybe<Array<Maybe<ExportContentType>>>
    createdAt: Maybe<Scalars['DateTime']['output']>
    downloadUrl: Maybe<Scalars['String']['output']>
    export: Maybe<Entity>
    guid: Maybe<Scalars['String']['output']>
    owner: Maybe<User>
    purpose: Maybe<Scalars['String']['output']>
    status: Maybe<ExportRequestStatusEnum>
    successUrl: Maybe<Scalars['String']['output']>
}

export enum ExportRequestStatusEnum {
    Completed = 'completed',
    Pending = 'pending',
}

export type ExportRequestsPayload = {
    __typename: 'ExportRequestsPayload'
    edges: Maybe<Array<Maybe<ExportRequest>>>
    total: Maybe<Scalars['Int']['output']>
}

export type ExportableField = {
    __typename: 'ExportableField'
    field: Scalars['String']['output']
    field_type: Scalars['String']['output']
    label: Scalars['String']['output']
}

export type ExternalContent = Entity & {
    __typename: 'ExternalContent'
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    featured: Maybe<Featured>
    guid: Scalars['String']['output']
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    remoteId: Maybe<Scalars['String']['output']>
    source: Maybe<ExternalContentSource>
    status: Maybe<Scalars['Int']['output']>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type ExternalContentSource = {
    handlerId: Maybe<ExternalContentSourceHandlerEnum>
    key: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    pluralName: Maybe<Scalars['String']['output']>
}

export enum ExternalContentSourceHandlerEnum {
    Datahub = 'datahub',
    Default = 'default',
}

export type ExternalContentSourcePayload = {
    __typename: 'ExternalContentSourcePayload'
    edges: Maybe<Array<Maybe<ExternalContentSource>>>
}

export type ExternalSearchList = {
    __typename: 'ExternalSearchList'
    edges: Maybe<Array<Maybe<SourceDocument>>>
    searchId: Maybe<Scalars['String']['output']>
    total: Scalars['Int']['output']
}

export type Featured = {
    __typename: 'Featured'
    alt: Maybe<Scalars['String']['output']>
    caption: Maybe<Scalars['String']['output']>
    image: Maybe<File>
    positionY: Maybe<Scalars['Int']['output']>
    video: Maybe<Scalars['String']['output']>
    videoThumbnailUrl: Maybe<Scalars['String']['output']>
    videoTitle: Maybe<Scalars['String']['output']>
}

export type FeaturedInput = {
    alt?: InputMaybe<Scalars['String']['input']>
    caption?: InputMaybe<Scalars['String']['input']>
    imageGuid?: InputMaybe<Scalars['String']['input']>
    positionY?: InputMaybe<Scalars['Int']['input']>
    video?: InputMaybe<Scalars['String']['input']>
    videoTitle?: InputMaybe<Scalars['String']['input']>
}

export type FetchVideoMetadataInput = {
    url: Scalars['String']['input']
}

export type FetchVideoMetadataPayload = {
    __typename: 'FetchVideoMetadataPayload'
    metadata: Maybe<VideoMetadata>
}

export type File = Entity &
    FileFolder & {
        __typename: 'File'
        accessId: Maybe<Scalars['Int']['output']>
        canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
        canBookmark: Maybe<Scalars['Boolean']['output']>
        canComment: Maybe<Scalars['Boolean']['output']>
        canEdit: Scalars['Boolean']['output']
        canEditInCollabora: Scalars['Boolean']['output']
        canLock: Maybe<Scalars['Boolean']['output']>
        canUnlock: Maybe<Scalars['Boolean']['output']>
        canVote: Maybe<Scalars['Boolean']['output']>
        collaboraEditUrl: Maybe<Scalars['String']['output']>
        commentCount: Maybe<Scalars['Int']['output']>
        comments: Maybe<Array<Maybe<Comment>>>
        container: Maybe<Entity>
        description: Maybe<Scalars['String']['output']>
        dimension: Maybe<ImageDimension>
        download: Maybe<Scalars['String']['output']>
        embed: Maybe<Scalars['String']['output']>
        excerpt: Maybe<Scalars['String']['output']>
        featured: Maybe<Featured>
        group: Maybe<Group>
        guid: Scalars['String']['output']
        hasChildren: Maybe<Scalars['Boolean']['output']>
        hasVoted: Maybe<Scalars['Int']['output']>
        inGroup: Maybe<Scalars['Boolean']['output']>
        inputLanguage: Maybe<Scalars['String']['output']>
        isBookmarked: Maybe<Scalars['Boolean']['output']>
        isFeatured: Maybe<Scalars['Boolean']['output']>
        isFeaturedImage: Maybe<Scalars['Boolean']['output']>
        isFollowing: Maybe<Scalars['Boolean']['output']>
        isHighlighted: Maybe<Scalars['Boolean']['output']>
        isInlineViewPossible: Maybe<Scalars['Boolean']['output']>
        isLocked: Maybe<Scalars['Boolean']['output']>
        isPersonalFile: Maybe<Scalars['Boolean']['output']>
        isPinned: Scalars['Boolean']['output']
        isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
        isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
        lastDownload: Maybe<Scalars['DateTime']['output']>
        latestVersion: Maybe<FileVersion>
        localDescription: Maybe<Scalars['String']['output']>
        localExcerpt: Maybe<Scalars['String']['output']>
        localRichDescription: Maybe<Scalars['String']['output']>
        lockedAt: Maybe<Scalars['DateTime']['output']>
        lockedBy: Maybe<User>
        metaData: Maybe<MetaData>
        mimeType: Maybe<Scalars['String']['output']>
        openGraphMetaData: Maybe<OpenGraphMetaData>
        originalFileName: Maybe<Scalars['String']['output']>
        owner: Maybe<User>
        parentFolder: Maybe<Folder>
        publishRequest: Maybe<PublishRequest>
        referenceCount: Maybe<Scalars['Int']['output']>
        references: Maybe<Array<Maybe<FileReference>>>
        richDescription: Maybe<Scalars['SecureRichText']['output']>
        rootContainer: Maybe<Entity>
        scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
        scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
        showOwner: Maybe<Scalars['Boolean']['output']>
        size: Maybe<Scalars['Int']['output']>
        status: Maybe<Scalars['Int']['output']>
        statusPublished: Maybe<StatusPublished>
        subtype: Maybe<Scalars['String']['output']>
        tagCategories: Maybe<Array<Maybe<TagCategory>>>
        tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
        thumbnail: Maybe<Scalars['String']['output']>
        timeCreated: Maybe<Scalars['DateTime']['output']>
        timePublished: Maybe<Scalars['DateTime']['output']>
        timeUpdated: Maybe<Scalars['DateTime']['output']>
        title: Maybe<Scalars['String']['output']>
        url: Maybe<Scalars['String']['output']>
        versions: Maybe<FileVersionList>
        views: Maybe<Scalars['Int']['output']>
        votes: Maybe<Scalars['Int']['output']>
        votingUsers: Maybe<UserList>
        writeAccessId: Maybe<Scalars['Int']['output']>
    }

export type FileVersionsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type FileVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type FileDeleteError = {
    __typename: 'FileDeleteError'
    entity: Maybe<Entity>
    next: Maybe<RecursiveDeleteOption>
}

export enum FileFilter {
    All = 'all',
    AttachmentFiles = 'attachmentFiles',
    Files = 'files',
    OrphanedFiles = 'orphanedFiles',
}

export type FileFolder = {
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canVote: Maybe<Scalars['Boolean']['output']>
    commentCount: Maybe<Scalars['Int']['output']>
    comments: Maybe<Array<Maybe<Comment>>>
    container: Maybe<Entity>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    featured: Maybe<Featured>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasVoted: Maybe<Scalars['Int']['output']>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isFollowing: Maybe<Scalars['Boolean']['output']>
    isHighlighted: Maybe<Scalars['Boolean']['output']>
    isPersonalFile: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    parentFolder: Maybe<Folder>
    referenceCount: Maybe<Scalars['Int']['output']>
    references: Maybe<Array<Maybe<FileReference>>>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    rootContainer: Maybe<Entity>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    votes: Maybe<Scalars['Int']['output']>
    votingUsers: Maybe<UserList>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type FileFolderVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type FileReference = {
    __typename: 'FileReference'
    entityType: Maybe<Scalars['String']['output']>
    guid: Maybe<Scalars['String']['output']>
    label: Maybe<Scalars['String']['output']>
    referenceType: Maybe<FileReferenceType>
    url: Maybe<Scalars['String']['output']>
}

export enum FileReferenceType {
    Entity = 'entity',
    Setting = 'setting',
}

export type FileVersion = {
    __typename: 'FileVersion'
    canViewInCollabora: Maybe<Scalars['Boolean']['output']>
    collaboraViewUrl: Maybe<Scalars['String']['output']>
    comment: Maybe<Scalars['String']['output']>
    createdAt: Maybe<Scalars['DateTime']['output']>
    createdBy: Maybe<User>
    downloadUrl: Maybe<Scalars['String']['output']>
    guid: Maybe<Scalars['String']['output']>
    isLatest: Maybe<Scalars['Boolean']['output']>
    mimeType: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    size: Maybe<Scalars['Int']['output']>
}

export type FileVersionList = {
    __typename: 'FileVersionList'
    edges: Maybe<Array<Maybe<FileVersion>>>
    total: Maybe<Scalars['Int']['output']>
}

export type FilterInput = {
    name: Scalars['String']['input']
    values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type Filters = {
    __typename: 'Filters'
    users: Maybe<Array<Maybe<UserFilter>>>
}

export type FiltersUsersArgs = {
    groupGuid?: InputMaybe<Scalars['String']['input']>
}

export type Folder = Entity &
    FileFolder & {
        __typename: 'Folder'
        accessId: Maybe<Scalars['Int']['output']>
        canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
        canBookmark: Maybe<Scalars['Boolean']['output']>
        canComment: Maybe<Scalars['Boolean']['output']>
        canEdit: Scalars['Boolean']['output']
        canVote: Maybe<Scalars['Boolean']['output']>
        commentCount: Maybe<Scalars['Int']['output']>
        comments: Maybe<Array<Maybe<Comment>>>
        container: Maybe<Entity>
        description: Maybe<Scalars['String']['output']>
        excerpt: Maybe<Scalars['String']['output']>
        featured: Maybe<Featured>
        group: Maybe<Group>
        guid: Scalars['String']['output']
        hasChildren: Maybe<Scalars['Boolean']['output']>
        hasVoted: Maybe<Scalars['Int']['output']>
        inGroup: Maybe<Scalars['Boolean']['output']>
        inputLanguage: Maybe<Scalars['String']['output']>
        isBookmarked: Maybe<Scalars['Boolean']['output']>
        isFeatured: Maybe<Scalars['Boolean']['output']>
        isFollowing: Maybe<Scalars['Boolean']['output']>
        isHighlighted: Maybe<Scalars['Boolean']['output']>
        isPersonalFile: Maybe<Scalars['Boolean']['output']>
        isPinned: Scalars['Boolean']['output']
        isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
        isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
        lastDownload: Maybe<Scalars['DateTime']['output']>
        localDescription: Maybe<Scalars['String']['output']>
        localExcerpt: Maybe<Scalars['String']['output']>
        localRichDescription: Maybe<Scalars['String']['output']>
        metaData: Maybe<MetaData>
        mimeType: Maybe<Scalars['String']['output']>
        openGraphMetaData: Maybe<OpenGraphMetaData>
        owner: Maybe<User>
        parentFolder: Maybe<Folder>
        referenceCount: Maybe<Scalars['Int']['output']>
        references: Maybe<Array<Maybe<FileReference>>>
        richDescription: Maybe<Scalars['SecureRichText']['output']>
        rootContainer: Maybe<Entity>
        scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
        scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
        showOwner: Maybe<Scalars['Boolean']['output']>
        size: Maybe<Scalars['Int']['output']>
        status: Maybe<Scalars['Int']['output']>
        statusPublished: Maybe<StatusPublished>
        subtype: Maybe<Scalars['String']['output']>
        tagCategories: Maybe<Array<Maybe<TagCategory>>>
        tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
        timeCreated: Maybe<Scalars['DateTime']['output']>
        timePublished: Maybe<Scalars['DateTime']['output']>
        timeUpdated: Maybe<Scalars['DateTime']['output']>
        title: Maybe<Scalars['String']['output']>
        url: Maybe<Scalars['String']['output']>
        views: Maybe<Scalars['Int']['output']>
        votes: Maybe<Scalars['Int']['output']>
        votingUsers: Maybe<UserList>
        writeAccessId: Maybe<Scalars['Int']['output']>
    }

export type FolderVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type FollowersList = {
    __typename: 'FollowersList'
    results: Array<Maybe<User>>
    total: Scalars['Int']['output']
}

export type FooterInput = {
    link: Scalars['String']['input']
    title: Scalars['String']['input']
}

export type FooterMenu = {
    __typename: 'FooterMenu'
    link: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export enum Frequency {
    Daily = 'daily',
    Monthly = 'monthly',
    Never = 'never',
    Twoweekly = 'twoweekly',
    Weekly = 'weekly',
}

export type GenericArticle = Entity & {
    __typename: 'GenericArticle'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    backgroundColor: Maybe<Scalars['String']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    canVote: Maybe<Scalars['Boolean']['output']>
    commentCount: Maybe<Scalars['Int']['output']>
    comments: Maybe<Array<Maybe<Comment>>>
    contentType: Maybe<CustomContentType>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    featured: Maybe<Featured>
    followers: Maybe<FollowersList>
    formResponse: Maybe<Array<Maybe<EntityFormResponse>>>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasVoted: Maybe<Scalars['Int']['output']>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isFollowing: Maybe<Scalars['Boolean']['output']>
    isHighlighted: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localAbstract: Maybe<Scalars['String']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    publishRequest: Maybe<PublishRequest>
    revision: Maybe<Revision>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    suggestedItems: Maybe<Array<Maybe<Entity>>>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    votes: Maybe<Scalars['Int']['output']>
    votingUsers: Maybe<UserList>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type GenericArticleCommentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type GenericArticleFollowersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
}

export type GenericArticleVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type Group = Entity & {
    __typename: 'Group'
    autoMembershipFields: Maybe<Array<Maybe<AutoMembershipField>>>
    autoNotification: Maybe<Scalars['Boolean']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canChangeOwnership: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    chat: Maybe<Chat>
    defaultReadAccessId: Maybe<Scalars['Int']['output']>
    defaultTagCategories: Maybe<Array<Maybe<TagCategory>>>
    defaultTags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    defaultWriteAccessId: Maybe<Scalars['Int']['output']>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    featured: Maybe<Featured>
    fileDiskUsage: Maybe<Scalars['Float']['output']>
    fileNotification: Maybe<Scalars['Boolean']['output']>
    guid: Scalars['String']['output']
    icon: Maybe<File>
    introduction: Maybe<Scalars['String']['output']>
    invite: Maybe<InviteList>
    invited: Maybe<InviteList>
    isAutoMembershipEnabled: Maybe<Scalars['Boolean']['output']>
    isChatEnabled: Maybe<Scalars['Boolean']['output']>
    isClosed: Maybe<Scalars['Boolean']['output']>
    isCollaboraEnabled: Maybe<Scalars['Boolean']['output']>
    isFavorite: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isHidden: Maybe<Scalars['Boolean']['output']>
    isIntroductionPublic: Maybe<Scalars['Boolean']['output']>
    isJoinButtonVisible: Maybe<Scalars['Boolean']['output']>
    isLeavingGroupDisabled: Maybe<Scalars['Boolean']['output']>
    isMembershipOnRequest: Maybe<Scalars['Boolean']['output']>
    isMenuAlwaysVisible: Maybe<Scalars['Boolean']['output']>
    isNotificationDirectMailEnabled: Maybe<Scalars['Boolean']['output']>
    isNotificationPushEnabled: Maybe<Scalars['Boolean']['output']>
    isNotificationsEnabled: Maybe<Scalars['Boolean']['output']>
    isOwner: Maybe<Scalars['Boolean']['output']>
    memberCount: Scalars['Int']['output']
    members: Maybe<MemberList>
    membership: Maybe<Membership>
    membershipRequests: Maybe<MembershipRequestList>
    menu: Maybe<Array<Maybe<GroupMenuItem>>>
    metaData: Maybe<MetaData>
    name: Maybe<Scalars['String']['output']>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    plugins: Maybe<Array<Maybe<Scalars['String']['output']>>>
    readAccessIds: Maybe<Array<Maybe<AccessId>>>
    requiredProfileFieldGuids: Maybe<Array<Maybe<Scalars['String']['output']>>>
    requiredProfileFieldsMessage: Maybe<Scalars['String']['output']>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    scheduleDeleteAfter: Maybe<Scalars['DateTime']['output']>
    showMemberProfileFieldGuids: Maybe<
        Array<Maybe<Scalars['String']['output']>>
    >
    startPage: Maybe<Page>
    status: Maybe<Scalars['Int']['output']>
    subgroups: Maybe<SubgroupList>
    subtype: Maybe<Scalars['String']['output']>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    url: Maybe<Scalars['String']['output']>
    vcardFieldGuids: Maybe<Array<Maybe<Scalars['String']['output']>>>
    welcomeMessage: Maybe<Scalars['String']['output']>
    writeAccessIds: Maybe<Array<Maybe<AccessId>>>
}

export type GroupInviteArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
}

export type GroupInvitedArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
}

export type GroupMembersArgs = {
    inSubgroupId?: InputMaybe<Scalars['Int']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    notInSubgroupId?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
}

export enum GroupAddPermission {
    Admin = 'admin',
    Authenticated = 'authenticated',
    Editor = 'editor',
}

export enum GroupFilter {
    All = 'all',
}

export type GroupList = {
    __typename: 'GroupList'
    edges: Maybe<Array<Maybe<Group>>>
    total: Scalars['Int']['output']
}

export enum GroupMemberOrderBy {
    MemberSince = 'memberSince',
    Name = 'name',
}

export type GroupMenuItem = {
    access: Maybe<GroupMenuItemAccess>
    id: Maybe<Scalars['String']['output']>
    label: Maybe<Scalars['String']['output']>
    type: Maybe<GroupMenuType>
}

export enum GroupMenuItemAccess {
    LoggedIn = 'loggedIn',
    Members = 'members',
    Public = 'public',
}

export type GroupMenuItemInput = {
    access?: InputMaybe<GroupMenuItemAccess>
    id?: InputMaybe<Scalars['String']['input']>
    label?: InputMaybe<Scalars['String']['input']>
    submenu?: InputMaybe<Array<InputMaybe<GroupMenuItemInput>>>
    type: GroupMenuType
}

export type GroupMenuLinkItem = GroupMenuItem & {
    __typename: 'GroupMenuLinkItem'
    access: Maybe<GroupMenuItemAccess>
    id: Maybe<Scalars['String']['output']>
    label: Maybe<Scalars['String']['output']>
    link: Maybe<Scalars['String']['output']>
    type: Maybe<GroupMenuType>
}

export type GroupMenuPageItem = GroupMenuItem & {
    __typename: 'GroupMenuPageItem'
    access: Maybe<GroupMenuItemAccess>
    id: Maybe<Scalars['String']['output']>
    label: Maybe<Scalars['String']['output']>
    page: Maybe<Page>
    type: Maybe<GroupMenuType>
}

export type GroupMenuPluginItem = GroupMenuItem & {
    __typename: 'GroupMenuPluginItem'
    access: Maybe<GroupMenuItemAccess>
    id: Maybe<Scalars['String']['output']>
    label: Maybe<Scalars['String']['output']>
    plugin: Maybe<Scalars['String']['output']>
    type: Maybe<GroupMenuType>
}

export enum GroupMenuType {
    Link = 'link',
    Page = 'page',
    Plugin = 'plugin',
    Submenu = 'submenu',
}

export type GroupNotificationItem = {
    __typename: 'GroupNotificationItem'
    guid: Scalars['String']['output']
    isNotificationDirectMailEnabled: Maybe<Scalars['Boolean']['output']>
    isNotificationPushEnabled: Maybe<Scalars['Boolean']['output']>
    isNotificationsEnabled: Maybe<Scalars['Boolean']['output']>
    name: Scalars['String']['output']
}

export enum GroupRoleFilter {
    Admin = 'admin',
    NewsEditor = 'newsEditor',
    Owner = 'owner',
}

export enum GroupSubMenuType {
    Link = 'link',
    Page = 'page',
    Plugin = 'plugin',
}

export type GroupSubmenuItem = GroupMenuItem & {
    __typename: 'GroupSubmenuItem'
    access: Maybe<GroupMenuItemAccess>
    id: Maybe<Scalars['String']['output']>
    label: Maybe<Scalars['String']['output']>
    submenu: Maybe<Array<Maybe<GroupMenuItem>>>
    type: Maybe<GroupMenuType>
}

export type HandleDeleteAccountRequestPayload = {
    __typename: 'HandleDeleteAccountRequestPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type HandleSiteAccessRequestPayload = {
    __typename: 'HandleSiteAccessRequestPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type ImageDimension = {
    __typename: 'ImageDimension'
    height: Maybe<Scalars['Int']['output']>
    width: Maybe<Scalars['Int']['output']>
}

export type ImportUserFieldInput = {
    accessId?: InputMaybe<Scalars['Int']['input']>
    csvColumn: Scalars['String']['input']
    forceAccess?: InputMaybe<Scalars['Boolean']['input']>
    userField: Scalars['String']['input']
}

export type ImportUsersStep1Payload = {
    __typename: 'ImportUsersStep1Payload'
    accessIdOptions: Maybe<Array<Maybe<OptionInteger>>>
    csvColumns: Maybe<Array<Maybe<Scalars['String']['output']>>>
    /**
     * - csvColumns, columns of the uploaded csv
     * - userFields, fields of users
     * - accessIds, integers of access level for field
     */
    importId: Scalars['String']['output']
    userFields: Maybe<Array<Maybe<Option>>>
}

export type ImportUsersStep2Payload = {
    __typename: 'ImportUsersStep2Payload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type InitiateVideocallPayload = {
    __typename: 'InitiateVideocallPayload'
    guestUrl: Maybe<Scalars['String']['output']>
    hostUrl: Maybe<Scalars['String']['output']>
    success: Maybe<Scalars['Boolean']['output']>
}

export type IntelligentSearchAnswer = {
    __typename: 'IntelligentSearchAnswer'
    answer: Maybe<Scalars['String']['output']>
    feedback: Maybe<Scalars['String']['output']>
    guid: Maybe<Scalars['String']['output']>
    sources: Maybe<Array<Maybe<SearchResult>>>
}

export type IntelligentSearchQaPair = {
    __typename: 'IntelligentSearchQAPair'
    adminFeedback: Maybe<Scalars['String']['output']>
    answer: Maybe<Scalars['String']['output']>
    created_at: Maybe<Scalars['DateTime']['output']>
    question: Maybe<Scalars['String']['output']>
    userFeedback: Maybe<Scalars['String']['output']>
    uuid: Maybe<Scalars['String']['output']>
}

export type IntelligentSearchQaPairList = {
    __typename: 'IntelligentSearchQAPairList'
    edges: Maybe<Array<Maybe<IntelligentSearchQaPair>>>
    total: Scalars['Int']['output']
}

export type IntelligentSearchQuestion = {
    __typename: 'IntelligentSearchQuestion'
    answers: Maybe<Array<Maybe<IntelligentSearchAnswer>>>
    guid: Scalars['String']['output']
    question: Maybe<Scalars['String']['output']>
    status: Maybe<IntelligentSearchStatus>
}

export type IntelligentSearchQuestionPayload = {
    __typename: 'IntelligentSearchQuestionPayload'
    question: Maybe<IntelligentSearchQuestion>
    success: Maybe<Scalars['Boolean']['output']>
}

export type IntelligentSearchQuestionResult = {
    __typename: 'IntelligentSearchQuestionResult'
    question: Maybe<IntelligentSearchQuestion>
}

export type IntelligentSearchQuestionsResult = {
    __typename: 'IntelligentSearchQuestionsResult'
    edges: Maybe<Array<Maybe<IntelligentSearchQuestion>>>
    total: Maybe<Scalars['Int']['output']>
}

export enum IntelligentSearchStatus {
    Accepted = 'accepted',
    Pending = 'pending',
    ReadyForReview = 'readyForReview',
}

export type Invite = {
    __typename: 'Invite'
    email: Maybe<Scalars['String']['output']>
    id: Maybe<Scalars['Int']['output']>
    invited: Scalars['Boolean']['output']
    timeCreated: Maybe<Scalars['DateTime']['output']>
    user: Maybe<User>
}

export type InviteList = {
    __typename: 'InviteList'
    edges: Maybe<Array<Maybe<Invite>>>
    total: Scalars['Int']['output']
}

export type InviteStatus = {
    __typename: 'InviteStatus'
    item: Maybe<Scalars['String']['output']>
    status: Maybe<InviteStatusEnum>
}

export enum InviteStatusEnum {
    InvalidEmail = 'invalidEmail',
    Invited = 'invited',
    Member = 'member',
    NotInvited = 'notInvited',
}

export type InviteToEventPayload = {
    __typename: 'InviteToEventPayload'
    event: Maybe<Event>
    status: Maybe<Array<Maybe<InviteToEventStatus>>>
}

export type InviteToEventStatus = {
    __typename: 'InviteToEventStatus'
    item: Maybe<Scalars['String']['output']>
    status: Maybe<InviteToEventStatusEnum>
}

export enum InviteToEventStatusEnum {
    AlreadyExists = 'alreadyExists',
    InvalidEmail = 'invalidEmail',
    InvalidUser = 'invalidUser',
    Invited = 'invited',
}

export type InviteToGroupPayload = {
    __typename: 'InviteToGroupPayload'
    group: Maybe<Group>
    status: Maybe<Array<Maybe<InviteStatus>>>
}

export type InviteToGroupUser = {
    email?: InputMaybe<Scalars['String']['input']>
    guid?: InputMaybe<Scalars['String']['input']>
    role?: InputMaybe<Role>
}

export type InviteToSitePayload = {
    __typename: 'InviteToSitePayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type JoinGroupPayload = {
    __typename: 'JoinGroupPayload'
    group: Maybe<Group>
}

export type KeyValueItem = {
    __typename: 'KeyValueItem'
    key: Scalars['String']['output']
    value: Scalars['String']['output']
}

export type KeyValueItemInput = {
    key: Scalars['String']['input']
    value?: InputMaybe<Scalars['String']['input']>
}

export enum KindOfAdminTask {
    CommentPublicationRequests = 'commentPublicationRequests',
    ContentPublicationRequests = 'contentPublicationRequests',
    DeleteAccountRequests = 'deleteAccountRequests',
    FilePublicationRequests = 'filePublicationRequests',
    SiteAccessRequests = 'siteAccessRequests',
}

export type LeaveGroupPayload = {
    __typename: 'LeaveGroupPayload'
    group: Maybe<Group>
}

export type LocalMenuTitle = {
    __typename: 'LocalMenuTitle'
    label: Maybe<Scalars['String']['output']>
    language: Maybe<Scalars['String']['output']>
}

export type LocalMenuTitleInput = {
    label?: InputMaybe<Scalars['String']['input']>
    language?: InputMaybe<Scalars['String']['input']>
}

export type LockFileInput = {
    guid: Scalars['String']['input']
    shouldLock: Scalars['Boolean']['input']
}

export type LockFilePayload = {
    __typename: 'LockFilePayload'
    entity: File
    success: Scalars['Boolean']['output']
}

export type Magazine = Entity & {
    __typename: 'Magazine'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    canVote: Maybe<Scalars['Boolean']['output']>
    colophonFields: Maybe<Array<Maybe<ColophonField>>>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    followers: Maybe<FollowersList>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    icon: Maybe<File>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isFollowing: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localAbstract: Maybe<Scalars['String']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localSubtitle: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    publishRequest: Maybe<PublishRequest>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    showTableOfContents: Scalars['Boolean']['output']
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtitle: Maybe<Scalars['String']['output']>
    subtype: Maybe<Scalars['String']['output']>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type MagazineFollowersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
}

export type MagazineIssue = Entity & {
    __typename: 'MagazineIssue'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    articles: Maybe<Array<Maybe<Entity>>>
    backgroundColor: Maybe<Scalars['String']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    canVote: Maybe<Scalars['Boolean']['output']>
    colophon: Maybe<Array<Maybe<ColophonValue>>>
    container: Maybe<Magazine>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    featured: Maybe<Featured>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    issueNumber: Maybe<Scalars['Int']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localAbstract: Maybe<Scalars['String']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    publishRequest: Maybe<PublishRequest>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    showTableOfContents: Scalars['Boolean']['output']
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type MarkAllAsReadPayload = {
    __typename: 'MarkAllAsReadPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type MarkAsReadPayload = {
    __typename: 'MarkAsReadPayload'
    notification: Maybe<Notification>
    success: Maybe<Scalars['Boolean']['output']>
}

export enum MatchStrategy {
    All = 'all',
    Any = 'any',
}

export type Member = {
    __typename: 'Member'
    email: Maybe<Scalars['String']['output']>
    isOwner: Scalars['Boolean']['output']
    memberSince: Maybe<Scalars['DateTime']['output']>
    roles: Maybe<Array<Maybe<Role>>>
    user: Maybe<User>
}

export type MemberList = {
    __typename: 'MemberList'
    edges: Maybe<Array<Maybe<Member>>>
    fieldsInOverview: Maybe<Array<Maybe<ProfileItem>>>
    onlineTotal: Maybe<Scalars['Int']['output']>
    total: Scalars['Int']['output']
}

export enum Membership {
    Invited = 'invited',
    Joined = 'joined',
    NotJoined = 'not_joined',
    Requested = 'requested',
}

export type MembershipRequestList = {
    __typename: 'MembershipRequestList'
    edges: Maybe<Array<Maybe<User>>>
    total: Scalars['Int']['output']
}

export type MenuItem = {
    __typename: 'MenuItem'
    access: MenuItemAccess
    children: Maybe<Array<Maybe<MenuItem>>>
    guid: Maybe<Scalars['String']['output']>
    label: Scalars['String']['output']
    link: Maybe<Scalars['String']['output']>
    localLabel: Maybe<Scalars['String']['output']>
    translations: Maybe<Array<Maybe<LocalMenuTitle>>>
}

export enum MenuItemAccess {
    Administrator = 'administrator',
    LoggedIn = 'loggedIn',
    Public = 'public',
    PublicOnly = 'publicOnly',
}

export type MenuItemInput = {
    access?: InputMaybe<MenuItemAccess>
    /** Temporary id of this menu item. */
    id: Scalars['Int']['input']
    label: Scalars['String']['input']
    link?: InputMaybe<Scalars['String']['input']>
    /** Temporary id of the parent menu item. */
    parentId?: InputMaybe<Scalars['Int']['input']>
    translations?: InputMaybe<Array<InputMaybe<LocalMenuTitleInput>>>
}

export enum MenuState {
    Compact = 'compact',
    Normal = 'normal',
}

export type MetaData = {
    __typename: 'MetaData'
    description: Maybe<Scalars['String']['output']>
    modified_time: Maybe<Scalars['String']['output']>
    published_time: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type MoodleCourse = {
    __typename: 'MoodleCourse'
    categoryId: Maybe<Scalars['Int']['output']>
    categoryName: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    id: Maybe<Scalars['Int']['output']>
    isEnrolled: Maybe<Scalars['Boolean']['output']>
    progress: Maybe<Scalars['Int']['output']>
    shortname: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    visible: Maybe<Scalars['Boolean']['output']>
}

export type MoodleCoursesPayload = {
    __typename: 'MoodleCoursesPayload'
    courses: Maybe<Array<Maybe<MoodleCourse>>>
    hasMoodleAccount: Maybe<Scalars['Boolean']['output']>
}

export type MoveFileFolderPayload = {
    __typename: 'MoveFileFolderPayload'
    entity: Maybe<Entity>
}

export type MutateTagCategoryInput = {
    name?: InputMaybe<Scalars['String']['input']>
    weight?: InputMaybe<Scalars['Int']['input']>
}

export type MutateTagCategoryTagInput = {
    synonyms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    value?: InputMaybe<Scalars['String']['input']>
    weight?: InputMaybe<Scalars['Int']['input']>
}

export type Mutation = {
    __typename: 'Mutation'
    /** Accept a group invitation. */
    acceptGroupInvitation: Maybe<AcceptGroupInvitationPayload>
    /** Accept a membership request to a group. */
    acceptMembershipRequest: Maybe<AcceptMembershipRequestPayload>
    addAttachment: Maybe<AddAttachmentPayload>
    addChat: Maybe<AddChatPayload>
    addChatAnswerFeedback: Maybe<DocumentChatPayload>
    addChatMessage: Maybe<AddChatMessagePayload>
    addCommentWithoutAccount: Maybe<AddCommentWithoutAccountPayload>
    addCustomContentType: Maybe<CustomContentTypePayload>
    addDatahubExternalContentSource: Maybe<ExternalContentSourcePayload>
    addDocumentChatMessage: Maybe<DocumentChatPayload>
    addEntity: Maybe<AddEntityPayload>
    addEpisode: Maybe<EpisodePayload>
    addFile: Maybe<AddEntityPayload>
    addGroup: Maybe<AddGroupPayload>
    addIntelligentSearchQuestion: Maybe<IntelligentSearchQuestionPayload>
    addPad: Maybe<AddPadPayload>
    addPage: Maybe<AddEntityPayload>
    addPodcast: Maybe<PodcastPayload>
    addPoll: Maybe<AddEntityPayload>
    addProfileSetManager: Maybe<ProfileSetManagerPayload>
    addRssEndpoint: Maybe<AddRssEndpointPayload>
    addSiteSettingProfileField: Maybe<AddSiteSettingProfileFieldPayload>
    /** Add profileFieldValidator */
    addSiteSettingProfileFieldValidator: Maybe<AddSiteSettingProfileFieldValidatorPayload>
    addSubgroup: Maybe<AddSubgroupPayload>
    /**  Tag-Category functions  */
    addTagCategory: Maybe<EditSiteSettingPayload>
    addTagCollection: Maybe<EditTagCollectionPayload>
    addUserContact: Maybe<AddUserContactPayload>
    addWebPushSubscription: Maybe<AddWebPushSubscriptionPayload>
    archiveEntities: Maybe<ArchiveEntitiesPayload>
    assignCommentModerationRequest: Maybe<CommentModerationMutationPayload>
    assignPublishRequest: Maybe<PublishRequestMutationPayload>
    /** Attend an event with state accept, waitinglist, maybe or reject  */
    attendEvent: Maybe<AttendEventPayload>
    attendEventWithoutAccount: Maybe<AttendEventWithoutAccountPayload>
    bookmark: Maybe<BookmarkPayload>
    /** Change the owner of a group. */
    changeGroupOwner: Maybe<ChangeGroupOwnerPayload>
    confirmComment: Maybe<CommentProcessMutationPayload>
    confirmPublishRequest: Maybe<PublishRequestMutationPayload>
    copyEntity: Maybe<CopyEntityPayload>
    createContentSnapshot: Maybe<ContentSnapshotPayload>
    deleteChatMessage: Maybe<DeleteChatMessagePayload>
    deleteCustomContentType: Maybe<DeleteCustomContentTypePayload>
    deleteEntities: Maybe<DeleteEntitiesPayload>
    deleteEntity: Maybe<DeleteEntityPayload>
    deleteEventAttendees: Maybe<DeleteEventAttendeesPayload>
    deleteExternalContentSource: Maybe<ExternalContentSourcePayload>
    /** Remove an invitation to join a group. */
    deleteGroupInvitation: Maybe<DeleteGroupInvitationPayload>
    deleteQAPair: Maybe<DeleteQaPairPayload>
    deleteSiteSettingProfileField: Maybe<DeleteSiteSettingProfileFieldPayload>
    /** Delete profileFieldValidator */
    deleteSiteSettingProfileFieldValidator: Maybe<DeleteSiteSettingProfileFieldValidatorPayload>
    deleteSubgroup: Maybe<DeleteSubgroupPayload>
    deleteTagCategory: Maybe<EditSiteSettingPayload>
    deleteTagCategoryTag: Maybe<EditSiteSettingPayload>
    deleteTagCollection: Maybe<DeleteTagCollectionpPayload>
    deleteUsers: Maybe<DeleteUsersPayload>
    editChat: Maybe<EditChatPayload>
    editChatMessage: Maybe<EditChatMessagePayload>
    editCustomContentType: Maybe<CustomContentTypePayload>
    editDatahubExternalContentSource: Maybe<ExternalContentSourcePayload>
    editEmailAccessRequest: Maybe<EditEmailAccessRequestPayload>
    editEmailOverview: Maybe<EditEmailOverviewPayload>
    editEntity: Maybe<EditEntityPayload>
    editEntityBulk: Maybe<EditEntityBulkPayload>
    editEpisode: Maybe<EpisodePayload>
    editEventAttendee: Maybe<EditEventAttendeePayload>
    editFileFolder: Maybe<EditFileFolderPayload>
    editFileVersionComment: EditFileVersionCommentPayload
    editGroup: Maybe<EditGroupPayload>
    editGroupNotifications: Maybe<EditGroupNotificationsPayload>
    editNotifications: Maybe<EditNotificationsPayload>
    editPad: Maybe<EditPadPayload>
    editPage: Maybe<EditEntityPayload>
    editPodcast: Maybe<PodcastPayload>
    editPoll: Maybe<EditEntityPayload>
    editProfileField: Maybe<EditProfileFieldPayload>
    editSiteSetting: Maybe<EditSiteSettingPayload>
    editSiteSettingProfileField: Maybe<EditSiteSettingProfileFieldPayload>
    /** Edit profileFieldValidator */
    editSiteSettingProfileFieldValidator: Maybe<EditSiteSettingProfileFieldValidatorPayload>
    editSubgroup: Maybe<EditSubgroupPayload>
    editTagCollection: Maybe<EditTagCollectionPayload>
    editTask: Maybe<EditTaskPayload>
    editTaskState: Maybe<EditTaskPayload>
    editUserName: Maybe<EditUserNamePayload>
    editUsers: Maybe<EditUsersPayload>
    exportAvatars: Maybe<ExportAvatarsPayload>
    extendTagCategory: Maybe<EditSiteSettingPayload>
    extractTagSynonym: Maybe<Array<Maybe<Tag>>>
    follow: Maybe<FollowPayload>
    /** Handle delete account request */
    handleDeleteAccountRequest: Maybe<HandleDeleteAccountRequestPayload>
    /** Handle access request */
    handleSiteAccessRequest: Maybe<HandleSiteAccessRequestPayload>
    /** User import step 1 */
    importUsersStep1: Maybe<ImportUsersStep1Payload>
    /** User import step 2, will be scheduled in background, performer will receive a mail with import results.  */
    importUsersStep2: Maybe<ImportUsersStep2Payload>
    initiateVideocall: Maybe<InitiateVideocallPayload>
    inviteToEvent: Maybe<InviteToEventPayload>
    /** Create an invitation to join a group. */
    inviteToGroup: Maybe<InviteToGroupPayload>
    /** Create and send invitation by email to join a site. */
    inviteToSite: Maybe<InviteToSitePayload>
    /**
     * Join a group. In the case of a closed group a membership request will be send,
     * in the case of an open group the user will be joined immediately.
     */
    joinGroup: Maybe<JoinGroupPayload>
    /** Leave a group. */
    leaveGroup: Maybe<LeaveGroupPayload>
    lockFile: Maybe<LockFilePayload>
    markAllAsRead: Maybe<MarkAllAsReadPayload>
    markAsRead: Maybe<MarkAsReadPayload>
    mergeTags: Maybe<Array<Maybe<Tag>>>
    moveFileFolder: Maybe<MoveFileFolderPayload>
    overwriteSiteOwner: Maybe<SiteSettings>
    refreshUserLastOnline: Maybe<RefreshUserLastOnlinePayload>
    rejectComment: Maybe<CommentProcessMutationPayload>
    /** Reject a membership request to a group. */
    rejectMembershipRequest: Maybe<RejectMembershipRequestPayload>
    rejectPublishRequest: Maybe<PublishRequestMutationPayload>
    removeGroupMembers: Maybe<RemoveGroupMembersPayload>
    removeProfileSetManager: Maybe<ProfileSetManagerPayload>
    removeUserContact: Maybe<RemoveUserContactPayload>
    reorder: Maybe<ReorderPayload>
    requestContentExport: Maybe<RequestContentExportPayload>
    /** Resend an invitation to join a group. */
    resendGroupInvitation: Maybe<ResendGroupInvitationPayload>
    resetCommentModerationRequest: Maybe<CommentModerationMutationPayload>
    resetPublishRequest: Maybe<PublishRequestMutationPayload>
    restoreCooldownContent: Maybe<RestoreCooldownContentPayload>
    /** Remove invitation to join a site. */
    revokeInviteToSite: Maybe<RevokeInviteToSitePayload>
    scheduleAppointment: Maybe<ScheduleAppointmentPayload>
    scheduleBanUsers: Maybe<ScheduleBanUsersPayload>
    sendMessageToEvent: Maybe<SendMessageToEventPayload>
    /** Send a message to the entity followers. */
    sendMessageToFollowers: Maybe<SendMessageToFollowersPayload>
    /** Send a message to the group members. */
    sendMessageToGroup: Maybe<SendMessageToGroupPayload>
    sendMessageToUser: Maybe<SendMessageToUserPayload>
    setUserOnlineStatus: Maybe<SetUserOnlineStatusPayload>
    signSiteAgreementVersion: Maybe<SignSiteAgreementVersionPayload>
    toggleBestAnswer: Maybe<ToggleBestAnswerPayload>
    toggleChatReaction: Maybe<ToggleChatReactionPayload>
    toggleEntityArchived: Maybe<ArchiveEntityPayload>
    toggleEntityIsPinned: Maybe<ToggleEntityIsPinnedPayload>
    /** Toggle a role of a group member */
    toggleGroupMemberRole: Maybe<ToggleGroupMemberRolePayload>
    toggleIsClosed: Maybe<ToggleIsClosedPayload>
    toggleRequestDeleteUser: Maybe<ToggleRequestDeleteUserPayload>
    toggleSuspendAdminPrivileges: Maybe<Viewer>
    toggleUserRole: Maybe<ToggleUserRolePayload>
    updateAttendEventState: Maybe<UpdateAttendEventStatePayload>
    updateIntelligentSearchAnswer: Maybe<IntelligentSearchQuestionPayload>
    /** Mark group membership as favorite. */
    updateMembershipFavorite: Maybe<UpdateMembershipFavoritePayload>
    updateQAPair: Maybe<IntelligentSearchQaPair>
    updateRevision: Maybe<Revision>
    updateTagCategory: Maybe<EditSiteSettingPayload>
    updateTagCategoryTag: Maybe<EditSiteSettingPayload>
    updateUserContactFavorite: Maybe<UpdateUserContactFavoritePayload>
    updateUserWidgetSettings: Maybe<UpdateUserWidgetSettingsPayload>
    vote: Maybe<VotePayload>
    voteOnPoll: Maybe<VoteOnPollPayload>
}

export type MutationAcceptGroupInvitationArgs = {
    input: AcceptGroupInvitationInput
}

export type MutationAcceptMembershipRequestArgs = {
    input: AcceptMembershipRequestInput
}

export type MutationAddAttachmentArgs = {
    input: AddAttachmentInput
}

export type MutationAddChatArgs = {
    input: AddChatInput
}

export type MutationAddChatAnswerFeedbackArgs = {
    input: AddChatAnswerFeedbackInput
}

export type MutationAddChatMessageArgs = {
    input: AddChatMessageInput
}

export type MutationAddCommentWithoutAccountArgs = {
    input: AddCommentWithoutAccountInput
}

export type MutationAddCustomContentTypeArgs = {
    input: CustomContentTypeInput
}

export type MutationAddDatahubExternalContentSourceArgs = {
    input: AddDatahubContentSourceInput
}

export type MutationAddDocumentChatMessageArgs = {
    input: AddDocumentChatMessageInput
}

export type MutationAddEntityArgs = {
    input: AddEntityInput
}

export type MutationAddEpisodeArgs = {
    input: AddEpisodeInput
}

export type MutationAddFileArgs = {
    input: AddFileInput
}

export type MutationAddGroupArgs = {
    input: AddGroupInput
}

export type MutationAddIntelligentSearchQuestionArgs = {
    input?: InputMaybe<AddIntelligentSearchInput>
}

export type MutationAddPadArgs = {
    input: AddPadInput
}

export type MutationAddPageArgs = {
    input: AddPageInput
}

export type MutationAddPodcastArgs = {
    input: AddPodcastInput
}

export type MutationAddPollArgs = {
    input: AddPollInput
}

export type MutationAddProfileSetManagerArgs = {
    profileSetGuid: Scalars['String']['input']
    userGuid: Scalars['String']['input']
}

export type MutationAddRssEndpointArgs = {
    groupGuid?: InputMaybe<Scalars['String']['input']>
    url: Scalars['String']['input']
}

export type MutationAddSiteSettingProfileFieldArgs = {
    input: AddSiteSettingProfileFieldInput
}

export type MutationAddSiteSettingProfileFieldValidatorArgs = {
    input: AddSiteSettingProfileFieldValidatorInput
}

export type MutationAddSubgroupArgs = {
    input: AddSubgroupInput
}

export type MutationAddTagCategoryArgs = {
    input: MutateTagCategoryInput
}

export type MutationAddTagCollectionArgs = {
    input: AddTagCollectionInput
}

export type MutationAddUserContactArgs = {
    input: AddUserContactInput
}

export type MutationAddWebPushSubscriptionArgs = {
    input: AddWebPushSubscriptionInput
}

export type MutationArchiveEntitiesArgs = {
    input: ArchiveEntitiesInput
}

export type MutationAssignCommentModerationRequestArgs = {
    guid: Scalars['String']['input']
}

export type MutationAssignPublishRequestArgs = {
    guid: Scalars['String']['input']
}

export type MutationAttendEventArgs = {
    input: AttendEventInput
}

export type MutationAttendEventWithoutAccountArgs = {
    input: AttendEventWithoutAccountInput
}

export type MutationBookmarkArgs = {
    input: BookmarkInput
}

export type MutationChangeGroupOwnerArgs = {
    input: ChangeGroupOwnerInput
}

export type MutationConfirmCommentArgs = {
    guid: Scalars['String']['input']
}

export type MutationConfirmPublishRequestArgs = {
    guid: Scalars['String']['input']
}

export type MutationCopyEntityArgs = {
    input: CopyEntityInput
}

export type MutationDeleteChatMessageArgs = {
    input: DeleteChatMessageInput
}

export type MutationDeleteCustomContentTypeArgs = {
    key: Scalars['String']['input']
}

export type MutationDeleteEntitiesArgs = {
    input: DeleteEntitiesInput
}

export type MutationDeleteEntityArgs = {
    input: DeleteEntityInput
}

export type MutationDeleteEventAttendeesArgs = {
    input: DeleteEventAttendeesInput
}

export type MutationDeleteExternalContentSourceArgs = {
    key: Scalars['String']['input']
}

export type MutationDeleteGroupInvitationArgs = {
    input: DeleteGroupInvitationInput
}

export type MutationDeleteQaPairArgs = {
    qaPairUuid: Scalars['String']['input']
}

export type MutationDeleteSiteSettingProfileFieldArgs = {
    input: DeleteSiteSettingProfileFieldInput
}

export type MutationDeleteSiteSettingProfileFieldValidatorArgs = {
    input: DeleteSiteSettingProfileFieldValidatorInput
}

export type MutationDeleteSubgroupArgs = {
    input: DeleteSubgroupInput
}

export type MutationDeleteTagCategoryArgs = {
    keepTags?: InputMaybe<Scalars['Boolean']['input']>
    name: Scalars['String']['input']
}

export type MutationDeleteTagCategoryTagArgs = {
    keepTag?: InputMaybe<Scalars['Boolean']['input']>
    name: Scalars['String']['input']
    value: Scalars['String']['input']
}

export type MutationDeleteTagCollectionArgs = {
    input: DeleteTagCollectionInput
}

export type MutationDeleteUsersArgs = {
    input: DeleteUsersInput
}

export type MutationEditChatArgs = {
    input: EditChatInput
}

export type MutationEditChatMessageArgs = {
    input: EditChatMessageInput
}

export type MutationEditCustomContentTypeArgs = {
    input: CustomContentTypeInput
}

export type MutationEditDatahubExternalContentSourceArgs = {
    input: UpdateDatahubContentSourceInput
}

export type MutationEditEmailAccessRequestArgs = {
    input: EditEmailAccessRequestInput
}

export type MutationEditEmailOverviewArgs = {
    input: EditEmailOverviewInput
}

export type MutationEditEntityArgs = {
    input: EditEntityInput
}

export type MutationEditEntityBulkArgs = {
    guids: Array<Scalars['String']['input']>
    input: EditEntityBulkInput
}

export type MutationEditEpisodeArgs = {
    input: EditEpisodeInput
}

export type MutationEditEventAttendeeArgs = {
    input: EditEventAttendeeInput
}

export type MutationEditFileFolderArgs = {
    input: EditFileFolderInput
}

export type MutationEditFileVersionCommentArgs = {
    input: EditFileVersionCommentInput
}

export type MutationEditGroupArgs = {
    input: EditGroupInput
}

export type MutationEditGroupNotificationsArgs = {
    input: EditGroupNotificationsInput
}

export type MutationEditNotificationsArgs = {
    input: EditNotificationsInput
}

export type MutationEditPadArgs = {
    coauthors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    input: EditPadInput
}

export type MutationEditPageArgs = {
    input: EditPageInput
}

export type MutationEditPodcastArgs = {
    input: EditPodcastInput
}

export type MutationEditPollArgs = {
    input: EditPollInput
}

export type MutationEditProfileFieldArgs = {
    input: EditProfileFieldInput
}

export type MutationEditSiteSettingArgs = {
    input: EditSiteSettingInput
}

export type MutationEditSiteSettingProfileFieldArgs = {
    input: EditSiteSettingProfileFieldInput
}

export type MutationEditSiteSettingProfileFieldValidatorArgs = {
    input: EditSiteSettingProfileFieldValidatorInput
}

export type MutationEditSubgroupArgs = {
    input: EditSubgroupInput
}

export type MutationEditTagCollectionArgs = {
    input: EditTagCollectionInput
}

export type MutationEditTaskArgs = {
    input: EditTaskInput
}

export type MutationEditTaskStateArgs = {
    input: EditTaskStateInput
}

export type MutationEditUserNameArgs = {
    input: EditUserNameInput
}

export type MutationEditUsersArgs = {
    input: EditUsersInput
}

export type MutationExtendTagCategoryArgs = {
    input: MutateTagCategoryTagInput
    name: Scalars['String']['input']
}

export type MutationExtractTagSynonymArgs = {
    input: TagMergeInput
}

export type MutationFollowArgs = {
    input: FollowInput
}

export type MutationHandleDeleteAccountRequestArgs = {
    input: HandleDeleteAccountRequestInput
}

export type MutationHandleSiteAccessRequestArgs = {
    input: HandleSiteAccessRequestInput
}

export type MutationImportUsersStep1Args = {
    input: ImportUsersStep1Input
}

export type MutationImportUsersStep2Args = {
    input: ImportUsersStep2Input
}

export type MutationInitiateVideocallArgs = {
    userGuid: Scalars['String']['input']
}

export type MutationInviteToEventArgs = {
    input: InviteToEventInput
}

export type MutationInviteToGroupArgs = {
    input: InviteToGroupInput
}

export type MutationInviteToSiteArgs = {
    input: InviteToSiteInput
}

export type MutationJoinGroupArgs = {
    input: JoinGroupInput
}

export type MutationLeaveGroupArgs = {
    input: LeaveGroupInput
}

export type MutationLockFileArgs = {
    input: LockFileInput
}

export type MutationMarkAllAsReadArgs = {
    input: MarkAllAsReadInput
}

export type MutationMarkAsReadArgs = {
    input: MarkAsReadInput
}

export type MutationMergeTagsArgs = {
    input: TagMergeInput
}

export type MutationMoveFileFolderArgs = {
    input: MoveFileFolderInput
}

export type MutationOverwriteSiteOwnerArgs = {
    input: OverwriteSiteOwnerInput
}

export type MutationRejectCommentArgs = {
    guid: Scalars['String']['input']
}

export type MutationRejectMembershipRequestArgs = {
    input: RejectMembershipRequestInput
}

export type MutationRejectPublishRequestArgs = {
    guid: Scalars['String']['input']
}

export type MutationRemoveGroupMembersArgs = {
    input: RemoveGroupMembersInput
}

export type MutationRemoveProfileSetManagerArgs = {
    profileSetGuid: Scalars['String']['input']
    userGuid: Scalars['String']['input']
}

export type MutationRemoveUserContactArgs = {
    input: RemoveUserContactInput
}

export type MutationReorderArgs = {
    input: ReorderInput
}

export type MutationRequestContentExportArgs = {
    input: RequestContentExportInput
}

export type MutationResendGroupInvitationArgs = {
    input: ResendGroupInvitationInput
}

export type MutationResetCommentModerationRequestArgs = {
    guid: Scalars['String']['input']
}

export type MutationResetPublishRequestArgs = {
    guid: Scalars['String']['input']
}

export type MutationRestoreCooldownContentArgs = {
    input?: InputMaybe<RestoreCooldownContentInput>
}

export type MutationRevokeInviteToSiteArgs = {
    input: RevokeInviteToSiteInput
}

export type MutationScheduleAppointmentArgs = {
    input: ScheduleAppointmentInput
}

export type MutationScheduleBanUsersArgs = {
    input: ScheduleBanUsersInput
}

export type MutationSendMessageToEventArgs = {
    input: SendMessageToEventInput
}

export type MutationSendMessageToFollowersArgs = {
    input: SendMessageToFollowersInput
}

export type MutationSendMessageToGroupArgs = {
    input: SendMessageToGroupInput
}

export type MutationSendMessageToUserArgs = {
    input: SendMessageToUserInput
}

export type MutationSetUserOnlineStatusArgs = {
    input: SetUserOnlineStatusInput
}

export type MutationSignSiteAgreementVersionArgs = {
    input: SignSiteAgreementVersionInput
}

export type MutationToggleBestAnswerArgs = {
    input: ToggleBestAnswerInput
}

export type MutationToggleChatReactionArgs = {
    input: ToggleChatReactionInput
}

export type MutationToggleEntityArchivedArgs = {
    guid: Scalars['String']['input']
}

export type MutationToggleEntityIsPinnedArgs = {
    input: ToggleEntityIsPinnedInput
}

export type MutationToggleGroupMemberRoleArgs = {
    input: ToggleGroupMemberRoleInput
}

export type MutationToggleIsClosedArgs = {
    input: ToggleIsClosedInput
}

export type MutationToggleRequestDeleteUserArgs = {
    input: ToggleRequestDeleteUserInput
}

export type MutationToggleUserRoleArgs = {
    input: ToggleUserRoleInput
}

export type MutationUpdateAttendEventStateArgs = {
    input: UpdateAttendEventStateInput
}

export type MutationUpdateIntelligentSearchAnswerArgs = {
    input?: InputMaybe<UpdateIntelligentSearchAnswerInput>
}

export type MutationUpdateMembershipFavoriteArgs = {
    input: UpdateMembershipFavoriteInput
}

export type MutationUpdateQaPairArgs = {
    input: UpdateQaPairInput
}

export type MutationUpdateRevisionArgs = {
    input: UpdateRevisionInput
}

export type MutationUpdateTagCategoryArgs = {
    input: MutateTagCategoryInput
    name: Scalars['String']['input']
}

export type MutationUpdateTagCategoryTagArgs = {
    input: MutateTagCategoryTagInput
    name: Scalars['String']['input']
    value: Scalars['String']['input']
}

export type MutationUpdateUserContactFavoriteArgs = {
    input: UpdateUserContactFavoriteInput
}

export type MutationUpdateUserWidgetSettingsArgs = {
    input: UserWidgetSettingsInput
}

export type MutationVoteArgs = {
    input: VoteInput
}

export type MutationVoteOnPollArgs = {
    input: VoteOnPollInput
}

export type News = Entity & {
    __typename: 'News'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    backgroundColor: Maybe<Scalars['String']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    canVote: Maybe<Scalars['Boolean']['output']>
    commentCount: Maybe<Scalars['Int']['output']>
    comments: Maybe<Array<Maybe<Comment>>>
    description: Maybe<Scalars['String']['output']>
    endDate: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    featured: Maybe<Featured>
    flowAttachments: Maybe<Array<Maybe<File>>>
    followers: Maybe<FollowersList>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasVoted: Maybe<Scalars['Int']['output']>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isBestAnswer: Maybe<Scalars['Boolean']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isFollowing: Maybe<Scalars['Boolean']['output']>
    isHighlighted: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localAbstract: Maybe<Scalars['String']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    publishRequest: Maybe<PublishRequest>
    revision: Maybe<Revision>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    source: Maybe<Scalars['String']['output']>
    startDate: Maybe<Scalars['String']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    suggestedItems: Maybe<Array<Maybe<Entity>>>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    votes: Maybe<Scalars['Int']['output']>
    votingUsers: Maybe<UserList>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type NewsCommentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type NewsFollowersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
}

export type NewsVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type Notification = {
    __typename: 'Notification'
    action: Maybe<Scalars['String']['output']>
    container: Maybe<Entity>
    customMessage: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    entity: Maybe<Entity>
    id: Maybe<Scalars['Int']['output']>
    isUnread: Maybe<Scalars['Boolean']['output']>
    performer: Maybe<User>
    timeCreated: Maybe<Scalars['DateTime']['output']>
}

export enum NotificationContentType {
    Blog = 'blog',
    Discussion = 'discussion',
    Episode = 'episode',
    Event = 'event',
    News = 'news',
    Page = 'page',
    Podcast = 'podcast',
    Question = 'question',
    Task = 'task',
    Wiki = 'wiki',
}

export type NotificationsList = {
    __typename: 'NotificationsList'
    edges: Maybe<Array<Maybe<Notification>>>
    total: Maybe<Scalars['Int']['output']>
    totalUnread: Maybe<Scalars['Int']['output']>
}

export type OnboardingProfileFieldInput = {
    guid: Scalars['String']['input']
    isMandatory: Scalars['Boolean']['input']
}

export type OpenGraphMetaData = {
    __typename: 'OpenGraphMetaData'
    description: Maybe<Scalars['String']['output']>
    image: Maybe<Scalars['String']['output']>
    site_name: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    type: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    video: Maybe<Scalars['String']['output']>
}

export type Option = {
    __typename: 'Option'
    label: Maybe<Scalars['String']['output']>
    value: Scalars['String']['output']
}

export type OptionInteger = {
    __typename: 'OptionInteger'
    label: Maybe<Scalars['String']['output']>
    value: Scalars['Int']['output']
}

export enum OrderBy {
    ContentType = 'contentType',
    FileSize = 'fileSize',
    GroupName = 'groupName',
    LastAction = 'lastAction',
    LastSeen = 'lastSeen',
    OwnerName = 'ownerName',
    ReadAccess = 'readAccess',
    StartDate = 'startDate',
    TimeCreated = 'timeCreated',
    TimePublished = 'timePublished',
    TimeUpdated = 'timeUpdated',
    Title = 'title',
}

export enum OrderDirection {
    Asc = 'asc',
    Desc = 'desc',
}

export type OverwriteSiteOwnerInput = {
    siteOwnerEmail?: InputMaybe<Scalars['String']['input']>
    siteOwnerName?: InputMaybe<Scalars['String']['input']>
}

export type Pad = Entity &
    FileFolder & {
        __typename: 'Pad'
        accessId: Maybe<Scalars['Int']['output']>
        canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
        canBookmark: Maybe<Scalars['Boolean']['output']>
        canComment: Maybe<Scalars['Boolean']['output']>
        canEdit: Scalars['Boolean']['output']
        canVote: Maybe<Scalars['Boolean']['output']>
        commentCount: Maybe<Scalars['Int']['output']>
        comments: Maybe<Array<Maybe<Comment>>>
        container: Maybe<Entity>
        description: Maybe<Scalars['String']['output']>
        downloadAsOptions: Maybe<Array<Maybe<DownloadAsOption>>>
        excerpt: Maybe<Scalars['String']['output']>
        featured: Maybe<Featured>
        group: Maybe<Group>
        guid: Scalars['String']['output']
        hasVoted: Maybe<Scalars['Int']['output']>
        inGroup: Maybe<Scalars['Boolean']['output']>
        inputLanguage: Maybe<Scalars['String']['output']>
        isBookmarked: Maybe<Scalars['Boolean']['output']>
        isFeatured: Maybe<Scalars['Boolean']['output']>
        isFollowing: Maybe<Scalars['Boolean']['output']>
        isHighlighted: Maybe<Scalars['Boolean']['output']>
        isPersonalFile: Maybe<Scalars['Boolean']['output']>
        isPinned: Scalars['Boolean']['output']
        isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
        isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
        jwtToken: Maybe<Scalars['String']['output']>
        localDescription: Maybe<Scalars['String']['output']>
        localExcerpt: Maybe<Scalars['String']['output']>
        localRichDescription: Maybe<Scalars['String']['output']>
        localTitle: Maybe<Scalars['String']['output']>
        metaData: Maybe<MetaData>
        openGraphMetaData: Maybe<OpenGraphMetaData>
        owner: Maybe<User>
        parentFolder: Maybe<Folder>
        referenceCount: Maybe<Scalars['Int']['output']>
        references: Maybe<Array<Maybe<FileReference>>>
        richDescription: Maybe<Scalars['SecureRichText']['output']>
        rootContainer: Maybe<Entity>
        scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
        scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
        showOwner: Maybe<Scalars['Boolean']['output']>
        size: Maybe<Scalars['Int']['output']>
        state: Maybe<Scalars['String']['output']>
        status: Maybe<Scalars['Int']['output']>
        statusPublished: Maybe<StatusPublished>
        subtype: Maybe<Scalars['String']['output']>
        tagCategories: Maybe<Array<Maybe<TagCategory>>>
        tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
        timeCreated: Maybe<Scalars['DateTime']['output']>
        timePublished: Maybe<Scalars['DateTime']['output']>
        timeUpdated: Maybe<Scalars['DateTime']['output']>
        title: Maybe<Scalars['String']['output']>
        url: Maybe<Scalars['String']['output']>
        views: Maybe<Scalars['Int']['output']>
        votes: Maybe<Scalars['Int']['output']>
        votingUsers: Maybe<UserList>
        writeAccessId: Maybe<Scalars['Int']['output']>
    }

export type PadVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type Page = Entity & {
    __typename: 'Page'
    accessControl: Maybe<Array<Maybe<AccessItem>>>
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canEdit: Maybe<Scalars['Boolean']['output']>
    children: Maybe<Array<Maybe<Page>>>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasChildren: Maybe<Scalars['Boolean']['output']>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    menu: Maybe<PageMenu>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    pageType: Maybe<Scalars['String']['output']>
    parent: Maybe<Page>
    preventDeleteAndArchive: Maybe<Scalars['Boolean']['output']>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    rootParent: Maybe<Page>
    rows: Maybe<Array<Maybe<Row>>>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showNavigation: Scalars['Boolean']['output']
    showOwner: Maybe<Scalars['Boolean']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    urlSlug: Maybe<Scalars['String']['output']>
}

export type PageMenu = {
    __typename: 'PageMenu'
    children: Maybe<Array<Maybe<PageMenu>>>
    guid: Maybe<Scalars['String']['output']>
    link: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
}

export type PageTagFilter = {
    __typename: 'PageTagFilter'
    contentType: Maybe<Scalars['String']['output']>
    showAllTagCategories: Maybe<Scalars['Boolean']['output']>
    showTagCategories: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type PageTagFilterInput = {
    contentType: Scalars['String']['input']
    showAllTagCategories?: InputMaybe<Scalars['Boolean']['input']>
    showTagCategories?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
}

export enum PageType {
    Campagne = 'campagne',
    Text = 'text',
}

export type Podcast = Entity & {
    __typename: 'Podcast'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    authors: Maybe<Array<Maybe<PodcastAuthor>>>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    canVote: Maybe<Scalars['Boolean']['output']>
    description: Maybe<Scalars['String']['output']>
    episodes: Maybe<EpisodeList>
    excerpt: Maybe<Scalars['String']['output']>
    followers: Maybe<FollowersList>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasVoted: Maybe<Scalars['Int']['output']>
    icon: Maybe<File>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isFollowing: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localAbstract: Maybe<Scalars['String']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    publishRequest: Maybe<PublishRequest>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    rssUrl: Maybe<Scalars['String']['output']>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    suggestedItems: Maybe<Array<Maybe<Entity>>>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    votes: Maybe<Scalars['Int']['output']>
    votingUsers: Maybe<UserList>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type PodcastEpisodesArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<SearchOrderBy>
    orderDirection?: InputMaybe<OrderDirection>
}

export type PodcastFollowersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
}

export type PodcastVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type PodcastAuthor = {
    __typename: 'PodcastAuthor'
    name: Maybe<Scalars['String']['output']>
}

export type PodcastAuthorInput = {
    name?: InputMaybe<Scalars['String']['input']>
}

export type PodcastPayload = {
    __typename: 'PodcastPayload'
    podcast: Maybe<Podcast>
    success: Maybe<Scalars['Boolean']['output']>
}

export type Poll = Entity & {
    __typename: 'Poll'
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canVote: Scalars['Boolean']['output']
    choices: Maybe<Array<Maybe<PollChoice>>>
    guid: Scalars['String']['output']
    hasVoted: Maybe<Scalars['Int']['output']>
    isPinned: Scalars['Boolean']['output']
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    voteWithoutAccount: Scalars['Boolean']['output']
}

export type PollChoice = {
    __typename: 'PollChoice'
    guid: Scalars['String']['output']
    text: Maybe<Scalars['String']['output']>
    uuid: Scalars['String']['output']
    votes: Maybe<Scalars['Int']['output']>
}

export type ProfileFieldValidator = {
    __typename: 'ProfileFieldValidator'
    id: Scalars['String']['output']
    name: Scalars['String']['output']
    type: ProfileFieldValidatorType
    validationList: Maybe<Array<Maybe<Scalars['String']['output']>>>
    validationString: Maybe<Scalars['String']['output']>
}

export type ProfileFieldValidatorInput = {
    name: Scalars['String']['input']
    type: ProfileFieldValidatorType
    validationListFile?: InputMaybe<Scalars['Upload']['input']>
    validationString?: InputMaybe<Scalars['String']['input']>
}

export enum ProfileFieldValidatorType {
    InList = 'inList',
}

export type ProfileItem = {
    __typename: 'ProfileItem'
    accessId: Maybe<Scalars['Int']['output']>
    autocomplete: Maybe<Scalars['String']['output']>
    category: Maybe<Scalars['String']['output']>
    fieldOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>
    fieldType: Maybe<Scalars['String']['output']>
    guid: Scalars['String']['output']
    isEditable: Maybe<Scalars['Boolean']['output']>
    isFilter: Maybe<Scalars['Boolean']['output']>
    isFilterable: Maybe<Scalars['Boolean']['output']>
    isInAdminOverview: Maybe<Scalars['Boolean']['output']>
    isInAutoGroupMembership: Maybe<Scalars['Boolean']['output']>
    isInOnboarding: Maybe<Scalars['Boolean']['output']>
    isInOverview: Maybe<Scalars['Boolean']['output']>
    isMandatory: Maybe<Scalars['Boolean']['output']>
    isOnVcard: Maybe<Scalars['Boolean']['output']>
    key: Scalars['String']['output']
    name: Scalars['String']['output']
    profileFieldValidator: Maybe<ProfileFieldValidator>
    value: Maybe<Scalars['String']['output']>
}

export type ProfileItemInput = {
    isFilter: Scalars['Boolean']['input']
    isInAdminOverview?: InputMaybe<Scalars['Boolean']['input']>
    isInAutoGroupMembership?: InputMaybe<Scalars['Boolean']['input']>
    isInOverview?: InputMaybe<Scalars['Boolean']['input']>
    isOnVcard?: InputMaybe<Scalars['Boolean']['input']>
    key: Scalars['String']['input']
    name: Scalars['String']['input']
}

export type ProfileSection = {
    __typename: 'ProfileSection'
    name: Scalars['String']['output']
    profileFieldGuids: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type ProfileSectionInput = {
    name: Scalars['String']['input']
    profileFieldGuids?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
}

export type ProfileSet = {
    __typename: 'ProfileSet'
    field: Maybe<ProfileItem>
    id: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
}

export type ProfileSetManagerPayload = {
    __typename: 'ProfileSetManagerPayload'
    profileSet: Maybe<ProfileSet>
    user: Maybe<User>
}

export type ProfileSyncLog = {
    __typename: 'ProfileSyncLog'
    content: Scalars['String']['output']
    timeCreated: Maybe<Scalars['DateTime']['output']>
    uuid: Scalars['String']['output']
}

export type ProfileSyncLogList = {
    __typename: 'ProfileSyncLogList'
    edges: Maybe<Array<Maybe<ProfileSyncLog>>>
    total: Scalars['Int']['output']
}

export type PublishRequest = {
    __typename: 'PublishRequest'
    assignedTo: Maybe<User>
    author: Maybe<User>
    entity: Maybe<Entity>
    guid: Maybe<Scalars['String']['output']>
    publishedAt: Maybe<Scalars['DateTime']['output']>
    status: Maybe<PublishRequestStatusEnum>
}

export type PublishRequestMutationPayload = {
    __typename: 'PublishRequestMutationPayload'
    node: Maybe<PublishRequest>
    success: Maybe<Scalars['Boolean']['output']>
}

export enum PublishRequestStatusEnum {
    Assigned = 'assigned',
    Open = 'open',
    Published = 'published',
}

export type PublishRequestsPayload = {
    __typename: 'PublishRequestsPayload'
    edges: Maybe<Array<Maybe<PublishRequest>>>
    total: Maybe<Scalars['Int']['output']>
}

export type Query = {
    __typename: 'Query'
    activities: Maybe<ActivityList>
    appointmentData: Maybe<AppointmentDataPayload>
    appointmentTimes: Maybe<Array<Maybe<AppointmentTimes>>>
    bookmarks: Maybe<EntityList>
    breadcrumb: Maybe<Array<Maybe<Entity>>>
    brokenLinks: Maybe<BrokenLinkList>
    chat: Maybe<Chat>
    chats: Maybe<ChatList>
    commentModerationRequests: Maybe<CommentModerationRequestsPayload>
    contentSnapshots: Maybe<ContentSnapshotPayload>
    cooldownContent: Maybe<CooldownContentList>
    entities: Maybe<EntityList>
    entity: Maybe<Entity>
    entitySlugSuggestion: Maybe<EntitySlugSuggestionPayload>
    events: Maybe<EventList>
    exportRequests: Maybe<ExportRequestsPayload>
    externalContentSources: Maybe<ExternalContentSourcePayload>
    externalSearch: Maybe<ExternalSearchList>
    fetchRssEndpoint: Maybe<RssEndpointPayload>
    fetchVideoMetadata: Maybe<FetchVideoMetadataPayload>
    files: Maybe<EntityList>
    filters: Maybe<Filters>
    groups: Maybe<GroupList>
    intelligentSearchQAPairs: Maybe<IntelligentSearchQaPairList>
    intelligentSearchQuestion: Maybe<IntelligentSearchQuestionResult>
    intelligentSearchQuestions: Maybe<IntelligentSearchQuestionsResult>
    members: Maybe<MemberList>
    moodleCourses: Maybe<MoodleCoursesPayload>
    notifications: Maybe<NotificationsList>
    profileSyncLogs: Maybe<ProfileSyncLogList>
    publishRequests: Maybe<PublishRequestsPayload>
    recommended: Maybe<EntityList>
    revisions: Maybe<RevisionList>
    search: Maybe<SearchList>
    searchJournal: Maybe<SearchJournal>
    site: Maybe<Site>
    siteAgreements: Maybe<Array<Maybe<SiteAgreement>>>
    siteCustomAgreements: Maybe<Array<Maybe<SiteCustomAgreement>>>
    siteSettings: Maybe<SiteSettings>
    siteStats: Maybe<SiteStats>
    siteUsers: Maybe<SiteUserList>
    tagCollections: Maybe<Array<Maybe<TagCollection>>>
    tags: Maybe<Array<Maybe<Tag>>>
    testRssEndpoint: Maybe<TestRssEndpointPayload>
    top: Maybe<Array<Maybe<TopItem>>>
    trending: Maybe<Array<Maybe<TrendingList>>>
    users: Maybe<UserList>
    usersByBirthDate: Maybe<SiteUserList>
    videoCall: Maybe<VideoCall>
    viewer: Maybe<Viewer>
}

export type QueryActivitiesArgs = {
    attendeeGuid?: InputMaybe<Scalars['String']['input']>
    containerGuid?: InputMaybe<Scalars['String']['input']>
    eventFilter?: InputMaybe<EventFilter>
    groupFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    limit?: InputMaybe<Scalars['Int']['input']>
    matchStrategy?: InputMaybe<MatchStrategy>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<OrderBy>
    orderDirection?: InputMaybe<OrderDirection>
    sortPinned?: InputMaybe<Scalars['Boolean']['input']>
    statusPublished?: InputMaybe<Array<InputMaybe<StatusPublished>>>
    subtypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    userGuid?: InputMaybe<Scalars['String']['input']>
}

export type QueryAppointmentTimesArgs = {
    agendaId: Scalars['String']['input']
    appointmentTypeId: Scalars['String']['input']
    endDate?: InputMaybe<Scalars['DateTime']['input']>
    startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type QueryBookmarksArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    subtype?: InputMaybe<Scalars['String']['input']>
}

export type QueryBreadcrumbArgs = {
    guid?: InputMaybe<Scalars['String']['input']>
}

export type QueryBrokenLinksArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type QueryChatArgs = {
    chatGuid?: InputMaybe<Scalars['String']['input']>
    chatMessageGuid?: InputMaybe<Scalars['String']['input']>
}

export type QueryChatsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    type?: InputMaybe<ChatTypeFilter>
    unread?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCommentModerationRequestsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    status?: InputMaybe<CommentModerationStatusEnum>
    userGuid?: InputMaybe<Scalars['String']['input']>
}

export type QueryCooldownContentArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type QueryEntitiesArgs = {
    containerGuid?: InputMaybe<Scalars['String']['input']>
    eventFilter?: InputMaybe<EventFilter>
    fileFilter?: InputMaybe<FileFilter>
    groupFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    isFeatured?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    matchStrategy?: InputMaybe<MatchStrategy>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<OrderBy>
    orderDirection?: InputMaybe<OrderDirection>
    parentGuid?: InputMaybe<Scalars['String']['input']>
    q?: InputMaybe<Scalars['String']['input']>
    sortPinned?: InputMaybe<Scalars['Boolean']['input']>
    statusPublished?: InputMaybe<Array<InputMaybe<StatusPublished>>>
    subtype?: InputMaybe<Scalars['String']['input']>
    subtypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    userGuid?: InputMaybe<Scalars['String']['input']>
}

export type QueryEntityArgs = {
    guid?: InputMaybe<Scalars['String']['input']>
    incrementViewCount?: InputMaybe<Scalars['Boolean']['input']>
    urlSlug?: InputMaybe<Scalars['String']['input']>
    username?: InputMaybe<Scalars['String']['input']>
}

export type QueryEntitySlugSuggestionArgs = {
    guid?: InputMaybe<Scalars['String']['input']>
    title?: InputMaybe<Scalars['NonEmptyString']['input']>
    urlSlug?: InputMaybe<Scalars['String']['input']>
}

export type QueryEventsArgs = {
    attendeeGuid?: InputMaybe<Scalars['String']['input']>
    containerGuid?: InputMaybe<Scalars['String']['input']>
    filter?: InputMaybe<EventFilter>
    limit?: InputMaybe<Scalars['Int']['input']>
    matchStrategy?: InputMaybe<MatchStrategy>
    offset?: InputMaybe<Scalars['Int']['input']>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryExportRequestsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    status?: InputMaybe<ExportRequestStatusEnum>
}

export type QueryExternalContentSourcesArgs = {
    handler: ExternalContentSourceHandlerEnum
}

export type QueryExternalSearchArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
    searchId?: InputMaybe<Scalars['String']['input']>
}

export type QueryFetchRssEndpointArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    url: Scalars['String']['input']
}

export type QueryFetchVideoMetadataArgs = {
    input: FetchVideoMetadataInput
}

export type QueryFilesArgs = {
    containerGuid?: InputMaybe<Scalars['String']['input']>
    fileFilter?: InputMaybe<FileFilter>
    filterBookmarks?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<Scalars['String']['input']>
    orderDirection?: InputMaybe<Scalars['String']['input']>
    typeFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryGroupsArgs = {
    filter?: InputMaybe<GroupFilter>
    isFavorite?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    matchStrategy?: InputMaybe<MatchStrategy>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    userGuid?: InputMaybe<Scalars['String']['input']>
}

export type QueryIntelligentSearchQaPairsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type QueryIntelligentSearchQuestionArgs = {
    guid: Scalars['String']['input']
}

export type QueryIntelligentSearchQuestionsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMembersArgs = {
    filters?: InputMaybe<Array<InputMaybe<FilterInput>>>
    groupGuid: Scalars['String']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    online?: InputMaybe<Scalars['Boolean']['input']>
    orderBy?: InputMaybe<GroupMemberOrderBy>
    orderDirection?: InputMaybe<OrderDirection>
    q?: InputMaybe<Scalars['String']['input']>
    roleFilter?: InputMaybe<GroupRoleFilter>
}

export type QueryNotificationsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    unread?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryProfileSyncLogsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPublishRequestsArgs = {
    files?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    status?: InputMaybe<PublishRequestStatusEnum>
    userGuid?: InputMaybe<Scalars['String']['input']>
}

export type QueryRecommendedArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type QueryRevisionsArgs = {
    containerGuid: Scalars['String']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type QuerySearchArgs = {
    containerGuid?: InputMaybe<Scalars['String']['input']>
    dateFrom?: InputMaybe<Scalars['String']['input']>
    dateTo?: InputMaybe<Scalars['String']['input']>
    filterArchived?: InputMaybe<Scalars['Boolean']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    matchStrategy?: InputMaybe<MatchStrategy>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<SearchOrderBy>
    orderDirection?: InputMaybe<OrderDirection>
    ownerGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    q?: InputMaybe<Scalars['String']['input']>
    searchRelatedSites?: InputMaybe<Scalars['Boolean']['input']>
    subtype?: InputMaybe<Scalars['String']['input']>
    subtypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    type?: InputMaybe<Type>
}

export type QuerySearchJournalArgs = {
    dateTimeFrom?: InputMaybe<Scalars['DateTime']['input']>
    dateTimeTo?: InputMaybe<Scalars['DateTime']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type QuerySiteUsersArgs = {
    banReason?: InputMaybe<Scalars['String']['input']>
    filterScheduledForBan?: InputMaybe<UserBanScheduledFilter>
    groupGuid?: InputMaybe<Scalars['String']['input']>
    isAutoBan?: InputMaybe<Scalars['Boolean']['input']>
    isBanned?: InputMaybe<Scalars['Boolean']['input']>
    isDeleteRequested?: InputMaybe<Scalars['Boolean']['input']>
    lastOnlineBefore?: InputMaybe<Scalars['String']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    memberSince?: InputMaybe<Scalars['DateTime']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    orderBy?: InputMaybe<SiteUsersOrderBy>
    orderByProfileFieldKey?: InputMaybe<Scalars['String']['input']>
    orderDirection?: InputMaybe<OrderDirection>
    q?: InputMaybe<Scalars['String']['input']>
    role?: InputMaybe<Scalars['String']['input']>
}

export type QueryTestRssEndpointArgs = {
    groupGuid?: InputMaybe<Scalars['String']['input']>
    url: Scalars['String']['input']
}

export type QueryUsersArgs = {
    contactsGuid?: InputMaybe<Scalars['String']['input']>
    filterFavoriteContacts?: InputMaybe<Scalars['Boolean']['input']>
    filters?: InputMaybe<Array<InputMaybe<FilterInput>>>
    groupGuid?: InputMaybe<Scalars['String']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    profileSetGuid?: InputMaybe<Scalars['String']['input']>
    q: Scalars['String']['input']
}

export type QueryUsersByBirthDateArgs = {
    futureDays?: InputMaybe<Scalars['Int']['input']>
    groupGuid?: InputMaybe<Scalars['String']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    profileFieldGuid: Scalars['String']['input']
    users?: InputMaybe<UserScope>
}

export type QueryVideoCallArgs = {
    guid: Scalars['String']['input']
}

export type Question = Entity & {
    __typename: 'Question'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canChooseBestAnswer: Maybe<Scalars['Boolean']['output']>
    canClose: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    canVote: Maybe<Scalars['Boolean']['output']>
    commentCount: Maybe<Scalars['Int']['output']>
    comments: Maybe<Array<Maybe<Comment>>>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    featured: Maybe<Featured>
    flowAttachments: Maybe<Array<Maybe<File>>>
    followers: Maybe<FollowersList>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasVoted: Maybe<Scalars['Int']['output']>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isBestAnswer: Maybe<Scalars['Boolean']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isClosed: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isFollowing: Maybe<Scalars['Boolean']['output']>
    isHighlighted: Maybe<Scalars['Boolean']['output']>
    isLocked: Scalars['Boolean']['output']
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localAbstract: Maybe<Scalars['String']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    publishRequest: Maybe<PublishRequest>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    suggestedItems: Maybe<Array<Maybe<Entity>>>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    votes: Maybe<Scalars['Int']['output']>
    votingUsers: Maybe<UserList>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type QuestionCommentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type QuestionFollowersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
    q?: InputMaybe<Scalars['String']['input']>
}

export type QuestionVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export enum RecommendedTypeEnum {
    Certified = 'certified',
    Recommended = 'recommended',
}

export enum RecursiveDeleteOption {
    ForceDelete = 'forceDelete',
    SoftDelete = 'softDelete',
    TryDelete = 'tryDelete',
}

export type Redirect = {
    __typename: 'Redirect'
    destination: Scalars['String']['output']
    source: Scalars['String']['output']
}

export type RedirectInput = {
    destination: Scalars['String']['input']
    source: Scalars['String']['input']
}

export type RefreshUserLastOnlinePayload = {
    __typename: 'RefreshUserLastOnlinePayload'
    success: Maybe<Scalars['Boolean']['output']>
    user: Maybe<User>
}

export type RejectMembershipRequestPayload = {
    __typename: 'RejectMembershipRequestPayload'
    group: Maybe<Group>
}

export type RelatedSiteSearchResult = {
    __typename: 'RelatedSiteSearchResult'
    download: Maybe<Scalars['String']['output']>
    endDate: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    guid: Scalars['String']['output']
    mimeType: Maybe<Scalars['String']['output']>
    siteName: Maybe<Scalars['String']['output']>
    siteUrl: Maybe<Scalars['String']['output']>
    startDate: Maybe<Scalars['String']['output']>
    status: Maybe<Scalars['Int']['output']>
    subtype: Maybe<Scalars['String']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
}

export type RemoveGroupMembersPayload = {
    __typename: 'RemoveGroupMembersPayload'
    group: Maybe<Group>
}

export type RemoveUserContactInput = {
    userGuid: Scalars['String']['input']
}

export type RemoveUserContactPayload = {
    __typename: 'RemoveUserContactPayload'
    success: Maybe<Scalars['Boolean']['output']>
    user: Maybe<User>
}

export type RequestContentExportInput = {
    contentTypes?: InputMaybe<Array<InputMaybe<ExportContentTypeInput>>>
    purpose?: InputMaybe<Scalars['String']['input']>
    successUrl?: InputMaybe<Scalars['String']['input']>
}

export type RequestContentExportPayload = {
    __typename: 'RequestContentExportPayload'
    exportRequest: Maybe<ExportRequest>
}

export enum Require2FaLevelEnum {
    Admin = 'admin',
    All = 'all',
    None = 'none',
}

export type ResendGroupInvitationPayload = {
    __typename: 'ResendGroupInvitationPayload'
    group: Maybe<Group>
}

export type RestoreCooldownContentPayload = {
    __typename: 'RestoreCooldownContentPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type Revision = {
    __typename: 'Revision'
    authors: Maybe<Array<Maybe<User>>>
    changedFields: Maybe<Array<Maybe<Scalars['String']['output']>>>
    container: Maybe<Entity>
    content: Maybe<ContentVersion>
    description: Maybe<Scalars['String']['output']>
    guid: Maybe<Scalars['String']['output']>
    originalContent: Maybe<ContentVersion>
    statusPublishedChanged: Maybe<StatusPublished>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    type: Maybe<RevisionType>
}

export type RevisionList = {
    __typename: 'RevisionList'
    edges: Maybe<Array<Maybe<Revision>>>
    total: Scalars['Int']['output']
}

export enum RevisionType {
    Create = 'create',
    Update = 'update',
}

export type RevokeInviteToSitePayload = {
    __typename: 'RevokeInviteToSitePayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export enum RichTextEditorFeatureEnum {
    AllowTextCssClasses = 'allowTextCssClasses',
}

export enum Role {
    Admin = 'admin',
    NewsEditor = 'newsEditor',
}

export type Row = {
    __typename: 'Row'
    backgroundColor: Maybe<Scalars['String']['output']>
    columns: Maybe<Array<Maybe<Column>>>
    isFullWidth: Maybe<Scalars['Boolean']['output']>
}

export type RssEndpointPayload = {
    __typename: 'RssEndpointPayload'
    edges: Maybe<Array<Maybe<RssItem>>>
    total: Maybe<Scalars['Int']['output']>
}

export type RssItem = {
    __typename: 'RssItem'
    description: Maybe<Scalars['String']['output']>
    guid: Maybe<Scalars['String']['output']>
    link: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type ScheduleAppointmentInput = {
    agendaId: Scalars['String']['input']
    appointmentTypeId: Scalars['String']['input']
    attendee: AppointmentAttendeeInput
    endDateTime: Scalars['DateTime']['input']
    startDateTime: Scalars['DateTime']['input']
}

export type ScheduleAppointmentPayload = {
    __typename: 'ScheduleAppointmentPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type ScheduleBanUsersPayload = {
    __typename: 'ScheduleBanUsersPayload'
    users: Maybe<Array<Maybe<User>>>
}

export enum SearchArchiveOptionEnum {
    Admin = 'admin',
    Authenticated = 'authenticated',
    Editor = 'editor',
    Everyone = 'everyone',
    Nobody = 'nobody',
}

export type SearchFilter = {
    __typename: 'SearchFilter'
    contentTypes: Maybe<Array<Maybe<KeyValueItem>>>
}

export type SearchJournal = {
    __typename: 'SearchJournal'
    edges: Maybe<Array<Maybe<SearchJournalSummary>>>
    total: Maybe<Scalars['Int']['output']>
}

export type SearchJournalSummary = {
    __typename: 'SearchJournalSummary'
    count: Maybe<Scalars['Int']['output']>
    query: Maybe<Scalars['String']['output']>
}

export type SearchList = {
    __typename: 'SearchList'
    edges: Maybe<Array<Maybe<SearchResult>>>
    total: Scalars['Int']['output']
    totals: Maybe<Array<Maybe<SearchTotal>>>
}

export enum SearchOrderBy {
    Score = 'score',
    TimeCreated = 'timeCreated',
    TimePublished = 'timePublished',
    Title = 'title',
}

export type SearchRelatedSite = {
    __typename: 'SearchRelatedSite'
    name: Scalars['String']['output']
    url: Scalars['String']['output']
}

export type SearchResult =
    | Blog
    | Discussion
    | Episode
    | Event
    | ExternalContent
    | File
    | Folder
    | GenericArticle
    | Group
    | MagazineIssue
    | News
    | Pad
    | Page
    | Podcast
    | Question
    | RelatedSiteSearchResult
    | StatusUpdate
    | User
    | Wiki

export type SearchTotal = {
    __typename: 'SearchTotal'
    subtype: Scalars['String']['output']
    title: Maybe<Scalars['String']['output']>
    total: Scalars['Int']['output']
}

export type SendMessageToEventPayload = {
    __typename: 'SendMessageToEventPayload'
    messageCount: Scalars['Int']['output']
    success: Scalars['Boolean']['output']
}

export type SendMessageToFollowersPayload = {
    __typename: 'SendMessageToFollowersPayload'
    entity: Maybe<Entity>
}

export type SendMessageToGroupPayload = {
    __typename: 'SendMessageToGroupPayload'
    group: Maybe<Group>
}

export type SendMessageToUserPayload = {
    __typename: 'SendMessageToUserPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type SetUserOnlineStatusInput = {
    status?: InputMaybe<UserOnlineStatusSetting>
}

export type SetUserOnlineStatusPayload = {
    __typename: 'SetUserOnlineStatusPayload'
    success: Maybe<Scalars['Boolean']['output']>
    user: Maybe<User>
}

export type SignSiteAgreementVersionPayload = {
    __typename: 'SignSiteAgreementVersionPayload'
    siteAgreementVersion: Maybe<SiteAgreementVersion>
}

export type Site = {
    __typename: 'Site'
    activityFilter: Maybe<ActivityFilter>
    autoMembershipProfileFields: Maybe<Array<Maybe<ProfileItem>>>
    blockedUserIntroMessage: Maybe<Scalars['SecureRichText']['output']>
    blueBillywigVideoEnabled: Maybe<Scalars['Boolean']['output']>
    cancelMembershipEnabled: Scalars['Boolean']['output']
    chatEnabled: Scalars['Boolean']['output']
    collabEditingEnabled: Scalars['Boolean']['output']
    collaboraCreateDocumentUrls: Maybe<Array<KeyValueItem>>
    collaboraEnabled: Scalars['Boolean']['output']
    collaboraPerGroup: Scalars['Boolean']['output']
    commentModerationEnabled: Maybe<Scalars['Boolean']['output']>
    commentWithoutAccountEnabled: Scalars['Boolean']['output']
    commentsOnNews: Maybe<Scalars['Boolean']['output']>
    contentAllowedTagCategories: Maybe<ContentAllowedTagCategory>
    contentModerationEnabled: Maybe<Scalars['Boolean']['output']>
    contentTranslation: Scalars['Boolean']['output']
    cookieConsent: Maybe<Scalars['Boolean']['output']>
    customContentTypes: Maybe<Array<Maybe<CustomContentType>>>
    customTagsAllowed: Scalars['Boolean']['output']
    datahubExternalContentEnabled: Maybe<Scalars['Boolean']['output']>
    defaultReadAccessId: Scalars['Int']['output']
    defaultSearchDirection: Maybe<OrderDirection>
    defaultSearchOrderBy: Maybe<SearchOrderBy>
    defaultWriteAccessId: Scalars['Int']['output']
    directLinks: Maybe<Array<Maybe<DirectLink>>>
    editUrlSlugEnabled: Scalars['Boolean']['output']
    editUserNameEnabled: Scalars['Boolean']['output']
    enableDocumentLocking: Maybe<Scalars['Boolean']['output']>
    enableFeedSorting: Maybe<Scalars['Boolean']['output']>
    enableSharing: Maybe<Scalars['Boolean']['output']>
    entityFilter: Maybe<EntityFilter>
    eventExport: Maybe<Scalars['Boolean']['output']>
    eventTiles: Maybe<Scalars['Boolean']['output']>
    fileDescriptionFieldEnabled: Maybe<Scalars['Boolean']['output']>
    footer: Maybe<Array<Maybe<FooterMenu>>>
    footerPageEnabled: Maybe<Scalars['Boolean']['output']>
    footerRows: Maybe<Array<Maybe<Row>>>
    groupMemberExport: Maybe<Scalars['Boolean']['output']>
    guid: Scalars['String']['output']
    icon: Maybe<Scalars['String']['output']>
    iconAlt: Maybe<Scalars['String']['output']>
    imageSizes: Maybe<Array<Maybe<Scalars['Int']['output']>>>
    initialArchiveDueDays: Maybe<Scalars['Int']['output']>
    initiativeDescription: Maybe<Scalars['String']['output']>
    initiativeImage: Maybe<Scalars['String']['output']>
    initiativeImageAlt: Maybe<Scalars['String']['output']>
    initiativeTitle: Maybe<Scalars['String']['output']>
    initiatorLink: Maybe<Scalars['String']['output']>
    integratedTokenOnlyVideocallUrl: Maybe<Scalars['String']['output']>
    integratedVideocallEnabled: Maybe<Scalars['Boolean']['output']>
    integratedVideocallUrl: Maybe<Scalars['String']['output']>
    isClosed: Maybe<Scalars['Boolean']['output']>
    isCustomContentTypeEnabled: Maybe<Scalars['Boolean']['output']>
    isDiscloseVotingUsersEnabled: Maybe<Scalars['Boolean']['output']>
    isDocumentChatEnabled: Maybe<Scalars['Boolean']['output']>
    isExternalSearchEnabled: Maybe<Scalars['Boolean']['output']>
    isIntelligentSearchEnabled: Maybe<Scalars['Boolean']['output']>
    kalturaVideoEnabled: Maybe<Scalars['Boolean']['output']>
    kalturaVideoPartnerId: Maybe<Scalars['String']['output']>
    kalturaVideoPlayerId: Maybe<Scalars['String']['output']>
    language: Scalars['String']['output']
    languageOptions: Maybe<Array<Maybe<Option>>>
    leaderImage: Maybe<Scalars['String']['output']>
    likeIcon: Maybe<Scalars['String']['output']>
    logo: Maybe<Scalars['String']['output']>
    logoAlt: Maybe<Scalars['String']['output']>
    maxCharactersInAbstract: Maybe<Scalars['Int']['output']>
    menu: Maybe<Array<Maybe<MenuItem>>>
    menuState: Maybe<MenuState>
    metaData: Maybe<MetaData>
    moodleEnabled: Maybe<Scalars['Boolean']['output']>
    name: Scalars['String']['output']
    newsletter: Maybe<Scalars['Boolean']['output']>
    notFoundPageCustomImage: Maybe<File>
    notFoundPageCustomImageAlt: Maybe<Scalars['String']['output']>
    notFoundPageDescription: Maybe<Scalars['SecureRichText']['output']>
    notFoundPageShowImage: Maybe<Scalars['Boolean']['output']>
    notFoundPageTitle: Maybe<Scalars['String']['output']>
    numberOfFeaturedItems: Maybe<Scalars['Int']['output']>
    onboardingEnabled: Scalars['Boolean']['output']
    onboardingIntro: Maybe<Scalars['String']['output']>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    pageTagFilters: Maybe<PageTagFilter>
    pdfCheckerEnabled: Scalars['Boolean']['output']
    preserveFileExif: Scalars['Boolean']['output']
    profile: Maybe<Array<Maybe<ProfileItem>>>
    profileFields: Maybe<Array<Maybe<ProfileItem>>>
    profileSections: Maybe<Array<Maybe<ProfileSection>>>
    pushNotificationsEnabled: Scalars['Boolean']['output']
    questionLockAfterActivity: Scalars['Boolean']['output']
    questionLockAfterActivityLink: Maybe<Scalars['String']['output']>
    readAccessIds: Maybe<Array<Maybe<AccessId>>>
    readOnlyMode: Maybe<Scalars['Boolean']['output']>
    recommendedType: Maybe<RecommendedTypeEnum>
    recurringEventsEnabled: Maybe<Scalars['Boolean']['output']>
    requireCommentModerationFor: Maybe<
        Array<Maybe<Scalars['String']['output']>>
    >
    requireContentModerationFor: Maybe<
        Array<Maybe<Scalars['String']['output']>>
    >
    scheduleAppointmentEnabled: Maybe<Scalars['Boolean']['output']>
    searchArchiveOption: Maybe<SearchArchiveOptionEnum>
    searchDisplayedFilters: Maybe<Array<Maybe<Scalars['String']['output']>>>
    searchFilter: Maybe<SearchFilter>
    searchRelatedSites: Maybe<Array<Maybe<SearchRelatedSite>>>
    searchRelatedSitesEnabled: Maybe<Scalars['Boolean']['output']>
    searchTagFilters: Maybe<Array<Maybe<SearchTagFilter>>>
    showCustomTagsInDetail: Scalars['Boolean']['output']
    showCustomTagsInFeed: Scalars['Boolean']['output']
    showExcerptInNewsCard: Maybe<Scalars['Boolean']['output']>
    showExtraHomepageFilters: Scalars['Boolean']['output']
    showIcon: Scalars['Boolean']['output']
    showInitiative: Scalars['Boolean']['output']
    showLeader: Scalars['Boolean']['output']
    showLeaderButtons: Scalars['Boolean']['output']
    showLoginRegister: Maybe<Scalars['Boolean']['output']>
    showOriginalFileName: Maybe<Scalars['Boolean']['output']>
    showPreheader: Maybe<Scalars['Boolean']['output']>
    showSuggestedItems: Scalars['Boolean']['output']
    showTagsInDetail: Scalars['Boolean']['output']
    showTagsInFeed: Scalars['Boolean']['output']
    showUpDownVoting: Maybe<Scalars['Boolean']['output']>
    showViewsCount: Maybe<Scalars['Boolean']['output']>
    sitePlanName: Maybe<Scalars['String']['output']>
    sitePlanType: Maybe<Scalars['String']['output']>
    startpage: Maybe<Scalars['String']['output']>
    startpageCms: Maybe<Scalars['String']['output']>
    style: Style
    subgroups: Maybe<Scalars['Boolean']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tenantId: Maybe<Scalars['Int']['output']>
    theme: Scalars['String']['output']
    usersOnline: Scalars['Int']['output']
    videocallEnabled: Maybe<Scalars['Boolean']['output']>
    videocallProfilepage: Maybe<Scalars['Boolean']['output']>
    writeAccessIds: Maybe<Array<Maybe<AccessId>>>
}

export type SiteCollaboraCreateDocumentUrlsArgs = {
    folderGuid?: InputMaybe<Scalars['String']['input']>
    groupGuid?: InputMaybe<Scalars['String']['input']>
}

export type SiteContentAllowedTagCategoriesArgs = {
    contentType: Scalars['String']['input']
}

export type SiteInitialArchiveDueDaysArgs = {
    subtype?: InputMaybe<Scalars['String']['input']>
}

export type SitePageTagFiltersArgs = {
    contentType: Scalars['String']['input']
}

export type SiteAccessRequest = {
    __typename: 'SiteAccessRequest'
    email: Scalars['String']['output']
    fieldsInAdminOverview: Maybe<Array<Maybe<ProfileItem>>>
    name: Scalars['String']['output']
    processedBy: Maybe<User>
    profileFields: Maybe<Array<Maybe<ProfileItem>>>
    reason: Maybe<Scalars['String']['output']>
    status: Maybe<SiteAccessStatus>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
}

export type SiteAccessRequestList = {
    __typename: 'SiteAccessRequestList'
    edges: Maybe<Array<Maybe<SiteAccessRequest>>>
    fieldsInAdminOverview: Maybe<Array<Maybe<ProfileItem>>>
    total: Scalars['Int']['output']
}

export enum SiteAccessStatus {
    Accepted = 'accepted',
    Pending = 'pending',
    Rejected = 'rejected',
    Unprocessed = 'unprocessed',
}

export type SiteAgreement = {
    __typename: 'SiteAgreement'
    accepted: Scalars['Boolean']['output']
    description: Maybe<Scalars['String']['output']>
    id: Scalars['String']['output']
    name: Scalars['String']['output']
    versions: Maybe<Array<Maybe<SiteAgreementVersion>>>
}

export type SiteAgreementVersion = {
    __typename: 'SiteAgreementVersion'
    accepted: Scalars['Boolean']['output']
    acceptedBy: Maybe<Scalars['String']['output']>
    acceptedDate: Maybe<Scalars['DateTime']['output']>
    document: Scalars['String']['output']
    id: Scalars['String']['output']
    type: Maybe<Scalars['String']['output']>
    version: Scalars['String']['output']
}

export type SiteCustomAgreement = {
    __typename: 'SiteCustomAgreement'
    fileName: Scalars['String']['output']
    id: Scalars['String']['output']
    name: Scalars['String']['output']
    url: Scalars['String']['output']
}

export type SiteInvite = {
    __typename: 'SiteInvite'
    email: Maybe<Scalars['String']['output']>
    timeCreated: Maybe<Scalars['DateTime']['output']>
}

export type SiteInviteList = {
    __typename: 'SiteInviteList'
    edges: Maybe<Array<Maybe<SiteInvite>>>
}

export type SiteSettings = {
    __typename: 'SiteSettings'
    allowRegistration: Maybe<Scalars['Boolean']['output']>
    anonymousStartPage: Maybe<Scalars['String']['output']>
    anonymousStartPageCms: Maybe<Scalars['String']['output']>
    appointmentTypeVideocall: Maybe<Array<Maybe<AppointmentType>>>
    archiveDueDays: Maybe<Scalars['Int']['output']>
    autoApproveSSO: Maybe<Scalars['Boolean']['output']>
    autoArchiveContentTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>
    blockUserOnEmailChange: Maybe<Scalars['Boolean']['output']>
    blockedUserIntroMessage: Maybe<Scalars['SecureRichText']['output']>
    blueBillywigVideoEnabled: Maybe<Scalars['Boolean']['output']>
    cancelMembershipEnabled: Maybe<Scalars['Boolean']['output']>
    collabEditingEnabled: Maybe<Scalars['Boolean']['output']>
    collaboraEnabled: Maybe<Scalars['Boolean']['output']>
    collaboraPerGroup: Maybe<Scalars['Boolean']['output']>
    colorHeader: Maybe<Scalars['String']['output']>
    colorPrimary: Maybe<Scalars['String']['output']>
    colorSecondary: Maybe<Scalars['String']['output']>
    commentModerationEnabled: Maybe<Scalars['Boolean']['output']>
    commentWithoutAccountEnabled: Maybe<Scalars['Boolean']['output']>
    commentsOnNews: Maybe<Scalars['Boolean']['output']>
    contentAllowedTagCategories: Maybe<Array<Maybe<ContentAllowedTagCategory>>>
    contentModerationEnabled: Maybe<Scalars['Boolean']['output']>
    cookieConsent: Maybe<Scalars['Boolean']['output']>
    customContentTypes: Maybe<Array<Maybe<CustomContentType>>>
    customCss: Maybe<Scalars['String']['output']>
    customTagsAllowed: Maybe<Scalars['Boolean']['output']>
    defaultEmailOverviewFrequency: Maybe<Scalars['String']['output']>
    defaultEmailOverviewFrequencyOptions: Maybe<Array<Maybe<Option>>>
    defaultReadAccessId: Maybe<Scalars['Int']['output']>
    defaultReadAccessIdOptions: Maybe<Array<Maybe<OptionInteger>>>
    defaultSearchDirection: Maybe<OrderDirection>
    defaultSearchOrderBy: Maybe<SearchOrderBy>
    deleteAccountRequests: Maybe<DeleteAccountRequestList>
    description: Maybe<Scalars['String']['output']>
    directLinks: Maybe<Array<Maybe<DirectLink>>>
    directRegistrationDomains: Maybe<Array<Maybe<Scalars['String']['output']>>>
    editUrlSlugEnabled: Maybe<Scalars['Boolean']['output']>
    editUserNameEnabled: Maybe<Scalars['Boolean']['output']>
    emailFooterImage: Maybe<File>
    emailFooterImageAlt: Maybe<Scalars['String']['output']>
    emailFooterImageAltDefault: Maybe<Scalars['String']['output']>
    emailFooterImageDefault: Maybe<Scalars['String']['output']>
    emailFooterImageEnabled: Maybe<Scalars['Boolean']['output']>
    emailFooterImageGuid: Maybe<Scalars['String']['output']>
    emailFooterImageLink: Maybe<Scalars['String']['output']>
    emailFooterImageLinkDefault: Maybe<Scalars['String']['output']>
    emailNotificationShowExcerpt: Maybe<Scalars['Boolean']['output']>
    emailOverviewEnableFeatured: Maybe<Scalars['Boolean']['output']>
    emailOverviewFeaturedTitle: Maybe<Scalars['String']['output']>
    emailOverviewIntro: Maybe<Scalars['String']['output']>
    emailOverviewSubject: Maybe<Scalars['String']['output']>
    emailOverviewTitle: Maybe<Scalars['String']['output']>
    enableDocumentLocking: Maybe<Scalars['Boolean']['output']>
    enableFeedSorting: Maybe<Scalars['Boolean']['output']>
    enableSharing: Maybe<Scalars['Boolean']['output']>
    eventExport: Maybe<Scalars['Boolean']['output']>
    eventTiles: Maybe<Scalars['Boolean']['output']>
    exportableContentTypes: Maybe<Array<Maybe<Option>>>
    exportableUserFields: Maybe<Array<Maybe<ExportableField>>>
    extraLanguages: Maybe<Array<Maybe<Scalars['String']['output']>>>
    favicon: Maybe<Scalars['String']['output']>
    fileDescriptionFieldEnabled: Maybe<Scalars['Boolean']['output']>
    flowAppUrl: Maybe<Scalars['String']['output']>
    flowCaseId: Maybe<Scalars['Int']['output']>
    flowEnabled: Maybe<Scalars['Boolean']['output']>
    flowSubtypes: Maybe<Array<Maybe<Scalars['String']['output']>>>
    flowToken: Maybe<Scalars['String']['output']>
    flowUserGuid: Maybe<Scalars['String']['output']>
    fontBody: Maybe<Scalars['String']['output']>
    fontHeading: Maybe<Scalars['String']['output']>
    fontOptions: Maybe<Array<Maybe<Option>>>
    footer: Maybe<Array<Maybe<FooterMenu>>>
    footerPage: Maybe<Page>
    footerPageEnabled: Maybe<Scalars['Boolean']['output']>
    groupMemberExport: Maybe<Scalars['Boolean']['output']>
    hideAccessLevelSelect: Maybe<Scalars['Boolean']['output']>
    hideContentOwner: Maybe<Array<Maybe<NotificationContentType>>>
    icon: Maybe<Scalars['String']['output']>
    iconAlt: Maybe<Scalars['String']['output']>
    idpId: Maybe<Scalars['String']['output']>
    idpName: Maybe<Scalars['String']['output']>
    initiativeDescription: Maybe<Scalars['String']['output']>
    initiativeImage: Maybe<Scalars['String']['output']>
    initiativeImageAlt: Maybe<Scalars['String']['output']>
    initiativeLink: Maybe<Scalars['String']['output']>
    initiativeTitle: Maybe<Scalars['String']['output']>
    isClosed: Maybe<Scalars['Boolean']['output']>
    isCustomContentTypeEnabled: Maybe<Scalars['Boolean']['output']>
    isDiscloseVotingUsersEnabled: Maybe<Scalars['Boolean']['output']>
    kalturaVideoEnabled: Maybe<Scalars['Boolean']['output']>
    kalturaVideoPartnerId: Maybe<Scalars['String']['output']>
    kalturaVideoPlayerId: Maybe<Scalars['String']['output']>
    language: Maybe<Scalars['String']['output']>
    languageOptions: Maybe<Array<Maybe<Option>>>
    leaderImage: Maybe<Scalars['String']['output']>
    likeIcon: Maybe<Scalars['String']['output']>
    loginIntro: Maybe<Scalars['String']['output']>
    logo: Maybe<Scalars['String']['output']>
    logoAlt: Maybe<Scalars['String']['output']>
    matomoId: Maybe<Scalars['String']['output']>
    matomoUrl: Maybe<Scalars['String']['output']>
    maxCharactersInAbstract: Maybe<Scalars['Int']['output']>
    menu: Maybe<Array<Maybe<MenuItem>>>
    menuState: Maybe<MenuState>
    name: Maybe<Scalars['String']['output']>
    newsletter: Maybe<Scalars['Boolean']['output']>
    notFoundPageCustomDescription: Maybe<Scalars['SecureRichText']['output']>
    notFoundPageCustomDescriptionEnabled: Maybe<Scalars['Boolean']['output']>
    notFoundPageCustomImage: Maybe<File>
    notFoundPageCustomImageAlt: Maybe<Scalars['String']['output']>
    notFoundPageCustomTitle: Maybe<Scalars['String']['output']>
    notFoundPageCustomTitleEnabled: Maybe<Scalars['Boolean']['output']>
    notFoundPageDescriptionDefault: Maybe<Scalars['String']['output']>
    notFoundPageShowImage: Maybe<Scalars['Boolean']['output']>
    notFoundPageTitleDefault: Maybe<Scalars['String']['output']>
    notifyAdminsOnEmailChangeBlock: Maybe<Scalars['Boolean']['output']>
    numberOfFeaturedItems: Maybe<Scalars['Int']['output']>
    oidcProviderOptions: Maybe<Array<Maybe<Option>>>
    oidcProviders: Maybe<Array<Maybe<Scalars['String']['output']>>>
    onboardingEnabled: Scalars['Boolean']['output']
    onboardingForceExistingUsers: Maybe<Scalars['Boolean']['output']>
    onboardingIntro: Maybe<Scalars['String']['output']>
    onboardingProfileFields: Maybe<Array<Maybe<ProfileItem>>>
    openForCreateContentTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>
    pageTagFilters: Maybe<Array<Maybe<PageTagFilter>>>
    pdfCheckerEnabled: Maybe<Scalars['Boolean']['output']>
    preserveFileExif: Maybe<Scalars['Boolean']['output']>
    profile: Maybe<Array<Maybe<ProfileItem>>>
    profileFieldValidators: Maybe<Array<Maybe<ProfileFieldValidator>>>
    profileFields: Maybe<Array<Maybe<ProfileItem>>>
    profileSections: Maybe<Array<Maybe<ProfileSection>>>
    profileSets: Maybe<Array<Maybe<ProfileSet>>>
    profileSyncEnabled: Maybe<Scalars['Boolean']['output']>
    profileSyncToken: Maybe<Scalars['String']['output']>
    pushNotificationsEnabled: Maybe<Scalars['Boolean']['output']>
    questionLockAfterActivity: Maybe<Scalars['Boolean']['output']>
    questionLockAfterActivityLink: Maybe<Scalars['String']['output']>
    questionerCanChooseBestAnswer: Maybe<Scalars['Boolean']['output']>
    recommendedType: Maybe<RecommendedTypeEnum>
    redirects: Maybe<Array<Maybe<Redirect>>>
    require2FA: Maybe<Require2FaLevelEnum>
    requireCommentModerationFor: Maybe<
        Array<Maybe<Scalars['String']['output']>>
    >
    requireContentModerationFor: Maybe<
        Array<Maybe<Scalars['String']['output']>>
    >
    roleOptions: Maybe<Array<Maybe<Option>>>
    searchArchiveOption: Maybe<SearchArchiveOptionEnum>
    searchContentTypes: Maybe<SearchFilter>
    searchDisplayedFilters: Maybe<Array<Maybe<Scalars['String']['output']>>>
    searchEngineIndexingEnabled: Maybe<Scalars['Boolean']['output']>
    searchExcludedContentTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>
    searchTagFilters: Maybe<Array<Maybe<SearchTagFilter>>>
    securityText: Maybe<Scalars['String']['output']>
    securityTextEnabled: Maybe<Scalars['Boolean']['output']>
    securityTextPGP: Maybe<Scalars['String']['output']>
    securityTextRedirectEnabled: Maybe<Scalars['Boolean']['output']>
    securityTextRedirectUrl: Maybe<Scalars['String']['output']>
    showCustomTagsInDetail: Maybe<Scalars['Boolean']['output']>
    showCustomTagsInFeed: Maybe<Scalars['Boolean']['output']>
    showExcerptInNewsCard: Maybe<Scalars['Boolean']['output']>
    showExtraHomepageFilters: Maybe<Scalars['Boolean']['output']>
    showFollowersContentTypeOptions: Maybe<Array<Scalars['String']['output']>>
    showFollowersContentTypes: Maybe<Array<Scalars['String']['output']>>
    showIcon: Scalars['Boolean']['output']
    showInitiative: Maybe<Scalars['Boolean']['output']>
    showLeader: Maybe<Scalars['Boolean']['output']>
    showLeaderButtons: Maybe<Scalars['Boolean']['output']>
    showLoginRegister: Maybe<Scalars['Boolean']['output']>
    showOriginalFileName: Maybe<Scalars['Boolean']['output']>
    showPreheader: Maybe<Scalars['Boolean']['output']>
    showSuggestedItems: Maybe<Scalars['Boolean']['output']>
    showTagsInDetail: Maybe<Scalars['Boolean']['output']>
    showTagsInFeed: Maybe<Scalars['Boolean']['output']>
    showUpDownVoting: Maybe<Scalars['Boolean']['output']>
    showViewsCount: Maybe<Scalars['Boolean']['output']>
    siteAccessRequests: Maybe<SiteAccessRequestList>
    siteCategory: Maybe<Scalars['String']['output']>
    siteInvites: Maybe<SiteInviteList>
    siteMembershipAcceptedIntro: Maybe<Scalars['String']['output']>
    siteMembershipAcceptedSubject: Maybe<Scalars['String']['output']>
    siteMembershipDeniedIntro: Maybe<Scalars['String']['output']>
    siteMembershipDeniedSubject: Maybe<Scalars['String']['output']>
    siteNotes: Maybe<Scalars['String']['output']>
    siteOwnerEmail: Maybe<Scalars['String']['output']>
    siteOwnerName: Maybe<Scalars['String']['output']>
    sitePlanName: Maybe<Scalars['String']['output']>
    sitePlanType: Maybe<Scalars['String']['output']>
    startPage: Maybe<Scalars['String']['output']>
    startPageCms: Maybe<Scalars['String']['output']>
    startPageCmsOptions: Maybe<Array<Maybe<Option>>>
    startPageOptions: Maybe<Array<Maybe<Option>>>
    statusUpdateGroups: Maybe<Scalars['Boolean']['output']>
    subgroups: Maybe<Scalars['Boolean']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    supportContractEnabled: Maybe<Scalars['Boolean']['output']>
    supportContractHoursRemaining: Maybe<Scalars['Float']['output']>
    tagCategorySettings: Maybe<Array<Maybe<TagCategorySetting>>>
    theme: Maybe<Scalars['String']['output']>
    themeOptions: Maybe<Array<Maybe<Option>>>
    walledGardenByIpEnabled: Maybe<Scalars['Boolean']['output']>
    whitelistedIpRanges: Maybe<Array<Maybe<Scalars['String']['output']>>>
    whoCanCreateGroup: GroupAddPermission
    whoCanCreateGroupOptions: Maybe<Array<Maybe<Option>>>
}

export type SiteSettingsDeleteAccountRequestsArgs = {
    orderBy?: InputMaybe<SiteUsersOrderBy>
    orderByProfileFieldKey?: InputMaybe<Scalars['String']['input']>
    orderDirection?: InputMaybe<OrderDirection>
}

export type SiteSettingsSiteAccessRequestsArgs = {
    orderBy?: InputMaybe<SiteUsersOrderBy>
    orderByProfileFieldKey?: InputMaybe<Scalars['String']['input']>
    orderDirection?: InputMaybe<OrderDirection>
    status?: InputMaybe<SiteAccessStatus>
}

export type SiteStats = {
    __typename: 'SiteStats'
    appVersion: Maybe<AppVersion>
    archiveSize: Maybe<Scalars['Int']['output']>
    dbUsage: Maybe<Scalars['Float']['output']>
    fileDiskUsage: Maybe<Scalars['Float']['output']>
}

export type SiteUserList = {
    __typename: 'SiteUserList'
    edges: Maybe<Array<Maybe<User>>>
    fieldsInAdminOverview: Maybe<Array<Maybe<ProfileItem>>>
    total: Scalars['Int']['output']
}

export enum SiteUsersOrderBy {
    BanReason = 'banReason',
    BanScheduledAt = 'banScheduledAt',
    BannedSince = 'bannedSince',
    Email = 'email',
    LastOnline = 'lastOnline',
    MemberSince = 'memberSince',
    Name = 'name',
    ProcessedBy = 'processedBy',
    ProfileFieldKey = 'profileFieldKey',
    Reason = 'reason',
    TimeCreated = 'timeCreated',
    TimeUpdated = 'timeUpdated',
}

export type SourceDocument = {
    __typename: 'SourceDocument'
    id: Maybe<Scalars['String']['output']>
    snippet: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
}

export type StatsItem = {
    __typename: 'StatsItem'
    key: Scalars['String']['output']
    name: Scalars['String']['output']
    value: Maybe<Scalars['String']['output']>
}

export enum StatusPublished {
    Archived = 'archived',
    Draft = 'draft',
    Published = 'published',
}

export type StatusUpdate = Entity & {
    __typename: 'StatusUpdate'
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    canVote: Maybe<Scalars['Boolean']['output']>
    commentCount: Maybe<Scalars['Int']['output']>
    comments: Maybe<Array<Maybe<Comment>>>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasVoted: Maybe<Scalars['Int']['output']>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isFollowing: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    votes: Maybe<Scalars['Int']['output']>
    votingUsers: Maybe<UserList>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type StatusUpdateCommentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type StatusUpdateVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type Style = {
    __typename: 'Style'
    colorHeader: Maybe<Scalars['String']['output']>
    colorPrimary: Maybe<Scalars['String']['output']>
    colorSecondary: Maybe<Scalars['String']['output']>
    fontBody: Maybe<Scalars['String']['output']>
    fontHeading: Maybe<Scalars['String']['output']>
}

export type Subgroup = {
    __typename: 'Subgroup'
    id: Maybe<Scalars['Int']['output']>
    members: Maybe<Array<Maybe<User>>>
    name: Maybe<Scalars['String']['output']>
}

export type SubgroupList = {
    __typename: 'SubgroupList'
    edges: Maybe<Array<Maybe<Subgroup>>>
    total: Scalars['Int']['output']
}

export type Subscription = {
    __typename: 'Subscription'
    onChatUpdate: Maybe<ChatUpdate>
    onChatsUpdate: Maybe<ChatsUpdate>
}

export type SubscriptionOnChatUpdateArgs = {
    chatGuid?: InputMaybe<Scalars['String']['input']>
    chatMessageGuid?: InputMaybe<Scalars['String']['input']>
}

export type Tag = {
    __typename: 'Tag'
    label: Scalars['String']['output']
    synonyms: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type TagCategory = {
    __typename: 'TagCategory'
    name: Scalars['String']['output']
    values: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type TagCategoryInput = {
    name: Scalars['String']['input']
    values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type TagCategorySetting = {
    __typename: 'TagCategorySetting'
    name: Maybe<Scalars['String']['output']>
    values: Maybe<Array<Maybe<TagCategoryTagSetting>>>
}

export type TagCategoryTagSetting = {
    __typename: 'TagCategoryTagSetting'
    synonyms: Maybe<Array<Maybe<Scalars['String']['output']>>>
    value: Maybe<Scalars['String']['output']>
}

export type TagCollection = {
    __typename: 'TagCollection'
    emailNotifications: Maybe<Scalars['Boolean']['output']>
    guid: Maybe<Scalars['String']['output']>
    label: Scalars['String']['output']
    owner: Maybe<User>
    siteNotifications: Maybe<Scalars['Boolean']['output']>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type TagCollectionList = {
    __typename: 'TagCollectionList'
    edges: Maybe<Array<Maybe<TagCollection>>>
    total: Scalars['Int']['output']
}

export type Task = Entity & {
    __typename: 'Task'
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canComment: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    canVote: Maybe<Scalars['Boolean']['output']>
    commentCount: Maybe<Scalars['Int']['output']>
    comments: Maybe<Array<Maybe<Comment>>>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasVoted: Maybe<Scalars['Int']['output']>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isFollowing: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    state: Maybe<Scalars['String']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    thumbnail: Maybe<Scalars['String']['output']>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    views: Maybe<Scalars['Int']['output']>
    votes: Maybe<Scalars['Int']['output']>
    votingUsers: Maybe<UserList>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type TaskVotingUsersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

export type TestRssEndpointPayload = {
    __typename: 'TestRssEndpointPayload'
    isFeed: Maybe<Scalars['Boolean']['output']>
}

export type ToggleBestAnswerPayload = {
    __typename: 'ToggleBestAnswerPayload'
    entity: Question
}

export type ToggleChatReactionPayload = {
    __typename: 'ToggleChatReactionPayload'
    chatMessage: Maybe<ChatMessage>
}

export type ToggleEntityIsPinnedPayload = {
    __typename: 'ToggleEntityIsPinnedPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type ToggleGroupMemberRolePayload = {
    __typename: 'ToggleGroupMemberRolePayload'
    group: Maybe<Group>
}

export type ToggleIsClosedPayload = {
    __typename: 'ToggleIsClosedPayload'
    entity: Question
}

export type ToggleRequestDeleteUserPayload = {
    __typename: 'ToggleRequestDeleteUserPayload'
    viewer: Maybe<Viewer>
}

export type ToggleUserRolePayload = {
    __typename: 'ToggleUserRolePayload'
    success: Maybe<Scalars['Boolean']['output']>
    user: Maybe<User>
}

export type TopItem = {
    __typename: 'TopItem'
    likes: Maybe<Scalars['Int']['output']>
    user: Maybe<User>
}

export type TranslationSet = {
    __typename: 'TranslationSet'
    language: Maybe<Scalars['String']['output']>
    values: Maybe<Array<Maybe<KeyValueItem>>>
}

export type TranslationSetInput = {
    language?: InputMaybe<Scalars['String']['input']>
    values?: InputMaybe<Array<InputMaybe<KeyValueItemInput>>>
}

export type TrendingList = {
    __typename: 'TrendingList'
    likes: Maybe<Scalars['Int']['output']>
    tag: Maybe<Scalars['String']['output']>
}

export enum Type {
    Group = 'group',
    Object = 'object',
    Page = 'page',
    User = 'user',
    Wiki = 'wiki',
}

export type UpdateAttendEventStatePayload = {
    __typename: 'UpdateAttendEventStatePayload'
    entity: Maybe<Event>
    fields: Maybe<Array<Maybe<EntityFormResponseFeedback>>>
    success: Maybe<Scalars['Boolean']['output']>
}

export type UpdateDatahubContentSourceInput = {
    apiUrl: Scalars['String']['input']
    batchSize?: InputMaybe<Scalars['Int']['input']>
    frontendUrl: Scalars['String']['input']
    key: Scalars['String']['input']
    name: Scalars['String']['input']
    pluralName: Scalars['String']['input']
}

export type UpdateIntelligentSearchAnswerInput = {
    feedback: Scalars['String']['input']
    guid: Scalars['String']['input']
}

export type UpdateIntelligentSearchAnswerPayload = {
    __typename: 'UpdateIntelligentSearchAnswerPayload'
    question: Maybe<IntelligentSearchQuestion>
    success: Maybe<Scalars['Boolean']['output']>
}

export type UpdateMembershipFavoriteInput = {
    favorite: Scalars['Boolean']['input']
    groupGuid: Scalars['String']['input']
}

export type UpdateMembershipFavoritePayload = {
    __typename: 'UpdateMembershipFavoritePayload'
    group: Maybe<Group>
    success: Maybe<Scalars['Boolean']['output']>
}

export enum UpdateOwnerRecursive {
    UpdateAllFiles = 'updateAllFiles',
    UpdateOwnerFiles = 'updateOwnerFiles',
}

export type UpdateUserContactFavoriteInput = {
    favorite: Scalars['Boolean']['input']
    userGuid: Scalars['String']['input']
}

export type UpdateUserContactFavoritePayload = {
    __typename: 'UpdateUserContactFavoritePayload'
    success: Maybe<Scalars['Boolean']['output']>
    user: Maybe<User>
}

export type UpdateUserWidgetSettingsPayload = {
    __typename: 'UpdateUserWidgetSettingsPayload'
    entity: Maybe<Entity>
    success: Maybe<Scalars['Boolean']['output']>
}

export type User = Entity & {
    __typename: 'User'
    accessRequestEmail: Maybe<AccessRequestEmail>
    banReason: Maybe<Scalars['String']['output']>
    banScheduledAt: Maybe<Scalars['DateTime']['output']>
    banScheduledReason: Maybe<Scalars['String']['output']>
    bannedSince: Maybe<Scalars['DateTime']['output']>
    canBan: Maybe<Scalars['Boolean']['output']>
    canDelete: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    email: Maybe<Scalars['String']['output']>
    emailNotifications: Maybe<Scalars['Boolean']['output']>
    emailNotificationsFrequency: Maybe<Scalars['Int']['output']>
    emailOverview: Maybe<EmailOverview>
    fieldsInAdminOverview: Maybe<Array<Maybe<ProfileItem>>>
    fieldsInOverview: Maybe<Array<Maybe<ProfileItem>>>
    getsNewsletter: Maybe<Scalars['Boolean']['output']>
    groupNotifications: Maybe<Array<Maybe<GroupNotificationItem>>>
    guid: Scalars['String']['output']
    icon: Maybe<Scalars['String']['output']>
    isBanned: Maybe<Scalars['Boolean']['output']>
    isChatGroupNotificationPushEnabled: Maybe<Scalars['Boolean']['output']>
    isChatUsersNotificationPushEnabled: Maybe<Scalars['Boolean']['output']>
    isCommentNotificationDirectMailEnabled: Maybe<Scalars['Boolean']['output']>
    isCommentNotificationPushEnabled: Maybe<Scalars['Boolean']['output']>
    isCommentNotificationsEnabled: Maybe<Scalars['Boolean']['output']>
    isContact: Maybe<Scalars['Boolean']['output']>
    isFavoriteContact: Maybe<Scalars['Boolean']['output']>
    isMentionNotificationDirectMailEnabled: Maybe<Scalars['Boolean']['output']>
    isMentionNotificationPushEnabled: Maybe<Scalars['Boolean']['output']>
    isMentionNotificationsEnabled: Maybe<Scalars['Boolean']['output']>
    isOnline: Maybe<Scalars['Boolean']['output']>
    isSuperadmin: Maybe<Scalars['Boolean']['output']>
    language: Maybe<Scalars['String']['output']>
    lastOnline: Maybe<Scalars['String']['output']>
    memberSince: Maybe<Scalars['DateTime']['output']>
    metaData: Maybe<MetaData>
    missingProfileFields: Maybe<Array<Maybe<ProfileItem>>>
    name: Maybe<Scalars['String']['output']>
    onlineStatus: Maybe<UserOnlineStatusSetting>
    onlineStatusUpdatedAt: Maybe<Scalars['DateTime']['output']>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    profile: Maybe<Array<Maybe<ProfileItem>>>
    profileSetManager: Maybe<Array<Maybe<ProfileSet>>>
    requestDelete: Maybe<Scalars['Boolean']['output']>
    roles: Maybe<Array<Maybe<Scalars['String']['output']>>>
    stats: Maybe<Array<Maybe<StatsItem>>>
    status: Maybe<Scalars['Int']['output']>
    url: Maybe<Scalars['String']['output']>
    username: Maybe<Scalars['String']['output']>
    vcard: Maybe<Array<Maybe<ProfileItem>>>
}

export type UserFieldsInOverviewArgs = {
    groupGuid?: InputMaybe<Scalars['String']['input']>
}

export type UserMissingProfileFieldsArgs = {
    groupGuid: Scalars['String']['input']
}

export type UserRolesArgs = {
    groupGuid?: InputMaybe<Scalars['String']['input']>
}

export type UserVcardArgs = {
    groupGuid?: InputMaybe<Scalars['String']['input']>
}

export enum UserBanScheduledFilter {
    Any = 'any',
    IsNotScheduled = 'isNotScheduled',
    IsScheduled = 'isScheduled',
}

export type UserFilter = {
    __typename: 'UserFilter'
    fieldType: Scalars['String']['output']
    keys: Maybe<Array<Scalars['String']['output']>>
    label: Scalars['String']['output']
    name: Scalars['String']['output']
}

export type UserFilterCount = {
    __typename: 'UserFilterCount'
    name: Scalars['String']['output']
    values: Maybe<Array<Maybe<UserFilterItemCount>>>
}

export type UserFilterItemCount = {
    __typename: 'UserFilterItemCount'
    count: Maybe<Scalars['Int']['output']>
    key: Scalars['String']['output']
}

export type UserList = {
    __typename: 'UserList'
    edges: Maybe<Array<Maybe<User>>>
    fieldsInAdminOverview: Maybe<Array<Maybe<ProfileItem>>>
    fieldsInOverview: Maybe<Array<Maybe<ProfileItem>>>
    filterCount: Maybe<Array<Maybe<UserFilterCount>>>
    total: Scalars['Int']['output']
}

export enum UserOnlineStatusSetting {
    Auto = 'auto',
    Offline = 'offline',
}

export type UserOrEmail = {
    email?: InputMaybe<Scalars['String']['input']>
    guid?: InputMaybe<Scalars['String']['input']>
}

export enum UserScope {
    All = 'all',
    Contacts = 'contacts',
}

export type VideoCall = {
    __typename: 'VideoCall'
    guid: Maybe<Scalars['String']['output']>
    isModerator: Maybe<Scalars['Boolean']['output']>
    jwtToken: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type VideoMetadata = {
    __typename: 'VideoMetadata'
    thumbnailUrl: Maybe<Scalars['String']['output']>
}

export type Viewer = {
    __typename: 'Viewer'
    banReason: Maybe<Scalars['String']['output']>
    canAccessAdmin: Maybe<Scalars['Boolean']['output']>
    canAccessExternalSearch: Maybe<Scalars['Boolean']['output']>
    canInsertMedia: Maybe<Scalars['Boolean']['output']>
    canUpdateAccessLevel: Maybe<Scalars['Boolean']['output']>
    canWriteToContainer: Scalars['Boolean']['output']
    countAdminTasks: Maybe<Scalars['Int']['output']>
    guid: Scalars['String']['output']
    has2faEnabled: Scalars['Boolean']['output']
    isAdmin: Scalars['Boolean']['output']
    isAutoBan: Maybe<Scalars['Boolean']['output']>
    isBanned: Scalars['Boolean']['output']
    isNewsEditor: Scalars['Boolean']['output']
    isSubEditor: Scalars['Boolean']['output']
    isSuspendAdminPrivileges: Maybe<Scalars['Boolean']['output']>
    language: Scalars['String']['output']
    loggedIn: Scalars['Boolean']['output']
    profileSetManager: Maybe<Array<Maybe<ProfileSet>>>
    requiresCommentModeration: Maybe<Scalars['Boolean']['output']>
    requiresContentModeration: Maybe<Scalars['Boolean']['output']>
    richTextEditorFeature: Maybe<Scalars['Boolean']['output']>
    showSuspendAdminPrivilegesToggle: Maybe<Scalars['Boolean']['output']>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    updateAccountUrl: Maybe<Scalars['String']['output']>
    user: Maybe<User>
}

export type ViewerCanAccessAdminArgs = {
    permission?: InputMaybe<AdminAccessPermission>
}

export type ViewerCanInsertMediaArgs = {
    subtype?: InputMaybe<Scalars['String']['input']>
}

export type ViewerCanUpdateAccessLevelArgs = {
    groupGuid?: InputMaybe<Scalars['String']['input']>
}

export type ViewerCanWriteToContainerArgs = {
    containerGuid?: InputMaybe<Scalars['String']['input']>
    subtype?: InputMaybe<Scalars['String']['input']>
}

export type ViewerCountAdminTasksArgs = {
    kind?: InputMaybe<KindOfAdminTask>
}

export type ViewerRequiresCommentModerationArgs = {
    groupGuid?: InputMaybe<Scalars['String']['input']>
    subtype?: InputMaybe<Scalars['String']['input']>
}

export type ViewerRequiresContentModerationArgs = {
    groupGuid?: InputMaybe<Scalars['String']['input']>
    subtype?: InputMaybe<Scalars['String']['input']>
}

export type ViewerRichTextEditorFeatureArgs = {
    feature: RichTextEditorFeatureEnum
}

export type VoteOnPollPayload = {
    __typename: 'VoteOnPollPayload'
    entity: Entity
}

export type Widget = {
    __typename: 'Widget'
    guid: Maybe<Scalars['String']['output']>
    settings: Maybe<Array<Maybe<WidgetSetting>>>
    type: Scalars['String']['output']
    userSettings: Maybe<Array<Maybe<WidgetSetting>>>
}

export type WidgetLink = {
    __typename: 'WidgetLink'
    buttonText: Maybe<Scalars['String']['output']>
    content: Maybe<Entity>
    description: Maybe<Scalars['String']['output']>
    id: Maybe<Scalars['String']['output']>
    image: Maybe<Attachment>
    imageAlt: Maybe<Scalars['String']['output']>
    isLocked: Maybe<Scalars['Boolean']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
}

export type WidgetLinkInput = {
    buttonText?: InputMaybe<Scalars['String']['input']>
    contentGuid?: InputMaybe<Scalars['String']['input']>
    description?: InputMaybe<Scalars['String']['input']>
    id?: InputMaybe<Scalars['String']['input']>
    image?: InputMaybe<Scalars['Upload']['input']>
    imageAlt?: InputMaybe<Scalars['String']['input']>
    imageId?: InputMaybe<Scalars['String']['input']>
    isLocked?: InputMaybe<Scalars['Boolean']['input']>
    title?: InputMaybe<Scalars['String']['input']>
    url?: InputMaybe<Scalars['String']['input']>
}

export type WidgetSetting = {
    __typename: 'WidgetSetting'
    attachment: Maybe<Attachment>
    key: Scalars['String']['output']
    links: Maybe<Array<Maybe<WidgetLink>>>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    value: Maybe<Scalars['String']['output']>
}

export type WidgetSettingInput = {
    attachment?: InputMaybe<Scalars['Upload']['input']>
    attachmentId?: InputMaybe<Scalars['String']['input']>
    key?: InputMaybe<Scalars['String']['input']>
    links?: InputMaybe<Array<InputMaybe<WidgetLinkInput>>>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    value?: InputMaybe<Scalars['String']['input']>
}

export type Wiki = Entity & {
    __typename: 'Wiki'
    abstract: Maybe<Scalars['SecureRichText']['output']>
    accessId: Maybe<Scalars['Int']['output']>
    canArchiveAndDelete: Maybe<Scalars['Boolean']['output']>
    canBookmark: Maybe<Scalars['Boolean']['output']>
    canEdit: Scalars['Boolean']['output']
    canEditAdvanced: Maybe<Scalars['Boolean']['output']>
    canEditGroup: Maybe<Scalars['Boolean']['output']>
    children: Maybe<Array<Maybe<Wiki>>>
    description: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    featured: Maybe<Featured>
    group: Maybe<Group>
    guid: Scalars['String']['output']
    hasChildren: Maybe<Scalars['Boolean']['output']>
    inGroup: Maybe<Scalars['Boolean']['output']>
    inputLanguage: Maybe<Scalars['String']['output']>
    isBookmarked: Maybe<Scalars['Boolean']['output']>
    isFeatured: Maybe<Scalars['Boolean']['output']>
    isPinned: Scalars['Boolean']['output']
    isRecommendedInSearch: Maybe<Scalars['Boolean']['output']>
    isTranslationEnabled: Maybe<Scalars['Boolean']['output']>
    lastSeen: Maybe<Scalars['DateTime']['output']>
    localAbstract: Maybe<Scalars['String']['output']>
    localDescription: Maybe<Scalars['String']['output']>
    localExcerpt: Maybe<Scalars['String']['output']>
    localRichDescription: Maybe<Scalars['String']['output']>
    localTitle: Maybe<Scalars['String']['output']>
    metaData: Maybe<MetaData>
    openGraphMetaData: Maybe<OpenGraphMetaData>
    owner: Maybe<User>
    parent: Maybe<Wiki>
    publishRequest: Maybe<PublishRequest>
    richDescription: Maybe<Scalars['SecureRichText']['output']>
    rootParent: Maybe<Wiki>
    scheduleArchiveEntity: Maybe<Scalars['DateTime']['output']>
    scheduleDeleteEntity: Maybe<Scalars['DateTime']['output']>
    showOwner: Maybe<Scalars['Boolean']['output']>
    status: Maybe<Scalars['Int']['output']>
    statusPublished: Maybe<StatusPublished>
    subtype: Maybe<Scalars['String']['output']>
    suggestedItems: Maybe<Array<Maybe<Entity>>>
    tagCategories: Maybe<Array<Maybe<TagCategory>>>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    timeCreated: Maybe<Scalars['DateTime']['output']>
    timePublished: Maybe<Scalars['DateTime']['output']>
    timeUpdated: Maybe<Scalars['DateTime']['output']>
    title: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
    writeAccessId: Maybe<Scalars['Int']['output']>
}

export type AcceptGroupInvitationInput = {
    /** The unique invite code. */
    code?: InputMaybe<Scalars['String']['input']>
}

export type AcceptMembershipRequestInput = {
    /** The guid of the group. */
    groupGuid?: InputMaybe<Scalars['String']['input']>
    /** The guid of the user. */
    userGuid?: InputMaybe<Scalars['String']['input']>
}

export type AddAttachmentInput = {
    /** @deprecated attachment relations are made through references in the text */
    contentGuid?: InputMaybe<Scalars['String']['input']>
    file: Scalars['Upload']['input']
}

export type AddChatAnswerFeedbackInput = {
    feedback: Feedback
    messageUuid: Scalars['String']['input']
}

export type AddChatInput = {
    userGuids?: InputMaybe<Array<Scalars['String']['input']>>
}

export type AddChatMessageInput = {
    chatGuid?: InputMaybe<Scalars['String']['input']>
    chatMessageGuid?: InputMaybe<Scalars['String']['input']>
    richDescription: Scalars['SecureRichText']['input']
}

export type AddCommentWithoutAccountInput = {
    containerGuid: Scalars['String']['input']
    email: Scalars['String']['input']
    name: Scalars['String']['input']
    richDescription: Scalars['SecureRichText']['input']
}

export type AddDocumentChatMessageInput = {
    conversationId?: InputMaybe<Scalars['String']['input']>
    message: Scalars['String']['input']
}

export type AddEntityInput = {
    abstract?: InputMaybe<Scalars['SecureRichText']['input']>
    accessId?: InputMaybe<Scalars['Int']['input']>
    attendEventOnline?: InputMaybe<Scalars['Boolean']['input']>
    attendEventWithoutAccount?: InputMaybe<Scalars['Boolean']['input']>
    attendeeWelcomeMailContent?: InputMaybe<Scalars['SecureRichText']['input']>
    attendeeWelcomeMailSubject?: InputMaybe<Scalars['String']['input']>
    backgroundColor?: InputMaybe<Scalars['String']['input']>
    colophon?: InputMaybe<Array<InputMaybe<ColophonValueInput>>>
    colophonFields?: InputMaybe<Array<InputMaybe<AddColophonFieldInput>>>
    containerGuid?: InputMaybe<Scalars['String']['input']>
    enableMaybeAttendEvent?: InputMaybe<Scalars['Boolean']['input']>
    endDate?: InputMaybe<Scalars['DateTime']['input']>
    featured?: InputMaybe<FeaturedInput>
    flowCaseId?: InputMaybe<Scalars['Int']['input']>
    form?: InputMaybe<EntityFormInput>
    formResponse?: InputMaybe<Array<InputMaybe<EntityFormResponseInput>>>
    groupGuid?: InputMaybe<Scalars['String']['input']>
    iconGuid?: InputMaybe<Scalars['String']['input']>
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isFeatured?: InputMaybe<Scalars['Boolean']['input']>
    isFormEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isRecommended?: InputMaybe<Scalars['Boolean']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    issueNumber?: InputMaybe<Scalars['Int']['input']>
    location?: InputMaybe<Scalars['String']['input']>
    locationAddress?: InputMaybe<Scalars['String']['input']>
    locationLink?: InputMaybe<Scalars['String']['input']>
    maxAttendees?: InputMaybe<Scalars['String']['input']>
    mentions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    qrAccess?: InputMaybe<Scalars['Boolean']['input']>
    rangeSettings?: InputMaybe<EventRangeSettingsInput>
    requireAttendParent?: InputMaybe<Scalars['Boolean']['input']>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    rsvp?: InputMaybe<Scalars['Boolean']['input']>
    scheduleArchiveEntity?: InputMaybe<Scalars['DateTime']['input']>
    scheduleDeleteEntity?: InputMaybe<Scalars['DateTime']['input']>
    showTableOfContents?: InputMaybe<Scalars['Boolean']['input']>
    source?: InputMaybe<Scalars['String']['input']>
    startDate?: InputMaybe<Scalars['DateTime']['input']>
    subtitle?: InputMaybe<Scalars['String']['input']>
    subtype: Scalars['String']['input']
    suggestedItems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    ticketLink?: InputMaybe<Scalars['String']['input']>
    timePublished?: InputMaybe<Scalars['DateTime']['input']>
    title?: InputMaybe<Scalars['String']['input']>
    type?: InputMaybe<Type>
    urlSlug?: InputMaybe<Scalars['String']['input']>
    videoCallEnabled?: InputMaybe<Scalars['Boolean']['input']>
    videoCallModeratorUserGuids?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    writeAccessId?: InputMaybe<Scalars['Int']['input']>
}

export type AddEpisodeInput = {
    abstract?: InputMaybe<Scalars['SecureRichText']['input']>
    accessId?: InputMaybe<Scalars['Int']['input']>
    fileGuid?: InputMaybe<Scalars['String']['input']>
    groupGuid?: InputMaybe<Scalars['String']['input']>
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isFeatured?: InputMaybe<Scalars['Boolean']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    podcastGuid: Scalars['String']['input']
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    scheduleArchiveEntity?: InputMaybe<Scalars['DateTime']['input']>
    scheduleDeleteEntity?: InputMaybe<Scalars['DateTime']['input']>
    suggestedItems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    timePublished?: InputMaybe<Scalars['DateTime']['input']>
    title?: InputMaybe<Scalars['String']['input']>
    writeAccessId?: InputMaybe<Scalars['Int']['input']>
}

export type AddFileInput = {
    accessId?: InputMaybe<Scalars['Int']['input']>
    containerGuid?: InputMaybe<Scalars['String']['input']>
    file?: InputMaybe<Scalars['Upload']['input']>
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    versionComment?: InputMaybe<Scalars['String']['input']>
    writeAccessId?: InputMaybe<Scalars['Int']['input']>
}

export type AddGroupInput = {
    autoMembershipFields?: InputMaybe<
        Array<InputMaybe<AutoMembershipFieldInput>>
    >
    autoNotification?: InputMaybe<Scalars['Boolean']['input']>
    defaultTagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    defaultTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    featured?: InputMaybe<FeaturedInput>
    fileNotification?: InputMaybe<Scalars['Boolean']['input']>
    iconGuid?: InputMaybe<Scalars['String']['input']>
    introduction?: InputMaybe<Scalars['String']['input']>
    isAutoMembershipEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isChatEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isClosed?: InputMaybe<Scalars['Boolean']['input']>
    isCollaboraEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isFeatured?: InputMaybe<Scalars['Boolean']['input']>
    isHidden?: InputMaybe<Scalars['Boolean']['input']>
    isIntroductionPublic?: InputMaybe<Scalars['Boolean']['input']>
    isJoinButtonVisible?: InputMaybe<Scalars['Boolean']['input']>
    isLeavingGroupDisabled?: InputMaybe<Scalars['Boolean']['input']>
    /** True when membership has to be requested by the user, False when every user can join the group. */
    isMembershipOnRequest?: InputMaybe<Scalars['Boolean']['input']>
    isMenuAlwaysVisible?: InputMaybe<Scalars['Boolean']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    menu?: InputMaybe<Array<InputMaybe<GroupMenuItemInput>>>
    name?: InputMaybe<Scalars['String']['input']>
    plugins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    requiredProfileFieldGuids?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    requiredProfileFieldsMessage?: InputMaybe<Scalars['String']['input']>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    showMemberProfileFieldGuids?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    vcardFieldGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    welcomeMessage?: InputMaybe<Scalars['String']['input']>
}

export type AddPadInput = {
    accessId?: InputMaybe<Scalars['Int']['input']>
    containerGuid: Scalars['String']['input']
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    richDescription: Scalars['SecureRichText']['input']
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Scalars['String']['input']>
    writeAccessId?: InputMaybe<Scalars['Int']['input']>
}

export type AddPageInput = {
    accessControl?: InputMaybe<Array<InputMaybe<AccessItemInput>>>
    accessId?: InputMaybe<Scalars['Int']['input']>
    containerGuid?: InputMaybe<Scalars['String']['input']>
    groupGuid?: InputMaybe<Scalars['String']['input']>
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    pageType?: InputMaybe<Scalars['String']['input']>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    rows?: InputMaybe<Array<InputMaybe<RowInput>>>
    scheduleArchiveEntity?: InputMaybe<Scalars['DateTime']['input']>
    showNavigation?: InputMaybe<Scalars['Boolean']['input']>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    timePublished?: InputMaybe<Scalars['DateTime']['input']>
    title?: InputMaybe<Scalars['String']['input']>
    urlSlug?: InputMaybe<Scalars['String']['input']>
}

export type AddPodcastInput = {
    abstract?: InputMaybe<Scalars['SecureRichText']['input']>
    accessId?: InputMaybe<Scalars['Int']['input']>
    authors?: InputMaybe<Array<InputMaybe<PodcastAuthorInput>>>
    groupGuid?: InputMaybe<Scalars['String']['input']>
    iconGuid?: InputMaybe<Scalars['String']['input']>
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isFeatured?: InputMaybe<Scalars['Boolean']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    scheduleArchiveEntity?: InputMaybe<Scalars['DateTime']['input']>
    scheduleDeleteEntity?: InputMaybe<Scalars['DateTime']['input']>
    suggestedItems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    timePublished?: InputMaybe<Scalars['DateTime']['input']>
    title?: InputMaybe<Scalars['String']['input']>
    writeAccessId?: InputMaybe<Scalars['Int']['input']>
}

export type AddPollInput = {
    accessId?: InputMaybe<Scalars['Int']['input']>
    choices: Array<InputMaybe<Scalars['String']['input']>>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    title: Scalars['String']['input']
    voteWithoutAccount?: InputMaybe<Scalars['Boolean']['input']>
}

export type AddRssEndpointPayload = {
    __typename: 'addRssEndpointPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type AddSiteSettingProfileFieldInput = {
    autocomplete?: InputMaybe<Scalars['String']['input']>
    fieldOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    fieldType: Scalars['String']['input']
    isEditable?: InputMaybe<Scalars['Boolean']['input']>
    isFilter?: InputMaybe<Scalars['Boolean']['input']>
    isInAdminOverview?: InputMaybe<Scalars['Boolean']['input']>
    isInAutoGroupMembership?: InputMaybe<Scalars['Boolean']['input']>
    isInOverview?: InputMaybe<Scalars['Boolean']['input']>
    isOnVcard?: InputMaybe<Scalars['Boolean']['input']>
    key?: InputMaybe<Scalars['String']['input']>
    name: Scalars['String']['input']
    profileFieldValidatorId?: InputMaybe<Scalars['String']['input']>
}

export type AddSiteSettingProfileFieldValidatorInput = {
    name: Scalars['String']['input']
    type: ProfileFieldValidatorType
    validationListFile?: InputMaybe<Scalars['Upload']['input']>
    validationString?: InputMaybe<Scalars['String']['input']>
}

export type AddSubgroupInput = {
    groupGuid?: InputMaybe<Scalars['String']['input']>
    members?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    name?: InputMaybe<Scalars['String']['input']>
}

export type AddTagCollectionInput = {
    label: Scalars['String']['input']
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<Scalars['String']['input']>>
}

export type AddWebPushSubscriptionInput = {
    auth: Scalars['String']['input']
    browser: Scalars['String']['input']
    endpoint: Scalars['String']['input']
    p256dh: Scalars['String']['input']
}

export type ArchiveEntitiesInput = {
    guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type AttendEventInput = {
    /**  If there is a form configured and enabled on the event, fill out the form  */
    formResponse?: InputMaybe<Array<InputMaybe<EntityFormResponseInput>>>
    guid?: InputMaybe<Scalars['String']['input']>
    state?: InputMaybe<Scalars['String']['input']>
    /**  Apply the change to related subscriptions  */
    updateSubEvents?: InputMaybe<Scalars['Boolean']['input']>
}

export type AttendEventWithoutAccountInput = {
    email: Scalars['String']['input']
    guid: Scalars['String']['input']
    name: Scalars['String']['input']
    resend?: InputMaybe<Scalars['Boolean']['input']>
}

export type BookmarkInput = {
    /** The guid of the entity to bookmark. */
    guid: Scalars['String']['input']
    /** True when adding, false when removing. */
    isAdding: Scalars['Boolean']['input']
}

export type BookmarkPayload = {
    __typename: 'bookmarkPayload'
    object: Entity
}

export type ChangeGroupOwnerInput = {
    /** The group guid. */
    guid?: InputMaybe<Scalars['String']['input']>
    /** The user guid. */
    userGuid?: InputMaybe<Scalars['String']['input']>
}

export type ColumnInput = {
    widgets?: InputMaybe<Array<InputMaybe<WidgetInput>>>
    width?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type CopyEntityInput = {
    copySubevents?: InputMaybe<Scalars['Boolean']['input']>
    guid: Scalars['String']['input']
    ownerGuid?: InputMaybe<Scalars['String']['input']>
    /**  TODO: Het veld `subtype` is overbodig. Kan weg zodra FE het niet meer gebruikt  */
    subtype?: InputMaybe<Scalars['String']['input']>
}

export type DeleteChatMessageInput = {
    guid: Scalars['String']['input']
}

export type DeleteEntitiesInput = {
    guids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type DeleteEntityInput = {
    fromFlow?: InputMaybe<Scalars['Boolean']['input']>
    guid: Scalars['String']['input']
    isScheduled?: InputMaybe<Scalars['Boolean']['input']>
    recursive?: InputMaybe<RecursiveDeleteOption>
}

export type DeleteEventAttendeesInput = {
    /** Email addresses of attendees to be removed */
    emailAddresses?: InputMaybe<Array<Scalars['String']['input']>>
    /** Event guid */
    guid: Scalars['String']['input']
    /**  Apply the change to related subscriptions  */
    updateSubEvents?: InputMaybe<Scalars['Boolean']['input']>
}

export type DeleteGroupInvitationInput = {
    /** The id of the invitation to delete. */
    id?: InputMaybe<Scalars['Int']['input']>
}

export type DeleteQaPairPayload = {
    __typename: 'deleteQAPairPayload'
    success: Maybe<Scalars['Boolean']['output']>
}

export type DeleteSiteSettingProfileFieldInput = {
    guid: Scalars['String']['input']
}

export type DeleteSiteSettingProfileFieldValidatorInput = {
    id: Scalars['String']['input']
}

export type DeleteSubgroupInput = {
    id: Scalars['Int']['input']
}

export type DeleteTagCollectionInput = {
    guid: Scalars['String']['input']
}

export type DeleteUsersInput = {
    guids?: InputMaybe<Array<Scalars['String']['input']>>
}

export type EditChatInput = {
    guid: Scalars['String']['input']
    isNotificationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type EditChatMessageInput = {
    guid: Scalars['String']['input']
    richDescription: Scalars['SecureRichText']['input']
}

export type EditEmailOverviewInput = {
    enabled?: InputMaybe<Scalars['Boolean']['input']>
    frequency?: InputMaybe<Frequency>
    guid?: InputMaybe<Scalars['String']['input']>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type EditEntityBulkInput = {
    ownerGuid?: InputMaybe<Scalars['String']['input']>
}

export type EditEntityInput = {
    abstract?: InputMaybe<Scalars['SecureRichText']['input']>
    accessId?: InputMaybe<Scalars['Int']['input']>
    articles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    attendEventOnline?: InputMaybe<Scalars['Boolean']['input']>
    attendEventWithoutAccount?: InputMaybe<Scalars['Boolean']['input']>
    attendeeWelcomeMailContent?: InputMaybe<Scalars['SecureRichText']['input']>
    attendeeWelcomeMailSubject?: InputMaybe<Scalars['String']['input']>
    backgroundColor?: InputMaybe<Scalars['String']['input']>
    colophon?: InputMaybe<Array<InputMaybe<ColophonValueInput>>>
    colophonFields?: InputMaybe<Array<InputMaybe<ColophonFieldInput>>>
    containerGuid?: InputMaybe<Scalars['String']['input']>
    enableMaybeAttendEvent?: InputMaybe<Scalars['Boolean']['input']>
    endDate?: InputMaybe<Scalars['DateTime']['input']>
    featured?: InputMaybe<FeaturedInput>
    form?: InputMaybe<EntityFormInput>
    formResponse?: InputMaybe<Array<InputMaybe<EntityFormResponseInput>>>
    fromFlow?: InputMaybe<Scalars['Boolean']['input']>
    groupGuid?: InputMaybe<Scalars['String']['input']>
    guid: Scalars['String']['input']
    iconGuid?: InputMaybe<Scalars['String']['input']>
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isAccessRecursive?: InputMaybe<Scalars['Boolean']['input']>
    isFeatured?: InputMaybe<Scalars['Boolean']['input']>
    isFormEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isRecommended?: InputMaybe<Scalars['Boolean']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    issueNumber?: InputMaybe<Scalars['Int']['input']>
    location?: InputMaybe<Scalars['String']['input']>
    locationAddress?: InputMaybe<Scalars['String']['input']>
    locationLink?: InputMaybe<Scalars['String']['input']>
    maxAttendees?: InputMaybe<Scalars['String']['input']>
    mentions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    ownerGuid?: InputMaybe<Scalars['String']['input']>
    qrAccess?: InputMaybe<Scalars['Boolean']['input']>
    rangeSettings?: InputMaybe<EventRangeSettingsInput>
    requireAttendParent?: InputMaybe<Scalars['Boolean']['input']>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    rsvp?: InputMaybe<Scalars['Boolean']['input']>
    scheduleArchiveEntity?: InputMaybe<Scalars['DateTime']['input']>
    scheduleDeleteEntity?: InputMaybe<Scalars['DateTime']['input']>
    showTableOfContents?: InputMaybe<Scalars['Boolean']['input']>
    slotsAvailable?: InputMaybe<Array<InputMaybe<EventSlotInput>>>
    source?: InputMaybe<Scalars['String']['input']>
    startDate?: InputMaybe<Scalars['DateTime']['input']>
    subtitle?: InputMaybe<Scalars['String']['input']>
    suggestedItems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    ticketLink?: InputMaybe<Scalars['String']['input']>
    timeCreated?: InputMaybe<Scalars['DateTime']['input']>
    timePublished?: InputMaybe<Scalars['DateTime']['input']>
    title?: InputMaybe<Scalars['String']['input']>
    urlSlug?: InputMaybe<Scalars['String']['input']>
    videoCallEnabled?: InputMaybe<Scalars['Boolean']['input']>
    videoCallModeratorUserGuids?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    writeAccessId?: InputMaybe<Scalars['Int']['input']>
}

export type EditEpisodeInput = {
    abstract?: InputMaybe<Scalars['SecureRichText']['input']>
    accessId?: InputMaybe<Scalars['Int']['input']>
    fileGuid?: InputMaybe<Scalars['String']['input']>
    guid?: InputMaybe<Scalars['String']['input']>
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isFeatured?: InputMaybe<Scalars['Boolean']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    ownerGuid?: InputMaybe<Scalars['String']['input']>
    podcastGuid?: InputMaybe<Scalars['String']['input']>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    scheduleArchiveEntity?: InputMaybe<Scalars['DateTime']['input']>
    scheduleDeleteEntity?: InputMaybe<Scalars['DateTime']['input']>
    suggestedItems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    timeCreated?: InputMaybe<Scalars['DateTime']['input']>
    timePublished?: InputMaybe<Scalars['DateTime']['input']>
    title?: InputMaybe<Scalars['String']['input']>
    writeAccessId?: InputMaybe<Scalars['Int']['input']>
}

export type EditEventAttendeeInput = {
    /** Email addresses of attendee to edit */
    emailAddress: Scalars['String']['input']
    /** Event guid */
    guid: Scalars['String']['input']
    /** Fields than can be edited */
    timeCheckedIn?: InputMaybe<Scalars['DateTime']['input']>
}

export type EditFileFolderInput = {
    accessId?: InputMaybe<Scalars['Int']['input']>
    file?: InputMaybe<Scalars['Upload']['input']>
    guid?: InputMaybe<Scalars['String']['input']>
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isAccessRecursive?: InputMaybe<Scalars['Boolean']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    keepPreviousAsVersion?: InputMaybe<Scalars['Boolean']['input']>
    ownerGuid?: InputMaybe<Scalars['String']['input']>
    ownerGuidRecursive?: InputMaybe<UpdateOwnerRecursive>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    scheduleArchiveEntity?: InputMaybe<Scalars['DateTime']['input']>
    scheduleDeleteEntity?: InputMaybe<Scalars['DateTime']['input']>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    timePublished?: InputMaybe<Scalars['DateTime']['input']>
    title?: InputMaybe<Scalars['String']['input']>
    versionComment?: InputMaybe<Scalars['String']['input']>
    writeAccessId?: InputMaybe<Scalars['Int']['input']>
}

export type EditGroupInput = {
    autoMembershipFields?: InputMaybe<
        Array<InputMaybe<AutoMembershipFieldInput>>
    >
    autoNotification?: InputMaybe<Scalars['Boolean']['input']>
    defaultTagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    defaultTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    featured?: InputMaybe<FeaturedInput>
    fileNotification?: InputMaybe<Scalars['Boolean']['input']>
    guid?: InputMaybe<Scalars['String']['input']>
    iconGuid?: InputMaybe<Scalars['String']['input']>
    introduction?: InputMaybe<Scalars['String']['input']>
    isAutoMembershipEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isChatEnabled?: InputMaybe<Scalars['Boolean']['input']>
    /** True when membership has to be requested by the user, False when every user can join the group. */
    isClosed?: InputMaybe<Scalars['Boolean']['input']>
    isCollaboraEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isFeatured?: InputMaybe<Scalars['Boolean']['input']>
    isHidden?: InputMaybe<Scalars['Boolean']['input']>
    isIntroductionPublic?: InputMaybe<Scalars['Boolean']['input']>
    isJoinButtonVisible?: InputMaybe<Scalars['Boolean']['input']>
    isLeavingGroupDisabled?: InputMaybe<Scalars['Boolean']['input']>
    /** True when membership has to be requested by the user, False when every user can join the group. */
    isMembershipOnRequest?: InputMaybe<Scalars['Boolean']['input']>
    isMenuAlwaysVisible?: InputMaybe<Scalars['Boolean']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    menu?: InputMaybe<Array<InputMaybe<GroupMenuItemInput>>>
    name?: InputMaybe<Scalars['String']['input']>
    plugins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    requiredProfileFieldGuids?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    requiredProfileFieldsMessage?: InputMaybe<Scalars['String']['input']>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    showMemberProfileFieldGuids?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    startPageGuid?: InputMaybe<Scalars['String']['input']>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    vcardFieldGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    welcomeMessage?: InputMaybe<Scalars['String']['input']>
}

export type EditGroupNotificationsInput = {
    guid: Scalars['String']['input']
    isNotificationDirectMailEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isNotificationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>
    userGuid?: InputMaybe<Scalars['String']['input']>
}

export type EditNotificationsInput = {
    emailNotifications?: InputMaybe<Scalars['Boolean']['input']>
    emailNotificationsFrequency?: InputMaybe<Scalars['Int']['input']>
    guid: Scalars['String']['input']
    isChatGroupNotificationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isChatUsersNotificationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isCommentNotificationDirectMailEnabled?: InputMaybe<
        Scalars['Boolean']['input']
    >
    isCommentNotificationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isCommentNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isMentionNotificationDirectMailEnabled?: InputMaybe<
        Scalars['Boolean']['input']
    >
    isMentionNotificationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>
    isMentionNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>
    language?: InputMaybe<Scalars['String']['input']>
    newsletter?: InputMaybe<Scalars['Boolean']['input']>
}

export type EditPadInput = {
    accessId?: InputMaybe<Scalars['Int']['input']>
    guid: Scalars['String']['input']
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    state?: InputMaybe<Scalars['String']['input']>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    title?: InputMaybe<Scalars['String']['input']>
    writeAccessId?: InputMaybe<Scalars['Int']['input']>
}

export type EditPageInput = {
    accessControl?: InputMaybe<Array<InputMaybe<AccessItemInput>>>
    accessId?: InputMaybe<Scalars['Int']['input']>
    containerGuid?: InputMaybe<Scalars['String']['input']>
    guid: Scalars['String']['input']
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isAccessRecursive?: InputMaybe<Scalars['Boolean']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    rows?: InputMaybe<Array<InputMaybe<RowInput>>>
    scheduleArchiveEntity?: InputMaybe<Scalars['DateTime']['input']>
    showNavigation?: InputMaybe<Scalars['Boolean']['input']>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    timePublished?: InputMaybe<Scalars['DateTime']['input']>
    title?: InputMaybe<Scalars['String']['input']>
    urlSlug?: InputMaybe<Scalars['String']['input']>
    writeAccessId?: InputMaybe<Scalars['Int']['input']>
}

export type EditPodcastInput = {
    abstract?: InputMaybe<Scalars['SecureRichText']['input']>
    accessId?: InputMaybe<Scalars['Int']['input']>
    authors?: InputMaybe<Array<InputMaybe<PodcastAuthorInput>>>
    groupGuid?: InputMaybe<Scalars['String']['input']>
    guid?: InputMaybe<Scalars['String']['input']>
    iconGuid?: InputMaybe<Scalars['String']['input']>
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isFeatured?: InputMaybe<Scalars['Boolean']['input']>
    isRecommendedInSearch?: InputMaybe<Scalars['Boolean']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    ownerGuid?: InputMaybe<Scalars['String']['input']>
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    scheduleArchiveEntity?: InputMaybe<Scalars['DateTime']['input']>
    scheduleDeleteEntity?: InputMaybe<Scalars['DateTime']['input']>
    suggestedItems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    timeCreated?: InputMaybe<Scalars['DateTime']['input']>
    timePublished?: InputMaybe<Scalars['DateTime']['input']>
    title?: InputMaybe<Scalars['String']['input']>
    writeAccessId?: InputMaybe<Scalars['Int']['input']>
}

export type EditPollInput = {
    accessId?: InputMaybe<Scalars['Int']['input']>
    choices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    guid: Scalars['String']['input']
    richDescription?: InputMaybe<Scalars['SecureRichText']['input']>
    title?: InputMaybe<Scalars['String']['input']>
    voteWithoutAccount?: InputMaybe<Scalars['Boolean']['input']>
}

export type EditProfileFieldInput = {
    fields?: InputMaybe<Array<InputMaybe<ProfileFieldInput>>>
    guid: Scalars['String']['input']
}

export type EditSiteSettingInput = {
    allowRegistration?: InputMaybe<Scalars['Boolean']['input']>
    anonymousStartPage?: InputMaybe<Scalars['String']['input']>
    anonymousStartPageCms?: InputMaybe<Scalars['String']['input']>
    appointmentTypeVideocall?: InputMaybe<
        Array<InputMaybe<AppointmentTypeInput>>
    >
    archiveDueDays?: InputMaybe<Scalars['Int']['input']>
    autoApproveSSO?: InputMaybe<Scalars['Boolean']['input']>
    autoArchiveContentTypes?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    blockUserOnEmailChange?: InputMaybe<Scalars['Boolean']['input']>
    blockedUserIntroMessage?: InputMaybe<Scalars['SecureRichText']['input']>
    blueBillywigVideoEnabled?: InputMaybe<Scalars['Boolean']['input']>
    cancelMembershipEnabled?: InputMaybe<Scalars['Boolean']['input']>
    collabEditingEnabled?: InputMaybe<Scalars['Boolean']['input']>
    collaboraPerGroup?: InputMaybe<Scalars['Boolean']['input']>
    colorHeader?: InputMaybe<Scalars['String']['input']>
    colorPrimary?: InputMaybe<Scalars['String']['input']>
    colorSecondary?: InputMaybe<Scalars['String']['input']>
    commentWithoutAccountEnabled?: InputMaybe<Scalars['Boolean']['input']>
    commentsOnNews?: InputMaybe<Scalars['Boolean']['input']>
    contentAllowedTagCategories?: InputMaybe<
        Array<InputMaybe<ContentAllowedTagCategoryInput>>
    >
    cookieConsent?: InputMaybe<Scalars['Boolean']['input']>
    customCss?: InputMaybe<Scalars['String']['input']>
    customTagsAllowed?: InputMaybe<Scalars['Boolean']['input']>
    defaultEmailOverviewFrequency?: InputMaybe<Scalars['String']['input']>
    defaultReadAccessId?: InputMaybe<Scalars['Int']['input']>
    defaultSearchDirection?: InputMaybe<OrderDirection>
    defaultSearchOrderBy?: InputMaybe<SearchOrderBy>
    description?: InputMaybe<Scalars['String']['input']>
    directLinks?: InputMaybe<Array<InputMaybe<DirectLinkInput>>>
    /** users with email adress in domain of directRegistrationDomains, can register even when allowRegistration is False */
    directRegistrationDomains?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    emailFooterImageAlt?: InputMaybe<Scalars['String']['input']>
    emailFooterImageEnabled?: InputMaybe<Scalars['Boolean']['input']>
    emailFooterImageGuid?: InputMaybe<Scalars['String']['input']>
    emailFooterImageLink?: InputMaybe<Scalars['String']['input']>
    emailNotificationShowExcerpt?: InputMaybe<Scalars['Boolean']['input']>
    emailOverviewEnableFeatured?: InputMaybe<Scalars['Boolean']['input']>
    emailOverviewFeaturedTitle?: InputMaybe<Scalars['String']['input']>
    emailOverviewIntro?: InputMaybe<Scalars['String']['input']>
    emailOverviewSubject?: InputMaybe<Scalars['String']['input']>
    emailOverviewTitle?: InputMaybe<Scalars['String']['input']>
    enableDocumentLocking?: InputMaybe<Scalars['Boolean']['input']>
    enableFeedSorting?: InputMaybe<Scalars['Boolean']['input']>
    enableSharing?: InputMaybe<Scalars['Boolean']['input']>
    eventExport?: InputMaybe<Scalars['Boolean']['input']>
    eventTiles?: InputMaybe<Scalars['Boolean']['input']>
    extraLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    favicon?: InputMaybe<Scalars['Upload']['input']>
    fileDescriptionFieldEnabled?: InputMaybe<Scalars['Boolean']['input']>
    flowAppUrl?: InputMaybe<Scalars['String']['input']>
    flowCaseId?: InputMaybe<Scalars['Int']['input']>
    flowEnabled?: InputMaybe<Scalars['Boolean']['input']>
    flowSubtypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    flowToken?: InputMaybe<Scalars['String']['input']>
    flowUserGuid?: InputMaybe<Scalars['String']['input']>
    fontBody?: InputMaybe<Scalars['String']['input']>
    fontHeading?: InputMaybe<Scalars['String']['input']>
    footer?: InputMaybe<Array<InputMaybe<FooterInput>>>
    footerPageEnabled?: InputMaybe<Scalars['Boolean']['input']>
    groupMemberExport?: InputMaybe<Scalars['Boolean']['input']>
    hideAccessLevelSelect?: InputMaybe<Scalars['Boolean']['input']>
    hideContentOwner?: InputMaybe<Array<InputMaybe<NotificationContentType>>>
    icon?: InputMaybe<Scalars['Upload']['input']>
    iconAlt?: InputMaybe<Scalars['String']['input']>
    idpId?: InputMaybe<Scalars['String']['input']>
    idpName?: InputMaybe<Scalars['String']['input']>
    initiativeDescription?: InputMaybe<Scalars['String']['input']>
    initiativeImage?: InputMaybe<Scalars['String']['input']>
    initiativeImageAlt?: InputMaybe<Scalars['String']['input']>
    initiativeLink?: InputMaybe<Scalars['String']['input']>
    initiativeTitle?: InputMaybe<Scalars['String']['input']>
    isClosed?: InputMaybe<Scalars['Boolean']['input']>
    isDiscloseVotingUsersEnabled?: InputMaybe<Scalars['Boolean']['input']>
    kalturaVideoEnabled?: InputMaybe<Scalars['Boolean']['input']>
    kalturaVideoPartnerId?: InputMaybe<Scalars['String']['input']>
    kalturaVideoPlayerId?: InputMaybe<Scalars['String']['input']>
    language?: InputMaybe<Scalars['String']['input']>
    leaderImage?: InputMaybe<Scalars['String']['input']>
    likeIcon?: InputMaybe<Scalars['String']['input']>
    loginIntro?: InputMaybe<Scalars['String']['input']>
    logo?: InputMaybe<Scalars['Upload']['input']>
    logoAlt?: InputMaybe<Scalars['String']['input']>
    matomoId?: InputMaybe<Scalars['String']['input']>
    matomoUrl?: InputMaybe<Scalars['String']['input']>
    maxCharactersInAbstract?: InputMaybe<Scalars['Int']['input']>
    menu?: InputMaybe<Array<InputMaybe<MenuItemInput>>>
    menuState?: InputMaybe<MenuState>
    name?: InputMaybe<Scalars['String']['input']>
    newsletter?: InputMaybe<Scalars['Boolean']['input']>
    notFoundPageCustomDescription?: InputMaybe<
        Scalars['SecureRichText']['input']
    >
    notFoundPageCustomDescriptionEnabled?: InputMaybe<
        Scalars['Boolean']['input']
    >
    notFoundPageCustomImageAlt?: InputMaybe<Scalars['String']['input']>
    notFoundPageCustomImageGuid?: InputMaybe<Scalars['String']['input']>
    notFoundPageCustomTitle?: InputMaybe<Scalars['String']['input']>
    notFoundPageCustomTitleEnabled?: InputMaybe<Scalars['Boolean']['input']>
    notFoundPageShowImage?: InputMaybe<Scalars['Boolean']['input']>
    notifyAdminsOnEmailChangeBlock?: InputMaybe<Scalars['Boolean']['input']>
    numberOfFeaturedItems?: InputMaybe<Scalars['Int']['input']>
    onboardingEnabled?: InputMaybe<Scalars['Boolean']['input']>
    onboardingForceExistingUsers?: InputMaybe<Scalars['Boolean']['input']>
    onboardingIntro?: InputMaybe<Scalars['String']['input']>
    onboardingProfileFields?: InputMaybe<
        Array<InputMaybe<OnboardingProfileFieldInput>>
    >
    openForCreateContentTypes?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    pageTagFilters?: InputMaybe<Array<InputMaybe<PageTagFilterInput>>>
    pdfCheckerEnabled?: InputMaybe<Scalars['Boolean']['input']>
    preserveFileExif?: InputMaybe<Scalars['Boolean']['input']>
    profile?: InputMaybe<Array<InputMaybe<ProfileItemInput>>>
    profileSections?: InputMaybe<Array<InputMaybe<ProfileSectionInput>>>
    profileSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>
    profileSyncToken?: InputMaybe<Scalars['String']['input']>
    pushNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>
    questionLockAfterActivity?: InputMaybe<Scalars['Boolean']['input']>
    questionLockAfterActivityLink?: InputMaybe<Scalars['String']['input']>
    questionerCanChooseBestAnswer?: InputMaybe<Scalars['Boolean']['input']>
    recommendedType?: InputMaybe<RecommendedTypeEnum>
    redirects?: InputMaybe<Array<InputMaybe<RedirectInput>>>
    removeFavicon?: InputMaybe<Scalars['Boolean']['input']>
    removeIcon?: InputMaybe<Scalars['Boolean']['input']>
    removeLogo?: InputMaybe<Scalars['Boolean']['input']>
    require2FA?: InputMaybe<Require2FaLevelEnum>
    requireCommentModerationFor?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    requireContentModerationFor?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    searchArchiveOption?: InputMaybe<SearchArchiveOptionEnum>
    searchDisplayedFilters?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    searchEngineIndexingEnabled?: InputMaybe<Scalars['Boolean']['input']>
    searchExcludedContentTypes?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    searchTagFilters?: InputMaybe<Array<InputMaybe<SearchTagFilterInput>>>
    securityText?: InputMaybe<Scalars['String']['input']>
    securityTextEnabled?: InputMaybe<Scalars['Boolean']['input']>
    securityTextPGP?: InputMaybe<Scalars['String']['input']>
    securityTextRedirectEnabled?: InputMaybe<Scalars['Boolean']['input']>
    securityTextRedirectUrl?: InputMaybe<Scalars['String']['input']>
    showCustomTagsInDetail?: InputMaybe<Scalars['Boolean']['input']>
    showCustomTagsInFeed?: InputMaybe<Scalars['Boolean']['input']>
    showExcerptInNewsCard?: InputMaybe<Scalars['Boolean']['input']>
    showExtraHomepageFilters?: InputMaybe<Scalars['Boolean']['input']>
    showFollowersContentTypes?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    showIcon?: InputMaybe<Scalars['Boolean']['input']>
    showInitiative?: InputMaybe<Scalars['Boolean']['input']>
    showLeader?: InputMaybe<Scalars['Boolean']['input']>
    showLeaderButtons?: InputMaybe<Scalars['Boolean']['input']>
    showLoginRegister?: InputMaybe<Scalars['Boolean']['input']>
    showOriginalFileName?: InputMaybe<Scalars['Boolean']['input']>
    showPreheader?: InputMaybe<Scalars['Boolean']['input']>
    showSuggestedItems?: InputMaybe<Scalars['Boolean']['input']>
    showTagsInDetail?: InputMaybe<Scalars['Boolean']['input']>
    showTagsInFeed?: InputMaybe<Scalars['Boolean']['input']>
    showUpDownVoting?: InputMaybe<Scalars['Boolean']['input']>
    showViewsCount?: InputMaybe<Scalars['Boolean']['input']>
    siteMembershipAcceptedIntro?: InputMaybe<Scalars['String']['input']>
    siteMembershipAcceptedSubject?: InputMaybe<Scalars['String']['input']>
    siteMembershipDeniedIntro?: InputMaybe<Scalars['String']['input']>
    siteMembershipDeniedSubject?: InputMaybe<Scalars['String']['input']>
    startPage?: InputMaybe<Scalars['String']['input']>
    startPageCms?: InputMaybe<Scalars['String']['input']>
    statusUpdateGroups?: InputMaybe<Scalars['Boolean']['input']>
    subgroups?: InputMaybe<Scalars['Boolean']['input']>
    subtitle?: InputMaybe<Scalars['String']['input']>
    theme?: InputMaybe<Scalars['String']['input']>
    walledGardenByIpEnabled?: InputMaybe<Scalars['Boolean']['input']>
    whitelistedIpRanges?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>>
    >
    whoCanCreateGroup?: InputMaybe<GroupAddPermission>
}

export type EditSiteSettingProfileFieldInput = {
    autocomplete?: InputMaybe<Scalars['String']['input']>
    fieldOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    guid: Scalars['String']['input']
    isEditable?: InputMaybe<Scalars['Boolean']['input']>
    isFilter?: InputMaybe<Scalars['Boolean']['input']>
    isInAdminOverview?: InputMaybe<Scalars['Boolean']['input']>
    isInAutoGroupMembership?: InputMaybe<Scalars['Boolean']['input']>
    isInOverview?: InputMaybe<Scalars['Boolean']['input']>
    isOnVcard?: InputMaybe<Scalars['Boolean']['input']>
    key?: InputMaybe<Scalars['String']['input']>
    name?: InputMaybe<Scalars['String']['input']>
    profileFieldValidatorId?: InputMaybe<Scalars['String']['input']>
}

export type EditSiteSettingProfileFieldValidatorInput = {
    id: Scalars['String']['input']
    name?: InputMaybe<Scalars['String']['input']>
    validationListFile?: InputMaybe<Scalars['Upload']['input']>
    validationString?: InputMaybe<Scalars['String']['input']>
}

export type EditSubgroupInput = {
    id?: InputMaybe<Scalars['Int']['input']>
    members?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    name?: InputMaybe<Scalars['String']['input']>
}

export type EditTagCollectionInput = {
    emailNotifications?: InputMaybe<Scalars['Boolean']['input']>
    guid: Scalars['String']['input']
    label: Scalars['String']['input']
    siteNotifications?: InputMaybe<Scalars['Boolean']['input']>
    tagCategories?: InputMaybe<Array<InputMaybe<TagCategoryInput>>>
    tags?: InputMaybe<Array<Scalars['String']['input']>>
}

export type EditTaskInput = {
    guid?: InputMaybe<Scalars['String']['input']>
    inputLanguage?: InputMaybe<Scalars['String']['input']>
    isTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>
    state?: InputMaybe<Scalars['String']['input']>
}

export type EditTaskStateInput = {
    guid: Scalars['String']['input']
    state: Scalars['String']['input']
}

export enum EditUserAction {
    Ban = 'ban',
    Unban = 'unban',
}

export type EditUserNameInput = {
    guid: Scalars['String']['input']
    name?: InputMaybe<Scalars['String']['input']>
}

export type EditUsersInput = {
    action: EditUserAction
    banReason?: InputMaybe<Scalars['String']['input']>
    guids: Array<InputMaybe<Scalars['String']['input']>>
}

export enum Feedback {
    Accepted = 'ACCEPTED',
    Rejected = 'REJECTED',
}

export type FollowInput = {
    /** The guid of the entity to follow. */
    guid: Scalars['String']['input']
    /** True for following, false for not following. */
    isFollowing: Scalars['Boolean']['input']
}

export type FollowPayload = {
    __typename: 'followPayload'
    object: Entity
}

export type HandleDeleteAccountRequestInput = {
    /** Set true to accept or false to deny. */
    accept: Scalars['Boolean']['input']
    guid: Scalars['String']['input']
}

export type HandleSiteAccessRequestInput = {
    /** Set true to accept or false to deny. */
    accept: Scalars['Boolean']['input']
    emailAddresses: Array<Scalars['String']['input']>
    message?: InputMaybe<Scalars['String']['input']>
    /** Silently deny or accept. When set to true no email will be send to the user. */
    silent?: InputMaybe<Scalars['Boolean']['input']>
}

export type ImportUsersStep1Input = {
    /** A list of email addresses to revoke invite for. */
    usersCsv: Scalars['Upload']['input']
}

export type ImportUsersStep2Input = {
    fields?: InputMaybe<Array<ImportUserFieldInput>>
    /** Start a background process for creating/updating users */
    importId: Scalars['String']['input']
}

export type InviteToEventInput = {
    /** Event guid */
    guid: Scalars['String']['input']
    resend?: InputMaybe<Scalars['Boolean']['input']>
    /** Email address or user to invite */
    users?: InputMaybe<Array<UserOrEmail>>
}

export type InviteToGroupInput = {
    /** Directly add the users to the group without sending an invite */
    directAdd?: InputMaybe<Scalars['Boolean']['input']>
    /** The guid of the group to invite to. */
    guid: Scalars['String']['input']
    /** A list of users to invite. */
    users?: InputMaybe<Array<InputMaybe<InviteToGroupUser>>>
}

export type InviteToSiteInput = {
    /** A list of email addresses to invite to site. */
    emailAddresses?: InputMaybe<Array<Scalars['String']['input']>>
    /** Message in email sent with invite */
    message?: InputMaybe<Scalars['String']['input']>
}

export type JoinGroupInput = {
    /** The guid of the group to join. */
    guid?: InputMaybe<Scalars['String']['input']>
}

export type LeaveGroupInput = {
    /** The guid of the group to leave. */
    guid?: InputMaybe<Scalars['String']['input']>
}

export type MarkAllAsReadInput = {
    id?: InputMaybe<Scalars['String']['input']>
}

export type MarkAsReadInput = {
    id?: InputMaybe<Scalars['Int']['input']>
}

export type MoveFileFolderInput = {
    containerGuid?: InputMaybe<Scalars['String']['input']>
    guid?: InputMaybe<Scalars['String']['input']>
}

export type ProfileFieldInput = {
    accessId?: InputMaybe<Scalars['Int']['input']>
    key?: InputMaybe<Scalars['String']['input']>
    value?: InputMaybe<Scalars['String']['input']>
}

export type ProfileFieldResponse = {
    __typename: 'profileFieldResponse'
    key: Maybe<Scalars['String']['output']>
    message: Maybe<Scalars['String']['output']>
}

export type RejectMembershipRequestInput = {
    /** The guid of the group. */
    groupGuid?: InputMaybe<Scalars['String']['input']>
    /** The guid of the user. */
    userGuid?: InputMaybe<Scalars['String']['input']>
}

export type RemoveGroupMembersInput = {
    /** The group guid. */
    guid?: InputMaybe<Scalars['String']['input']>
    /** The user guids. */
    userGuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ReorderInput = {
    destinationPosition: Scalars['Int']['input']
    guid: Scalars['String']['input']
    sourcePosition: Scalars['Int']['input']
}

export type ReorderPayload = {
    __typename: 'reorderPayload'
    container: Entity
}

export type ResendGroupInvitationInput = {
    /** The id of the invitation to resend. */
    id?: InputMaybe<Scalars['Int']['input']>
}

export type RestoreCooldownContentInput = {
    guids?: InputMaybe<Array<Scalars['String']['input']>>
}

export type RevokeInviteToSiteInput = {
    /** A list of email addresses to revoke invite for. */
    emailAddresses?: InputMaybe<Array<Scalars['String']['input']>>
}

export type RowInput = {
    backgroundColor?: InputMaybe<Scalars['String']['input']>
    columns?: InputMaybe<Array<InputMaybe<ColumnInput>>>
    isFullWidth: Scalars['Boolean']['input']
}

export type ScheduleBanUsersInput = {
    banAt?: InputMaybe<Scalars['DateTime']['input']>
    banReason?: InputMaybe<Scalars['String']['input']>
    guids: Array<Scalars['String']['input']>
}

export type SearchTagFilter = {
    __typename: 'searchTagFilter'
    name: Scalars['String']['output']
    tagFilterEnabled: Maybe<Scalars['Boolean']['output']>
    tagFilterType: TagFilterTypeEnum
}

export type SearchTagFilterInput = {
    name: Scalars['String']['input']
    tagFilterEnabled?: InputMaybe<Scalars['Boolean']['input']>
    tagFilterType: TagFilterTypeEnum
}

export type SendMessageToEventInput = {
    /** The guid of the event */
    guid: Scalars['String']['input']
    isTest?: InputMaybe<Scalars['Boolean']['input']>
    message: Scalars['String']['input']
    sendCopyToSender?: InputMaybe<Scalars['Boolean']['input']>
    sendToStatus?: InputMaybe<Scalars['String']['input']>
    subject: Scalars['String']['input']
}

export type SendMessageToFollowersInput = {
    /** The guid of the entity whose followers will receive the message. */
    guid: Scalars['String']['input']
    /** Is this a test message (send only to current user)? */
    isTest?: InputMaybe<Scalars['Boolean']['input']>
    /** The message to send. */
    message: Scalars['String']['input']
    /** An (optional) list of specific followers (user guids) to send the message to. */
    recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    /** An (optional) parameter for sending a copy of the message to the sender. */
    sendCopyToSender?: InputMaybe<Scalars['Boolean']['input']>
    /** An (optional) parameter for sending the message to all followers of the entity. */
    sendToAllFollowers?: InputMaybe<Scalars['Boolean']['input']>
    /** The subject of the message. */
    subject: Scalars['String']['input']
}

export type SendMessageToGroupInput = {
    /** The guid of the group to send the message to. */
    guid?: InputMaybe<Scalars['String']['input']>
    /** Is this a test message (send only to current user) */
    isTest?: InputMaybe<Scalars['Boolean']['input']>
    /** The message to send. */
    message?: InputMaybe<Scalars['String']['input']>
    /** An (optional) list of recipients to send the message to. */
    recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    /** An (optional) parameter for sending a copy of the message to the sender */
    sendCopyToSender?: InputMaybe<Scalars['Boolean']['input']>
    /** An (optional) parameter for sending the message to all members of the group. */
    sendToAllMembers?: InputMaybe<Scalars['Boolean']['input']>
    /**  ID of a subgroup to send a message to  */
    subGroup?: InputMaybe<Scalars['Int']['input']>
    /** The subject of the message. */
    subject?: InputMaybe<Scalars['String']['input']>
}

export type SendMessageToUserInput = {
    /** The guid of the user to send the message to. */
    guid?: InputMaybe<Scalars['String']['input']>
    /** The message to send. */
    message?: InputMaybe<Scalars['String']['input']>
    sendCopyToSender?: InputMaybe<Scalars['Boolean']['input']>
    /** The subject of the message. */
    subject?: InputMaybe<Scalars['String']['input']>
}

export type SignSiteAgreementVersionInput = {
    accept: Scalars['Boolean']['input']
    id: Scalars['String']['input']
}

export enum TagFilterTypeEnum {
    Checkbox = 'checkbox',
    Cloud = 'cloud',
    Select = 'select',
}

export type TagMergeInput = {
    synonym: Scalars['String']['input']
    tag: Scalars['String']['input']
}

export type ToggleBestAnswerInput = {
    guid?: InputMaybe<Scalars['String']['input']>
}

export type ToggleChatReactionInput = {
    guid: Scalars['String']['input']
    unicode: Scalars['String']['input']
}

export type ToggleEntityIsPinnedInput = {
    guid: Scalars['String']['input']
}

export type ToggleGroupMemberRoleInput = {
    /** The group guid. */
    guid?: InputMaybe<Scalars['String']['input']>
    /** The role to be toggled. */
    role?: InputMaybe<Role>
    /** The user guid. */
    userGuid?: InputMaybe<Scalars['String']['input']>
}

export type ToggleIsClosedInput = {
    guid?: InputMaybe<Scalars['String']['input']>
}

export type ToggleRequestDeleteUserInput = {
    guid: Scalars['String']['input']
}

export type ToggleUserRoleInput = {
    guid: Scalars['String']['input']
    role: Scalars['String']['input']
}

export type UpdateAttendEventStateInput = {
    code: Scalars['String']['input']
    delete?: InputMaybe<Scalars['Boolean']['input']>
    email: Scalars['String']['input']
    /**  If there is a form configured and enabled on the event, fill out the form  */
    formResponse?: InputMaybe<Array<InputMaybe<EntityFormResponseInput>>>
    guid: Scalars['String']['input']
    state?: InputMaybe<Scalars['String']['input']>
}

export type UpdateQaPairInput = {
    answer?: InputMaybe<Scalars['String']['input']>
    feedback: Scalars['String']['input']
    qaPairUuid: Scalars['String']['input']
}

export type UpdateRevisionInput = {
    description?: InputMaybe<Scalars['String']['input']>
    guid?: InputMaybe<Scalars['String']['input']>
}

export type UserWidgetSettingsInput = {
    containerGuid: Scalars['String']['input']
    guid: Scalars['String']['input']
    settings?: InputMaybe<Array<InputMaybe<WidgetSettingInput>>>
}

export type VoteInput = {
    /** The guid of the entity to vote on. */
    guid: Scalars['String']['input']
    /** 1 for upvote, -1 for downvote, 0 for deleting. */
    score: Scalars['Int']['input']
}

export type VoteOnPollInput = {
    guid: Scalars['String']['input']
    response: Scalars['String']['input']
}

export type VotePayload = {
    __typename: 'votePayload'
    object: Entity
}

export type WidgetInput = {
    guid?: InputMaybe<Scalars['String']['input']>
    settings?: InputMaybe<Array<InputMaybe<WidgetSettingInput>>>
    type: Scalars['String']['input']
}
